msgid ""
msgstr ""
"POT-Creation-Date: 2026-08-19 11:56+0100\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. Table suffix: Margin type
#: packages/ui-kit/src/components/table/fields/margin/margin_field.tsx:32
msgid " ({marginType, select, cross {Cross} isolated {Iso.} other {Unknown}})"
msgstr " ({marginType, select, cross {Cross} isolated {Iso.} other {Unknown}})"

#. Table cell: None
#. Table cell: None
#. Table cell: None
#. Table cell: None
#. Table cell: None
#. Table cell: None
#: packages/ui-kit/src/feature/market_info/funding_history_popover.tsx:202
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:215
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:245
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:262
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:434
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:512
msgid "--"
msgstr "--"

#. Table Cell: Type
#. placeholder {0}: params.row.type
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:356
msgid "{0, select, limit {Limit} market {Market} stopLimit {Stop Limit} stopMarket {Stop Market} change {Change} other {}}"
msgstr "{0, select, limit {Limit} market {Market} stopLimit {Stop Limit} stopMarket {Stop Market} change {Change} other {}}"

#. Table cell: Long/short direction
#. placeholder {0}: params.row.side
#. placeholder {0}: props.side
#: packages/ui-kit/src/components/table/fields/direction/direction.tsx:27
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:271
#~ msgid "{0, select, long {Long} short {Short} other {}}"
#~ msgstr "{0, select, long {Long} short {Short} other {}}"

#. Flip dialog: side + size, e.g. 'Long 0.0018 BTC'
#. placeholder {0}: position.side
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:200
#~ msgid "{0, select, long {Long} short {Short} other {}} {positionSizeText} {ticker}"
#~ msgstr "{0, select, long {Long} short {Short} other {}} {positionSizeText} {ticker}"

#. Table cell: Open/close action
#. placeholder {0}: params.row.action
#. placeholder {0}: props.behavior
#: packages/ui-kit/src/components/table/fields/direction/direction.tsx:26
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:269
#~ msgid "{0, select, open {Open} close {Close} other {}}"
#~ msgstr "{0, select, open {Open} close {Close} other {}}"

#. Picture-in-picture order side label
#. Table cell: direction (Open/Close Long/Short)
#. Table cell: direction (Open/Close Long/Short)
#. placeholder {0}: order.action
#. placeholder {0}: params.row.action
#. placeholder {0}: props.behavior
#. placeholder {1}: order.side
#. placeholder {1}: params.row.side
#. placeholder {1}: props.side
#: apps/web/src/features/picture_in_picture/components/OrderRow.tsx:79
#: packages/ui-kit/src/components/table/fields/direction/direction.tsx:27
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:329
msgid "{0, select, open {Open} close {Close} other {}} {1, select, long {Long} short {Short} other {}}"
msgstr "{0, select, open {Open} close {Close} other {}} {1, select, long {Long} short {Short} other {}}"

#. Adjust margin: submit button label across pending / max-amount-error / invalid / ready states
#. placeholder {0}: isPending ? 'pending' : inputError.type === 'MAX_AMOUNT' ? 'max' : !isValid ? 'invalid' : 'ok'
#: apps/web/src/features/trading/adjust_margin_dialog/index.tsx:114
msgid "{0, select, pending {Confirming} max {Try lower amount} invalid {Choose amount of margin to add} other {Confirm}}"
msgstr "{0, select, pending {Confirming} max {Try lower amount} invalid {Choose amount of margin to add} other {Confirm}}"

#. Table cell: Open/close direction
#. placeholder {0}: String(params.row.isClose)
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:267
#~ msgid "{0, select, true {Close} other {Open}}"
#~ msgstr "{0, select, true {Close} other {Open}}"

#. Table cell: direction (Close/Open Long/Short)
#. placeholder {0}: String(params.row.isClose)
#. placeholder {1}: params.row.side
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:324
msgid "{0, select, true {Close} other {Open}} {1, select, long {Long} short {Short} other {}}"
msgstr "{0, select, true {Close} other {Open}} {1, select, long {Long} short {Short} other {}}"

#. Edit order dialog submit button
#. placeholder {0}: String(isPending)
#: apps/web/src/features/trading/edit_order_dialog/index.tsx:128
msgid "{0, select, true {Confirming…} other {Save changes}}"
msgstr "{0, select, true {Confirming…} other {Save changes}}"

#. Reduce only field in table
#. Table cell: Reduce Only
#. placeholder {0}: String(isReduceOnly)
#. placeholder {0}: String(params.row.reduceOnly)
#: packages/ui-kit/src/components/table/fields/reduce_only/reduce_only.tsx:7
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:495
msgid "{0, select, true {Yes} other {No}}"
msgstr "{0, select, true {Yes} other {No}}"

#. mPoints distribution card: how much of the epoch pool comes from the maker-volume boost
#: apps/web/src/features/mpoints/components/stat-cards/points-distribution-card.tsx:69
msgid "{added} mPoints added for maker volume."
msgstr "{added} mPoints added for maker volume."

#. Portfolio liquidation risk segment title
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:65
msgid "{asset} — {percent}% to liq."
msgstr "{asset} — {percent}% to liq."

#. Picture-in-picture order card expand button label
#: apps/web/src/features/picture_in_picture/components/OrderRow.tsx:69
msgid "{asset} order details"
msgstr "{asset} order details"

#. Picture-in-picture position card expand button label
#: apps/web/src/features/picture_in_picture/components/PositionRow.tsx:71
msgid "{asset} position details"
msgstr "{asset} position details"

#. Close dialog: resting limit close orders are cancelled before a limit close is posted
#: apps/web/src/features/account/close_position_dialog/SinglePositionContent.tsx:212
#~ msgid "{closeOrdersCount, plural, one {# resting reduce-only limit order on this position will be cancelled first, even if the close does not fill.} other {# resting reduce-only limit orders on this position will be cancelled first, even if the close does not fill.}}"
#~ msgstr "{closeOrdersCount, plural, one {# resting reduce-only limit order on this position will be cancelled first, even if the close does not fill.} other {# resting reduce-only limit orders on this position will be cancelled first, even if the close does not fill.}}"

#. Close dialog: resting limit close orders are cancelled after a market close settles
#: apps/web/src/features/account/close_position_dialog/SinglePositionContent.tsx:205
#~ msgid "{closeOrdersCount, plural, one {# resting reduce-only limit order on this position will be cancelled once the position closes.} other {# resting reduce-only limit orders on this position will be cancelled once the position closes.}}"
#~ msgstr "{closeOrdersCount, plural, one {# resting reduce-only limit order on this position will be cancelled once the position closes.} other {# resting reduce-only limit orders on this position will be cancelled once the position closes.}}"

#. Close dialog: resting limit close orders are cancelled by the flow
#: apps/web/src/features/account/close_position_dialog/SinglePositionContent.tsx:205
#~ msgid "{closeOrdersCount, plural, one {# resting reduce-only limit order on this position will be cancelled, even if the close does not fill.} other {# resting reduce-only limit orders on this position will be cancelled, even if the close does not fill.}}"
#~ msgstr "{closeOrdersCount, plural, one {# resting reduce-only limit order on this position will be cancelled, even if the close does not fill.} other {# resting reduce-only limit orders on this position will be cancelled, even if the close does not fill.}}"

#. Flip dialog: resting limit close orders are cancelled by the flow
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:243
#~ msgid "{closeOrdersCount, plural, one {# resting reduce-only limit order on this position will be cancelled, even if the flip does not fill.} other {# resting reduce-only limit orders on this position will be cancelled, even if the flip does not fill.}}"
#~ msgstr "{closeOrdersCount, plural, one {# resting reduce-only limit order on this position will be cancelled, even if the flip does not fill.} other {# resting reduce-only limit orders on this position will be cancelled, even if the flip does not fill.}}"

#. Flip dialog: resting limit close orders must be cancelled by the user (on-chain mode)
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:250
#~ msgid "{closeOrdersCount, plural, one {# resting reduce-only limit order on this position will be invalid after the flip — cancel it manually.} other {# resting reduce-only limit orders on this position will be invalid after the flip — cancel them manually.}}"
#~ msgstr "{closeOrdersCount, plural, one {# resting reduce-only limit order on this position will be invalid after the flip — cancel it manually.} other {# resting reduce-only limit orders on this position will be invalid after the flip — cancel them manually.}}"

#. Close dialog: resting limit close orders must be cancelled by the user (on-chain mode)
#: apps/web/src/features/account/close_position_dialog/SinglePositionContent.tsx:219
#~ msgid "{closeOrdersCount, plural, one {# resting reduce-only limit order on this position will be left over — cancel it manually.} other {# resting reduce-only limit orders on this position will be left over — cancel them manually.}}"
#~ msgstr "{closeOrdersCount, plural, one {# resting reduce-only limit order on this position will be left over — cancel it manually.} other {# resting reduce-only limit orders on this position will be left over — cancel them manually.}}"

#. Flip dialog: resting close orders are cancelled by the flow
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:243
#~ msgid "{closeOrdersCount, plural, one {# resting reduce-only order (TP/SL or limit close) on this position will be cancelled.} other {# resting reduce-only orders (TP/SL or limit closes) on this position will be cancelled.}}"
#~ msgstr "{closeOrdersCount, plural, one {# resting reduce-only order (TP/SL or limit close) on this position will be cancelled.} other {# resting reduce-only orders (TP/SL or limit closes) on this position will be cancelled.}}"

#. Flip dialog: resting close orders must be cancelled by the user (on-chain mode)
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:250
#~ msgid "{closeOrdersCount, plural, one {# resting reduce-only order (TP/SL or limit close) on this position will be invalid after the flip — cancel it manually.} other {# resting reduce-only orders (TP/SL or limit closes) on this position will be invalid after the flip — cancel them manually.}}"
#~ msgstr "{closeOrdersCount, plural, one {# resting reduce-only order (TP/SL or limit close) on this position will be invalid after the flip — cancel it manually.} other {# resting reduce-only orders (TP/SL or limit closes) on this position will be invalid after the flip — cancel them manually.}}"

#. Close dialog: resting limit close orders the user must cancel (on-chain mode)
#. Flip dialog: resting limit close orders the user must cancel (on-chain mode)
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:242
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:265
msgid "{closeOrdersCount, plural, one {# stays open — cancel it} other {# stay open — cancel them}}"
msgstr "{closeOrdersCount, plural, one {# stays open — cancel it} other {# stay open — cancel them}}"

#. Close dialog: resting limit close orders the flow cancels
#. Flip dialog: resting limit close orders the flow cancels
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:235
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:258
msgid "{closeOrdersCount, plural, one {# will be cancelled} other {# will be cancelled}}"
msgstr "{closeOrdersCount, plural, one {# will be cancelled} other {# will be cancelled}}"

#. Flip dialog: why the resting limit close orders are cancelled
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:234
msgid "{closeOrdersCount, plural, one {This position has # resting limit close order. After the flip it would sit on the opposite side and could no longer close the position, so it is cancelled before the order is sent — even if the flip does not fill.} other {This position has # resting limit close orders. After the flip they would sit on the opposite side and could no longer close the position, so they are cancelled before the order is sent — even if the flip does not fill.}}"
msgstr "{closeOrdersCount, plural, one {This position has # resting limit close order. After the flip it would sit on the opposite side and could no longer close the position, so it is cancelled before the order is sent — even if the flip does not fill.} other {This position has # resting limit close orders. After the flip they would sit on the opposite side and could no longer close the position, so they are cancelled before the order is sent — even if the flip does not fill.}}"

#. Flip dialog: why the resting limit close orders must be cancelled by the user (on-chain mode)
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:241
msgid "{closeOrdersCount, plural, one {This position has # resting limit close order. After the flip it would sit on the opposite side and could no longer close the position. Cancelling it needs its own transaction, so do it from the Open Orders tab.} other {This position has # resting limit close orders. After the flip they would sit on the opposite side and could no longer close the position. Cancelling them needs its own transaction, so do it from the Open Orders tab.}}"
msgstr "{closeOrdersCount, plural, one {This position has # resting limit close order. After the flip it would sit on the opposite side and could no longer close the position. Cancelling it needs its own transaction, so do it from the Open Orders tab.} other {This position has # resting limit close orders. After the flip they would sit on the opposite side and could no longer close the position. Cancelling them needs its own transaction, so do it from the Open Orders tab.}}"

#. Close dialog: why the resting limit close orders are cancelled after a market close settles
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:215
msgid "{closeOrdersCount, plural, one {This position has # resting limit close order. It is cancelled once the position is actually closed, so a market close that does not fill leaves it untouched.} other {This position has # resting limit close orders. They are cancelled once the position is actually closed, so a market close that does not fill leaves them untouched.}}"
msgstr "{closeOrdersCount, plural, one {This position has # resting limit close order. It is cancelled once the position is actually closed, so a market close that does not fill leaves it untouched.} other {This position has # resting limit close orders. They are cancelled once the position is actually closed, so a market close that does not fill leaves them untouched.}}"

#. Close dialog: why the resting limit close orders must be cancelled by the user (on-chain mode)
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:201
msgid "{closeOrdersCount, plural, one {This position has # resting limit close order. Once the position is closed it has nothing left to close, and it blocks new close orders until it is gone. Cancelling it needs its own transaction, so do it from the Open Orders tab.} other {This position has # resting limit close orders. Once the position is closed they have nothing left to close, and they block new close orders until they are gone. Cancelling them needs its own transaction, so do it from the Open Orders tab.}}"
msgstr "{closeOrdersCount, plural, one {This position has # resting limit close order. Once the position is closed it has nothing left to close, and it blocks new close orders until it is gone. Cancelling it needs its own transaction, so do it from the Open Orders tab.} other {This position has # resting limit close orders. Once the position is closed they have nothing left to close, and they block new close orders until they are gone. Cancelling them needs its own transaction, so do it from the Open Orders tab.}}"

#. Close dialog: why the resting limit close orders are cancelled before a limit close
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:208
msgid "{closeOrdersCount, plural, one {This position has # resting limit close order. The exchange will not accept a new limit close while it holds the position, so it is cancelled before the order is sent — even if the close does not fill.} other {This position has # resting limit close orders. The exchange will not accept a new limit close while they hold the position, so they are cancelled before the order is sent — even if the close does not fill.}}"
msgstr "{closeOrdersCount, plural, one {This position has # resting limit close order. The exchange will not accept a new limit close while it holds the position, so it is cancelled before the order is sent — even if the close does not fill.} other {This position has # resting limit close orders. The exchange will not accept a new limit close while they hold the position, so they are cancelled before the order is sent — even if the close does not fill.}}"

#. Trigger price Cell
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:522
msgid "{condition, select, above {Price above } below {Price below } other {}}"
msgstr "{condition, select, above {Price above } below {Price below } other {}}"

#. User limit orders above the visible ask range
#: packages/ui-kit/src/feature/order_book/offscreen_orders/offscreen_orders.tsx:20
msgid "{count, plural, one {# order above} other {# orders above}}"
msgstr "{count, plural, one {# order above} other {# orders above}}"

#. User limit orders below the visible bid range
#: packages/ui-kit/src/feature/order_book/offscreen_orders/offscreen_orders.tsx:26
msgid "{count, plural, one {# order below} other {# orders below}}"
msgstr "{count, plural, one {# order below} other {# orders below}}"

#. API key IP restriction count
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:143
msgid "{count, plural, one {# range} other {# ranges}}"
msgstr "{count, plural, one {# range} other {# ranges}}"

#. Toast after an on-chain close/flip: reduce-only limit orders the app could not cancel for the user. {count} is how many.
#: apps/web/src/features/account/utils/staleCloseOrders.ts:65
msgid "{count} reduce-only limit orders are no longer valid. Cancel them from the Open Orders tab."
msgstr "{count} reduce-only limit orders are no longer valid. Cancel them from the Open Orders tab."

#. CSV export: this table only exports bounded windows
#: packages/ui-kit/src/feature/terminal_tables/csv_export/ExportCsvDialog.tsx:216
msgid "{dayLimit, plural, one {Select a range of up to # day.} other {Select a range of up to # days.}}"
msgstr "{dayLimit, plural, one {Select a range of up to # day.} other {Select a range of up to # days.}}"

#: apps/web/src/features/tournament/hooks/useStandings.ts:47
msgid "{days, plural, one {# day} other {# days}}"
msgstr "{days, plural, one {# day} other {# days}}"

#. Tooltip on a referee address showing how long ago that person joined. Their gender is unknown, so if the past tense carries gender in your language, rewrite as a nominal phrase (e.g. "Joined: # days ago").
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:69
msgid "{days, plural, one {Joined # day ago} other {Joined # days ago}}"
msgstr "{days, plural, one {Joined # day ago} other {Joined # days ago}}"

#. Tooltip on expired volume pill — referral too old
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:179
msgid "{days, plural, one {Referral date ># day ago.} other {Referral date ># days ago.}}"
msgstr "{days, plural, one {Referral date ># day ago.} other {Referral date ># days ago.}}"

#. Tooltip on inactive volume pill — explains why slot was returned
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:160
msgid "{days, plural, one {User did not trade {amount} within # day.} other {User did not trade {amount} within # days.}}"
msgstr "{days, plural, one {User did not trade {amount} within # day.} other {User did not trade {amount} within # days.}}"

#. Funding heatmap tooltip: number of funding events in the 24h summary
#: apps/web/src/features/funding-map/HeatmapTooltip.tsx:72
msgid "{events, plural, one {# funding event} other {# funding events}}"
msgstr "{events, plural, one {# funding event} other {# funding events}}"

#. Flip dialog: order direction + size, e.g. 'Sell 0.0037 BTC'
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:165
msgid "{flipSide, select, long {Buy} short {Sell} other {}} {orderSizeText} {ticker}"
msgstr "{flipSide, select, long {Buy} short {Sell} other {}} {orderSizeText} {ticker}"

#. Flip dialog: side + size, e.g. 'Short 0.0018 BTC'
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:206
#~ msgid "{flipSide, select, long {Long} short {Short} other {}} {positionSizeText} {ticker}"
#~ msgstr "{flipSide, select, long {Long} short {Short} other {}} {positionSizeText} {ticker}"

#: apps/web/src/features/tournament/hooks/useStandings.ts:152
msgid "{gap} to the top 10"
msgstr "{gap} to the top 10"

#. Preferences: liquidation alert cooldown duration
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:302
msgid "{hours, plural, one {# hour} other {# hours}}"
msgstr "{hours, plural, one {# hour} other {# hours}}"

#. Funding heatmap: hours-ago tick
#: apps/web/src/features/funding-map/FundingHeatmap.tsx:52
msgid "{hoursAgo}h"
msgstr "{hoursAgo}h"

#. Mobile trade/order card: shown next to the coin, whether it opens or closes a position
#: packages/ui-kit/src/feature/terminal_tables/shared/open_close_mobile_card.tsx:15
msgid "{isClose, select, true {Close} other {Open}}"
msgstr "{isClose, select, true {Close} other {Open}}"

#. TIF menu item
#: packages/ui-kit/src/feature/order_entry/form/tif.tsx:65
msgid "{item, select, gtc {Good ’Til Cancel} immediateOrCancel {Immediate Or Cancel} fillOrKill {Fill Or Kill} postOnly {Post Only} other {}}"
msgstr "{item, select, gtc {Good ’Til Cancel} immediateOrCancel {Immediate Or Cancel} fillOrKill {Fill Or Kill} postOnly {Post Only} other {}}"

#: apps/web/src/features/tournament/components/finalising-dialog.tsx:163
msgid "{label} Competition:"
msgstr "{label} Competition:"

#. Connection status tooltip line; the number is a block count
#: packages/ui-kit/src/common/heartbeatStore.ts:49
msgid "{lag, plural, one {Account data # block behind} other {Account data # blocks behind}}"
msgstr "{lag, plural, one {Account data # block behind} other {Account data # blocks behind}}"

#. Footer connection status; the number is a block count
#: packages/ui-kit/src/common/heartbeatStore.ts:27
msgid "{lag, plural, one {Indexing (# block behind)} other {Indexing (# blocks behind)}}"
msgstr "{lag, plural, one {Indexing (# block behind)} other {Indexing (# blocks behind)}}"

#. Connection status tooltip line; the number is a block count
#: packages/ui-kit/src/common/heartbeatStore.ts:43
msgid "{lag, plural, one {Market data # block behind} other {Market data # blocks behind}}"
msgstr "{lag, plural, one {Market data # block behind} other {Market data # blocks behind}}"

#. Market order fill prognosis: how many book levels the fill spans
#: packages/ui-kit/src/feature/order_entry/form/market_fill_prognosis.tsx:173
msgid "{levels, plural, one {Fills within 1 book level.} other {Fills across # book levels.}}"
msgstr "{levels, plural, one {Fills within 1 book level.} other {Fills across # book levels.}}"

#. Market order fill prognosis: slippage value percent
#: packages/ui-kit/src/feature/order_entry/form/market_fill_prognosis.tsx:129
msgid "{limit}%"
msgstr "{limit}%"

#. Builder Traders tile: markets traded through the code
#: apps/web/src/features/builders/builderDashboard.tsx:94
msgid "{markets, plural, one {# market} other {# markets}}"
msgstr "{markets, plural, one {# market} other {# markets}}"

#. Preferences: liquidation alert cooldown duration
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:296
msgid "{minutes, plural, one {# minute} other {# minutes}}"
msgstr "{minutes, plural, one {# minute} other {# minutes}}"

#. Boosted market stats panel chip label
#: packages/ui-kit/src/feature/market_info/boost_chip.tsx:90
#~ msgid "{multiplier}x Points Boost"
#~ msgstr "{multiplier}x Points Boost"

#. Origins tier label; {name} is the badge name, e.g. Gold
#: apps/web/src/utils/badge.ts:20
msgid "{name} Tier"
msgstr "{name} Tier"

#: apps/web/src/features/tournament/components/finalising-dialog.tsx:110
msgid "{name} Tournament"
msgstr "{name} Tournament"

#: apps/web/src/features/tournament/components/finalising-dialog.tsx:120
msgid "{name} tournament is over"
msgstr "{name} tournament is over"

#. Table cell: Order ID
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:536
msgid "{orderId}"
msgstr "{orderId}"

#. Picture-in-picture order type
#: apps/web/src/features/picture_in_picture/components/OrderRow.tsx:85
msgid "{orderType, select, limit {Limit} market {Market} stopLimit {Stop} stopMarket {Stop} change {Change} other {}}"
msgstr "{orderType, select, limit {Limit} market {Market} stopLimit {Stop} stopMarket {Stop} change {Change} other {}}"

#. Stop order type
#: packages/ui-kit/src/feature/order_entry/form/order_type_bar.tsx:199
msgid "{orderType, select, stopLimit {Stop} stopMarket {Stop} other {Stop}}"
msgstr "{orderType, select, stopLimit {Stop} stopMarket {Stop} other {Stop}}"

#. Flip dialog: what a partial fill leaves behind (completes 'The rest would be cancelled, leaving you …')
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:33
msgid "{outcome, select, reduced {with a smaller position on your current side} flat {flat, without opening the opposite side} partialFlip {flipped, but with a smaller position than you have now} other {}}"
msgstr "{outcome, select, reduced {with a smaller position on your current side} flat {flat, without opening the opposite side} partialFlip {flipped, but with a smaller position than you have now} other {}}"

#. Builder fees tile: amount transferred so far
#: apps/web/src/features/builders/builderDashboard.tsx:79
msgid "{paidOut} paid out"
msgstr "{paidOut} paid out"

#. Builder fees tile: amount transferred so far and amount from closed epochs not transferred yet
#: apps/web/src/features/builders/builderDashboard.tsx:74
msgid "{paidOut} paid out · {awaiting} awaiting"
msgstr "{paidOut} paid out · {awaiting} awaiting"

#. Preferences: liquidation alert threshold option
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:279
msgid "{percent}% of the way to liquidation"
msgstr "{percent}% of the way to liquidation"

#: packages/ui-kit/src/components/table/fields/pnl/pnl.tsx:37
msgid "{pnl} ({roe})"
msgstr "{pnl} ({roe})"

#: apps/web/src/features/tournament/hooks/useStandings.ts:135
msgid "{prize} projected prize"
msgstr "{prize} projected prize"

#. CSV export progress: rows collected so far
#: packages/ui-kit/src/feature/terminal_tables/csv_export/ExportCsvDialog.tsx:171
msgid "{rowCount, plural, one {# row found} other {# rows found}}"
msgstr "{rowCount, plural, one {# row found} other {# rows found}}"

#. Trade console button label
#: packages/ui-kit/src/feature/order_entry/form/forms_action_buttons.tsx:55
msgid "{side, select, long {Long {symbol}} short {Short {symbol}} other {{symbol}}}"
msgstr "{side, select, long {Long {symbol}} short {Short {symbol}} other {{symbol}}}"

#. Picture-in-picture position side leverage
#: apps/web/src/features/picture_in_picture/components/PositionRow.tsx:84
msgid "{side, select, long {Long} short {Short} other {}} {leverage}x"
msgstr "{side, select, long {Long} short {Short} other {}} {leverage}x"

#. Flip dialog: position side + size, e.g. 'Long 0.0018 BTC'
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:47
msgid "{side, select, long {Long} short {Short} other {}} {sizeText} {ticker}"
msgstr "{side, select, long {Long} short {Short} other {}} {sizeText} {ticker}"

#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/tp_sl_modal.tsx:157
msgid "{size} {baseCurrency}"
msgstr "{size} {baseCurrency}"

#: apps/web/src/features/tournament/components/competition-card.tsx:103
msgid "{start} – {end}"
msgstr "{start} – {end}"

#. Status field cell values
#: packages/ui-kit/src/components/table/fields/status/status.tsx:34
msgid "{status, select, unspecified {Unspecified} pending {Pending} open {Open} partial {Partially Filled} filled {Filled} canceled {Canceled} expired {Expired} failed {Failed} triggered {Triggered} untriggered {Untriggered} executed {Executed} liquidation {Liquidation} other {Unknown}}"
msgstr "{status, select, unspecified {Unspecified} pending {Pending} open {Open} partial {Partially Filled} filled {Filled} canceled {Canceled} expired {Expired} failed {Failed} triggered {Triggered} untriggered {Untriggered} executed {Executed} liquidation {Liquidation} other {Unknown}}"

#: packages/ui-kit/src/components/table/fields/tp_sl/tp_sl.tsx:48
msgid "{tp} / {sl}"
msgstr "{tp} / {sl}"

#. Builder Traders tile: trades through the code
#: apps/web/src/features/builders/builderDashboard.tsx:88
msgid "{trades, plural, one {# trade} other {# trades}}"
msgstr "{trades, plural, one {# trade} other {# trades}}"

#. Table footer row count while a filter hides rows, e.g. "3 of 7"
#: packages/ui-kit/src/feature/terminal_tables/shared/MarketColumnFilter.tsx:159
msgid "{visible} of {total}"
msgstr "{visible} of {total}"

#: apps/web/src/features/tournament/hooks/useStandings.ts:128
msgid "#{below} is only {gap} behind you"
msgstr "#{below} is only {gap} behind you"

#. Builder Volume tile: the code's rank and share of all builder volume
#: apps/web/src/features/builders/builderDashboard.tsx:144
msgid "#{rank} by volume · {share} of builder volume"
msgstr "#{rank} by volume · {share} of builder volume"

#. Take profit gain percent input label
#: packages/ui-kit/src/feature/order_entry/form/tp_sl.tsx:143
msgid "% Gain"
msgstr "% Gain"

#. Stop loss loss percent input label
#: packages/ui-kit/src/feature/order_entry/form/tp_sl.tsx:144
msgid "% Loss"
msgstr "% Loss"

#. Referral history volume badge — under min volume threshold
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:145
msgid "< {amount}"
msgstr "< {amount}"

#. Rewards structure fee share cell: 1st-level plus 2nd-level share
#: apps/web/src/features/referral/components/partner/rewards-structure-dialog.tsx:103
msgid "<0/> + <1/>"
msgstr "<0/> + <1/>"

#. Partner hero summary of the rewards the locked tier currently earns
#: apps/web/src/features/referral/components/partner/partner-hero-card.tsx:232
msgid "<0>Current Rewards:</0> Points <1/> • Fee share <2/> + <3/>."
msgstr "<0>Current Rewards:</0> Points <1/> • Fee share <2/> + <3/>."

#. Adjust margin dialog: tooltip threshold legend, risky band
#: apps/web/src/features/trading/adjust_margin_dialog/MarginInfoRows.tsx:101
msgid "<2% = Risky"
msgstr "<2% = Risky"

#. Adjust margin dialog: tooltip threshold legend, safe band
#: apps/web/src/features/trading/adjust_margin_dialog/MarginInfoRows.tsx:104
msgid ">10% = Safe(ish)"
msgstr ">10% = Safe(ish)"

#. Market order fill prognosis: avg fill value with impact
#: packages/ui-kit/src/feature/order_entry/form/market_fill_prognosis.tsx:119
msgid "≈ {price} ({impact})"
msgstr "≈ {price} ({impact})"

#. Leaderboard rank cell marker on the current user row; keep the pointing hand
#: apps/web/src/features/leaderboard/components/ranking/useLeaderboardColumns.tsx:75
msgid "☜ You"
msgstr "☜ You"

#. Filter: 1 Month
#. Filter: 1 Month
#: apps/web/src/features/builders/components/BuildersCard.tsx:123
#: apps/web/src/features/leaderboard/components/LeaderboardCard.tsx:138
msgid "1 Month"
msgstr "1 Month"

#. Filter: 1 Week
#. Filter: 1 Week
#: apps/web/src/features/builders/components/BuildersCard.tsx:121
#: apps/web/src/features/leaderboard/components/LeaderboardCard.tsx:136
msgid "1 Week"
msgstr "1 Week"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:40
msgid "1 year"
msgstr "1 year"

#. Portfolio account overview label
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:255
msgid "10% Stress Test"
msgstr "10% Stress Test"

#. Portfolio chart period: last 14 days
#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:132
msgid "14D"
msgstr "14D"

#. Fee table column: 14-day volume (compact)
#: apps/web/src/components/header/user_account_menu/fees_panel.tsx:142
msgid "14D Vol"
msgstr "14D Vol"

#: packages/ui-kit/src/components/dialogs/fee_tiers_dialog.tsx:144
msgid "14D Volume"
msgstr "14D Volume"

#: apps/web/src/components/summer-banner/summer-banner.tsx:65
msgid "16 weeks · paid at season end · trade and refer to claim your share"
msgstr "16 weeks · paid at season end · trade and refer to claim your share"

#. Filter: 2 Weeks
#. Filter: 2 Weeks
#: apps/web/src/features/builders/components/BuildersCard.tsx:122
#: apps/web/src/features/leaderboard/components/LeaderboardCard.tsx:137
msgid "2 Weeks"
msgstr "2 Weeks"

#. Portfolio chart period: last 24 hours
#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:130
msgid "24H"
msgstr "24H"

#. Funding heatmap: leftmost time label
#: apps/web/src/features/funding-map/FundingHeatmap.tsx:50
msgid "24h ago"
msgstr "24h ago"

#. Funding heatmap: header of the 24h annualised average column
#: apps/web/src/features/funding-map/FundingHeatmap.tsx:131
msgid "24h APR"
msgstr "24h APR"

#. Coin info 24h change
#: packages/ui-kit/src/feature/market_info/coin_info/market_metrics.tsx:126
msgid "24h Change"
msgstr "24h Change"

#. Market info table 24h change
#: packages/ui-kit/src/feature/market_info/market_menu/market_menu_table.tsx:274
msgid "24H Change"
msgstr "24H Change"

#. Coin info 24h volume
#. Dashboard KPI: 24h notional volume
#: apps/web/src/features/dashboard/dashboard.tsx:128
#: packages/ui-kit/src/feature/market_info/coin_info/market_metrics.tsx:129
msgid "24h Volume"
msgstr "24h Volume"

#. Boosted market points multiplier tooltip
#: packages/ui-kit/src/feature/market_info/boost_chip.tsx:37
#~ msgid "2x points"
#~ msgstr "2x points"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:38
msgid "30 days"
msgstr "30 days"

#. Dashboard KPI change over 30 days
#. Dashboard chart range: last 30 days
#. Portfolio chart period: last 30 days
#: apps/web/src/features/dashboard/dashboardLabels.ts:5
#: apps/web/src/features/dashboard/dashboardLabels.ts:9
#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:133
msgid "30D"
msgstr "30D"

#. Partner current referred volume label
#. Rewards structure column header
#: apps/web/src/features/referral/components/partner/partner-stats.tsx:155
#: apps/web/src/features/referral/components/partner/rewards-structure-dialog.tsx:56
msgid "30D Referred Volume"
msgstr "30D Referred Volume"

#. Leaderboard monthly volume row
#: apps/web/src/components/header/rewards_menu/panels.tsx:312
msgid "30d volume"
msgstr "30d volume"

#. Portfolio account overview label
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:246
msgid "5% Stress Test"
msgstr "5% Stress Test"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:37
msgid "7 days"
msgstr "7 days"

#. Dashboard KPI change over 7 days
#. Dashboard chart range: last 7 days
#. Portfolio chart period: last 7 days
#: apps/web/src/features/dashboard/dashboardLabels.ts:4
#: apps/web/src/features/dashboard/dashboardLabels.ts:8
#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:131
msgid "7D"
msgstr "7D"

#. Dashboard KPI: transactions in the last 7 days, millions
#: apps/web/src/features/dashboard/dashboard.tsx:191
msgid "7d Transactions"
msgstr "7d Transactions"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:39
msgid "90 days"
msgstr "90 days"

#. Dashboard chart range: last 90 days
#: apps/web/src/features/dashboard/dashboardLabels.ts:6
msgid "90D"
msgstr "90D"

#: apps/web/src/features/auth/components/geo_block_dialog.tsx:40
#: apps/web/src/features/auth/components/terms_dialog.tsx:66
msgid "Accept"
msgstr "Accept"

#: apps/web/src/features/auth/components/access_steps.tsx:66
msgid "Access Code"
msgstr "Access Code"

#. Portfolio chart empty state title: restricted or geo-blocked
#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:86
msgid "Access restricted"
msgstr "Access restricted"

#. Restricted wallet button
#: apps/web/src/features/account/hooks/useDepositButtonText.ts:17
#: apps/web/src/features/auth/components/access_request_dialog.tsx:149
msgid "Access Restricted"
msgstr "Access Restricted"

#. Mobile trade tab: account overview
#. Portfolio account overview heading
#. Portfolio chart: account equity
#: apps/web/src/components/dialogs/AccountDialog.tsx:24
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:135
#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:125
#: apps/web/src/features/terminal/mobile/mobile_trading_layout.tsx:50
msgid "Account"
msgstr "Account"

#. Connection status tooltip line; {lag} is a block count
#: packages/ui-kit/src/common/heartbeatStore.ts:35
#~ msgid "Account data {lag} blocks behind"
#~ msgstr "Account data {lag} blocks behind"

#. Tab title: Account History
#. Tab title: Account History
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:263
#: packages/ui-kit/src/feature/terminal_tables/account_history/account_history.tsx:66
msgid "Account History"
msgstr "Account History"

#. Account tab render error
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:318
msgid "Account History failed to render."
msgstr "Account History failed to render."

#. Portfolio account overview label
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:226
msgid "Account Leverage"
msgstr "Account Leverage"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:45
msgid "Account not found."
msgstr "Account not found."

#. Preferences: trading panel toggle
#: apps/web/src/components/header/user_settings/preferences-drawer/terminal_panels_section.tsx:19
msgid "Account Status"
msgstr "Account Status"

#. Account value label in account menu
#: apps/web/src/components/header/user_account_menu/account_balance_summary.tsx:121
msgid "Account value"
msgstr "Account value"

#. Account panel row label
#: apps/web/src/features/account/account_status.tsx:49
msgid "Account Value"
msgstr "Account Value"

#. P&L history tooltip: negative funding charged to the account balance on increase
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:113
msgid "Accrued funding debt {amount} was deducted from the account balance"
msgstr "Accrued funding debt {amount} was deducted from the account balance"

#. P&L history tooltip: positive funding materialized into position margin on increase
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:109
msgid "Accrued funding payout {amount} was added to the position margin"
msgstr "Accrued funding payout {amount} was added to the position margin"

#. Builder payout live status tooltip
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:58
msgid "Accruing now. Final when the epoch closes."
msgstr "Accruing now. Final when the epoch closes."

#. API key table column
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:177
msgid "Actions"
msgstr "Actions"

#. Referees filter option
#: apps/web/src/features/referral/components/referrals-history/referrals-history.tsx:48
msgid "Active"
msgstr "Active"

#. Builder code status: live
#: apps/web/src/features/builders/builderDashboard.tsx:46
msgctxt "builder code status"
msgid "Active"
msgstr "Active"

#. Referrals active referees row
#: apps/web/src/components/header/rewards_menu/panels.tsx:278
msgid "Active referees"
msgstr "Active referees"

#. Account history operation
#. P&L history event label: collateral added
#: packages/ui-kit/src/feature/terminal_tables/account_history/constants.ts:25
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:52
msgid "Add Collateral"
msgstr "Add Collateral"

#. Favorites bar empty state
#: apps/web/src/features/markets/favorites_bar.tsx:17
msgid "Add favorites here from the market dropdown"
msgstr "Add favorites here from the market dropdown"

#. Fund account menu deposit description
#: apps/web/src/components/header/fund_account_menu/index.tsx:148
msgid "Add funds to your account"
msgstr "Add funds to your account"

#. Memo cell empty placeholder
#: apps/web/src/features/referral/components/referrals-history/memo-cell.tsx:161
msgid "Add memo"
msgstr "Add memo"

#. Button opening the add referral code dialog
#: apps/web/src/features/referral/components/referred-by.tsx:59
msgid "Add referral code"
msgstr "Add referral code"

#. Add referral code dialog title
#: apps/web/src/features/referral/components/referred-by.tsx:139
msgid "Add Referral Code"
msgstr "Add Referral Code"

#. Picture-in-picture add TP/SL button
#. Take profit and stop loss enable checkbox label
#: apps/web/src/features/picture_in_picture/components/PositionRow.tsx:186
#: packages/ui-kit/src/feature/order_entry/form/tp_sl.tsx:71
msgid "Add TP / SL"
msgstr "Add TP / SL"

#. Leaderboard column header: wallet address
#: apps/web/src/features/auth/components/access_steps.tsx:88
#: apps/web/src/features/leaderboard/components/ranking/useLeaderboardColumns.tsx:104
msgid "Address"
msgstr "Address"

#. Modal title for the dialog of Adjust Leverage
#: packages/ui-kit/src/feature/order_entry/form/account_leverage.tsx:132
msgid "Adjust Leverage"
msgstr "Adjust Leverage"

#. Positions table: adjust margin icon button
#. Positions table: adjust margin icon button
#: packages/ui-kit/src/components/table/fields/margin/margin_field.tsx:43
#: packages/ui-kit/src/feature/terminal_tables/position/positions_columns.tsx:172
msgid "Adjust margin"
msgstr "Adjust margin"

#. Adjust margin dialog: title including the trading pair
#: apps/web/src/features/trading/adjust_margin_dialog/index.tsx:99
msgid "Adjust Margin for {pair}"
msgstr "Adjust Margin for {pair}"

#: packages/ui-kit/src/components/dialogs/slippage_dialog.tsx:56
msgid "Adjust Max Slippage"
msgstr "Adjust Max Slippage"

#. Modal Title of Adjust TP/SL
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/tp_sl_modal.tsx:135
msgid "Adjust TP/SL Levels"
msgstr "Adjust TP/SL Levels"

#. Preferences: liquidation alert threshold select
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:196
msgid "Alert at"
msgstr "Alert at"

#. Preferences: liquidation alert cooldown select
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:197
msgid "Alert cooldown"
msgstr "Alert cooldown"

#. Builder payout filter: every status
#. Custom filter: All
#. Custom filter: All
#. Custom filter: All
#. Custom filter: All
#. Market info all categories
#. Market info all categories
#. Referees filter option
#. Rewards filter option
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:226
#: apps/web/src/features/referral/components/referrals-history/referrals-history.tsx:43
#: apps/web/src/features/referral/components/referrals-history/referrals-history.tsx:74
#: packages/ui-kit/src/feature/market_info/market_menu/category_filter.tsx:30
#: packages/ui-kit/src/feature/market_info/market_menu/market_menu_sheet.tsx:98
#: packages/ui-kit/src/feature/terminal_tables/account_history/useFilterOptions.tsx:16
#: packages/ui-kit/src/feature/terminal_tables/shared/getSideFilterOptions.tsx:6
#: packages/ui-kit/src/feature/terminal_tables/shared/getSideFilterOptions.tsx:10
#: packages/ui-kit/src/feature/terminal_tables/shared/getSideFilterOptions.tsx:16
msgid "All"
msgstr "All"

#. Dashboard chart range: the whole history
#. Portfolio chart period: the whole history. Sits in a toggle beside 24H / 7D / 14D / 30D, so it means "all time", not "all items" — several languages need a different word than the one used for a filter that shows every row.
#: apps/web/src/features/dashboard/dashboardLabels.ts:7
#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:136
msgctxt "time range"
msgid "All"
msgstr "All"

#. Leverage button tooltip: margin mode restriction
#: packages/ui-kit/src/feature/order_entry/form/order_type_bar.tsx:214
msgid "All positions are currently Isolated only."
msgstr "All positions are currently Isolated only."

#. Alert title: all positions isolated
#: packages/ui-kit/src/feature/order_entry/form/account_leverage.tsx:179
msgid "All positions are isolated only."
msgstr "All positions are isolated only."

#. Connection status tooltip line
#: packages/ui-kit/src/common/heartbeatStore.ts:39
msgid "All systems operational"
msgstr "All systems operational"

#. Filter: All Time
#. Filter: All Time
#. Filter: All Time
#. Partner all-time stats heading
#: apps/web/src/features/builders/components/BuildersCard.tsx:119
#: apps/web/src/features/leaderboard/components/LeaderboardCard.tsx:134
#: apps/web/src/features/referral/components/partner/partner-stats.tsx:164
#: packages/ui-kit/src/components/table/filter/date_range.tsx:105
msgid "All Time"
msgstr "All Time"

#. Portfolio stat label
#: apps/web/src/features/portfolio/components/StatCards.tsx:40
msgid "All Time P&L"
msgstr "All Time P&L"

#. Portfolio stat label
#: apps/web/src/features/portfolio/components/StatCards.tsx:31
msgid "All Time Volume"
msgstr "All Time Volume"

#. Dashboard KPI: cumulative trading fees
#: apps/web/src/features/dashboard/dashboard.tsx:181
msgid "All-Time Fees"
msgstr "All-Time Fees"

#. Leaderboard all-time rank row
#: apps/web/src/components/header/rewards_menu/panels.tsx:329
msgid "All-time rank"
msgstr "All-time rank"

#. Dashboard KPI: cumulative volume
#: apps/web/src/features/dashboard/dashboard.tsx:165
msgid "All-Time Volume"
msgstr "All-Time Volume"

#. Builder dashboard Volume tooltip
#: apps/web/src/features/builders/builderDashboard.tsx:140
msgid "All-time volume through your code, and its rank and share among all builders."
msgstr "All-time volume through your code, and its rank and share among all builders."

#. Table header: Amount
#. Token amount input label
#: packages/ui-kit/src/components/input_field/token_input_field.tsx:39
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:109
msgid "Amount"
msgstr "Amount"

#. Account panel tooltip: available balance
#: apps/web/src/features/account/account_status.tsx:58
msgid "Amount available to open and maintain positions, or withdraw"
msgstr "Amount available to open and maintain positions, or withdraw"

#: apps/web/src/hooks/useTokenAmountValidation.ts:53
msgid "Amount exceeds your collateral balance."
msgstr "Amount exceeds your collateral balance."

#: apps/web/src/features/account/components/deposit_panel.tsx:81
msgid "Amount exceeds your deposit limit."
msgstr "Amount exceeds your deposit limit."

#: apps/web/src/hooks/useTokenAmountValidation.ts:53
msgid "Amount exceeds your wallet balance."
msgstr "Amount exceeds your wallet balance."

#: apps/web/src/hooks/useTokenAmountValidation.ts:46
msgid "Amount must be at least {formattedMinAmount} {tokenSymbol}."
msgstr "Amount must be at least {formattedMinAmount} {tokenSymbol}."

#. An onchain price provided by Chainlink, used to calculate margin requirements and trigger liquidations.
#: packages/ui-kit/src/feature/market_info/coin_info/market_metrics.tsx:120
msgid "An onchain price provided by Chainlink, used to calculate margin requirements and trigger liquidations."
msgstr "An onchain price provided by Chainlink, used to calculate margin requirements and trigger liquidations."

#. Dashboard page title
#: apps/web/src/features/dashboard/dashboard.tsx:95
msgid "Analytics Dashboard"
msgstr "Analytics Dashboard"

#. Funding rates page: heatmap card subtitle
#: apps/web/src/features/funding-map/FundingHeatmapCard.tsx:116
#~ msgid "Annualised funding for every Perpl market, hour by hour. Persistent colour is carry worth having; noise that flips every few hours is not."
#~ msgstr "Annualised funding for every Perpl market, hour by hour. Persistent colour is carry worth having; noise that flips every few hours is not."

#: apps/web/src/features/funding-map/HeatmapTooltip.tsx:156
#: packages/ui-kit/src/feature/market_info/annualized_funding_tooltip.tsx:21
msgid "Annualized: {rate}%"
msgstr "Annualized: {rate}%"

#. Revoke API key confirmation body
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:34
msgid "Any client using key {key} will immediately lose access. This cannot be undone."
msgstr "Any client using key {key} will immediately lose access. This cannot be undone."

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:220
msgid "API key"
msgstr "API key"

#. API key copied toast
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:74
#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:222
msgid "API key copied"
msgstr "API key copied"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:211
msgid "API key created"
msgstr "API key created"

#. API key revoked toast
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:42
msgid "API key revoked"
msgstr "API key revoked"

#. API keys page title
#. Header nav item
#: apps/web/src/components/header/constants.ts:138
#: apps/web/src/features/api-keys/api-keys.tsx:29
msgid "API Keys"
msgstr "API Keys"

#: apps/web/src/features/builders/builderDashboard.tsx:264
#: apps/web/src/features/builders/builders.tsx:61
msgid "Apply to become a builder."
msgstr "Apply to become a builder."

#: apps/web/src/features/account/oneclick_dialog.tsx:44
msgid "Approve one-click trading to enjoy a smoother trading experience."
msgstr "Approve one-click trading to enjoy a smoother trading experience."

#. Tools menu builder codes description
#: apps/web/src/components/header/tools_menu/config.tsx:36
msgid "Apps and bots built on Perpl"
msgstr "Apps and bots built on Perpl"

#. Market depth chart: ask side
#. Market depth chart: ask side
#: apps/web/src/features/order_book/market_depth/MarketDepthPanel.tsx:21
#: apps/web/src/features/order_book/market_depth/MarketDepthToolbar.tsx:26
msgid "Asks"
msgstr "Asks"

#. Alert body: liquidation explanation with adverse-move percent
#. placeholder {0}: adverseMovePercent ?? '—'
#: packages/ui-kit/src/feature/order_entry/form/account_leverage.tsx:189
msgid "At <0>{modalLeverage}x</0> on this market, a ~<1>{0}%</1> move against you triggers liquidation."
msgstr "At <0>{modalLeverage}x</0> on this market, a ~<1>{0}%</1> move against you triggers liquidation."

#. Available balance row
#. Available to trade label, short form for mobile
#. PiP available balance label
#: apps/web/src/components/header/user_account_menu/account_balance_summary.tsx:180
#: apps/web/src/features/picture_in_picture/components/PipBalanceFooter.tsx:17
#: packages/ui-kit/src/feature/order_entry/form/account_leverage.tsx:56
msgid "Available"
msgstr "Available"

#. placeholder {0}: token.symbol
#: apps/web/src/features/account/components/account_panel.tsx:147
msgid "Available ({0})"
msgstr "Available ({0})"

#. Account panel row label
#: apps/web/src/features/account/account_status.tsx:57
msgid "Available Balance"
msgstr "Available Balance"

#. Renew cooldown tooltip
#: apps/web/src/features/referral/hooks/useRefCodeRenewal.ts:77
msgid "Available in {time}"
msgstr "Available in {time}"

#. Available to trade label
#: packages/ui-kit/src/feature/order_entry/form/account_leverage.tsx:53
msgid "Available to trade"
msgstr "Available to trade"

#: packages/ui-kit/src/components/input_field/token_input_field.tsx:62
msgid "Available: <0>{formattedMaxAmount}</0> {tokenSymbol}"
msgstr "Available: <0>{formattedMaxAmount}</0> {tokenSymbol}"

#. Dashboard chart: Perpl average TPS last 24 hours
#: apps/web/src/features/dashboard/dashboardLabels.ts:31
msgid "Average TPS (24h)"
msgstr "Average TPS (24h)"

#. Market making table: tooltip on the average fill column headers
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:76
msgid "Average volume per fill"
msgstr "Average volume per fill"

#. Market order fill prognosis: avg fill label
#: packages/ui-kit/src/feature/order_entry/form/market_fill_prognosis.tsx:195
msgid "Avg fill"
msgstr "Avg fill"

#. Market making table header
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:119
msgid "Avg Fill"
msgstr "Avg Fill"

#. Market making table header
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:117
msgid "Avg Maker Fill"
msgstr "Avg Maker Fill"

#. Market making table header
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:118
msgid "Avg Taker Fill"
msgstr "Avg Taker Fill"

#. Dashboard KPI: average transactions per second, last 24h
#: apps/web/src/features/dashboard/dashboard.tsx:185
msgid "Avg TPS (24h)"
msgstr "Avg TPS (24h)"

#. Order book hover range average price
#: packages/ui-kit/src/feature/order_book/hover_popover/hover_popover.tsx:133
msgid "Avg. Price"
msgstr "Avg. Price"

#. Builder payout status: epoch closed, transfer not seen yet
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:42
msgid "Awaiting transfer"
msgstr "Awaiting transfer"

#. Back to the account menu overview
#: apps/web/src/components/header/user_account_menu/index.tsx:114
msgid "Back"
msgstr "Back"

#. CSV export progress: the date the history has been read back to so far
#: packages/ui-kit/src/feature/terminal_tables/csv_export/ExportCsvDialog.tsx:180
msgid "back to {reached}"
msgstr "back to {reached}"

#. Table header: Balance
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:110
msgid "Balance"
msgstr "Balance"

#. Market depth chart: bid side
#. Market depth chart: bid side
#: apps/web/src/features/order_book/market_depth/MarketDepthPanel.tsx:20
#: apps/web/src/features/order_book/market_depth/MarketDepthToolbar.tsx:25
msgid "Bids"
msgstr "Bids"

#. Limit order tab tooltip: maker-volume mPoints boost campaign
#: packages/ui-kit/src/feature/order_entry/form/order_type_bar.tsx:187
msgid "Bonus mPoints for adding liquidity"
msgstr "Bonus mPoints for adding liquidity"

#. Boosted market chip label
#: packages/ui-kit/src/feature/market_info/boost_chip.tsx:72
msgid "Boost"
msgstr "Boost"

#. Preferences: toast position
#: apps/web/src/components/header/user_settings/preferences-drawer/notification_preference_section.tsx:35
msgid "Bottom Right"
msgstr "Bottom Right"

#. Funding rates table: Funding Cap / Floor column header tooltip
#: apps/web/src/features/funding_rates/funding_rates.tsx:170
msgid "Bounds the exchange contract enforces on every funding event of this market."
msgstr "Bounds the exchange contract enforces on every funding event of this market."

#. Button opening the bridge checkout
#. Button opening the bridge checkout
#. Fund account menu bridge label
#: apps/web/src/components/header/fund_account_menu/index.tsx:183
#: apps/web/src/providers/fun_bridge/fun_bridge.tsx:64
#: apps/web/src/providers/fun_bridge/fun_bridge.tsx:88
msgid "Bridge"
msgstr "Bridge"

#: apps/web/src/features/account/components/deposit_panel.tsx:178
msgid "Bridge AUSD"
msgstr "Bridge AUSD"

#. API key table column
#. Builders leaderboard column header: builder name and code
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:102
#: apps/web/src/features/builders/components/useBuilderColumns.tsx:38
msgid "Builder"
msgstr "Builder"

#. Header nav item
#: apps/web/src/components/header/constants.ts:130
#: apps/web/src/features/builders/builders.tsx:37
msgid "Builder Codes"
msgstr "Builder Codes"

#. Builder dashboard page title
#: apps/web/src/features/builders/builderDashboard.tsx:289
msgid "Builder Dashboard"
msgstr "Builder Dashboard"

#. Builder dashboard load error
#: apps/web/src/features/builders/builderDashboard.tsx:244
msgid "Builder data is temporarily unavailable. Retrying shortly."
msgstr "Builder data is temporarily unavailable. Retrying shortly."

#. Builder payout history column header: gross builder fees
#. Builders leaderboard column header
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:158
#: apps/web/src/features/builders/components/BuilderTotals.tsx:42
#: apps/web/src/features/builders/components/useBuilderColumns.tsx:94
msgid "Builder Fees"
msgstr "Builder Fees"

#. Builder payout history Builder Fees column tooltip
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:159
msgid "Builder fees charged through your code in the epoch, before the payout share."
msgstr "Builder fees charged through your code in the epoch, before the payout share."

#. Builder dashboard Total Earned tooltip
#: apps/web/src/features/builders/builderDashboard.tsx:130
msgid "Builder fees you've earned through your code over every closed epoch."
msgstr "Builder fees you've earned through your code over every closed epoch."

#. Builder dashboard Earned This Epoch tooltip
#: apps/web/src/features/builders/builderDashboard.tsx:107
msgid "Builder fees you've earned through your code so far this epoch."
msgstr "Builder fees you've earned through your code so far this epoch."

#. Link from the builder dashboard to the public builder leaderboard
#: apps/web/src/features/builders/builderDashboard.tsx:292
msgid "Builder leaderboard"
msgstr "Builder leaderboard"

#: apps/web/src/features/builders/builders.tsx:67
msgid "Builders are independent third parties; being listed or featured is not an endorsement by Perpl. Do your own research and review permissions before trading through one."
msgstr "Builders are independent third parties; being listed or featured is not an endorsement by Perpl. Do your own research and review permissions before trading through one."

#. Custom filter: Buy
#: packages/ui-kit/src/feature/terminal_tables/shared/getSideFilterOptions.tsx:11
msgid "Buy"
msgstr "Buy"

#. Mobile trade bar: open the order form on the long side
#: apps/web/src/features/terminal/mobile/mobile_trade_bar.tsx:41
msgid "Buy / Long"
msgstr "Buy / Long"

#. Chart overlay preference
#: apps/web/src/components/header/user_settings/preferences-drawer/chart_overlay_preference_section.tsx:14
msgid "Buy / Sell marks"
msgstr "Buy / Sell marks"

#: apps/web/src/features/auth/components/terms_dialog.tsx:78
msgid "By continuing, you agree to our <0>Terms of Use</0> and <1>Privacy Policy.</1>"
msgstr "By continuing, you agree to our <0>Terms of Use</0> and <1>Privacy Policy.</1>"

#. message for tp/sl modal
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/tp_sl_modal.tsx:213
msgid "By default take-profit and stop-loss orders apply to the entire position."
msgstr "By default take-profit and stop-loss orders apply to the entire position."

#: apps/web/src/features/leaderboard/components/dialog/badges_dialog.tsx:82
msgid "CAMPAIGN CLOSED"
msgstr "CAMPAIGN CLOSED"

#. CSV export dialog: abort and close
#. Close dialog: cancel button
#. Close dialog: cancel button
#. Disable one-click trading cancel button
#. Flip dialog: cancel button
#. Mobile open order card: cancel order button
#. Open orders row action
#. Picture-in-picture cancel order button
#. Renew referral code cancel button
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:159
#: apps/web/src/features/account/close_position_dialog/CloseAllContent.tsx:56
#: apps/web/src/features/account/close_position_dialog/SinglePositionContent.tsx:165
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:141
#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:173
#: apps/web/src/features/picture_in_picture/components/OrderRow.tsx:197
#: apps/web/src/features/referral/hooks/useRefCodeRenewal.ts:112
#: packages/ui-kit/src/components/dialogs/confirmation_dialog.tsx:26
#: packages/ui-kit/src/feature/terminal_tables/csv_export/ExportCsvDialog.tsx:252
#: packages/ui-kit/src/feature/terminal_tables/open_orders/open_orders_columns.tsx:172
#: packages/ui-kit/src/feature/terminal_tables/open_orders/open_orders.tsx:92
msgid "Cancel"
msgstr "Cancel"

#. Open orders bulk-action button while filters hide some orders: shown/total, e.g. "Cancel 2/5"
#: packages/ui-kit/src/feature/terminal_tables/open_orders/open_orders.tsx:50
msgid "Cancel {shown}/{total}"
msgstr "Cancel {shown}/{total}"

#. Open orders header button
#. Table header: action for cancel all
#: packages/ui-kit/src/feature/terminal_tables/open_orders/open_orders_columns.tsx:153
#: packages/ui-kit/src/feature/terminal_tables/open_orders/open_orders.tsx:106
msgid "Cancel All"
msgstr "Cancel All"

#. Mobile open order card: cancel order button
#: packages/ui-kit/src/feature/terminal_tables/open_orders/open_orders.tsx:95
#~ msgid "Cancel order"
#~ msgstr "Cancel order"

#. Dashboard chart: daily deposit and withdrawal flows
#: apps/web/src/features/dashboard/dashboardLabels.ts:26
msgid "Capital Flows"
msgstr "Capital Flows"

#. Header nav item linking to the release notes page. Sits in the Tools menu beside "API Keys" and "Docs".
#: apps/web/src/components/header/constants.ts:146
msgid "Changelog"
msgstr "Changelog"

#. Mobile trade tab: price chart
#. Preferences: chart overlays section title
#: apps/web/src/components/header/user_settings/preferences-drawer/chart_overlay_preference_section.tsx:22
#: apps/web/src/features/terminal/mobile/mobile_trading_layout.tsx:42
msgid "Chart"
msgstr "Chart"

#. Terminal chart view: candlesticks
#. Terminal chart view: candlesticks
#: apps/web/src/features/tv_charts/candle_sticks.tsx:167
#: apps/web/src/features/tv_charts/trading_chart_panel.tsx:97
msgctxt "terminal view"
msgid "Chart"
msgstr "Chart"

#: apps/web/src/components/summer-banner/million-banner.tsx:59
#: apps/web/src/components/summer-banner/summer-banner.tsx:72
msgid "Check mPoints"
msgstr "Check mPoints"

#: apps/web/src/features/tournament/components/standing-card.tsx:97
#: apps/web/src/features/tournament/components/standing-row.tsx:76
msgid "Checking your standing…"
msgstr "Checking your standing…"

#. Coin filter checklist: unchecks every coin
#: packages/ui-kit/src/feature/terminal_tables/shared/MarketColumnFilter.tsx:136
msgid "Clear"
msgstr "Clear"

#. Button label to clear filters
#: packages/ui-kit/src/components/table/filter/empty_filter_view.tsx:39
msgid "Clear filters"
msgstr "Clear filters"

#: apps/web/src/features/tournament/hooks/useStandings.ts:145
msgid "Climb to break into the top 10"
msgstr "Climb to break into the top 10"

#. Close dialog button accessibility label
#: packages/ui-kit/src/components/button/close_button.tsx:9
msgid "close"
msgstr "close"

#. Mobile position card: close position button
#. Picture-in-picture close position button
#. Positions row action
#: apps/web/src/features/account/components/withdraw_panel.tsx:135
#: apps/web/src/features/picture_in_picture/components/PositionRow.tsx:191
#: apps/web/src/features/points/components/og-badge-dialog/og-badge-dialog.tsx:117
#: packages/ui-kit/src/feature/terminal_tables/position/positions_columns.tsx:194
#: packages/ui-kit/src/feature/terminal_tables/position/positions_table.tsx:111
msgid "Close"
msgstr "Close"

#. Market menu keyboard hint: Esc closes this menu
#: packages/ui-kit/src/feature/market_info/market_menu/market_menu_hints.tsx:63
msgctxt "keyboard shortcut"
msgid "Close"
msgstr "Close"

#. P&L history event fallback label: closed
#. P&L history event label: position closed
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:33
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:69
msgctxt "position event"
msgid "Close"
msgstr "Close"

#. Order form fees row label: closing fees
#: packages/ui-kit/src/feature/order_entry/constants.ts:65
#~ msgctxt "position fees"
#~ msgid "Close"
#~ msgstr "Close"

#. Positions bulk-action button while filters hide some positions: shown/total, e.g. "Close 2/5"
#: packages/ui-kit/src/feature/terminal_tables/position/positions_table.tsx:91
msgid "Close {shown}/{total}"
msgstr "Close {shown}/{total}"

#. Close dialog title for a full close
#: apps/web/src/features/account/close_position_dialog/SinglePositionContent.tsx:28
msgid "Close {ticker} Position"
msgstr "Close {ticker} Position"

#. Close-all dialog: confirm button
#. Positions header button
#. Positions header button
#: apps/web/src/features/account/close_position_dialog/CloseAllContent.tsx:59
#: packages/ui-kit/src/feature/terminal_tables/position/positions_columns.tsx:161
#: packages/ui-kit/src/feature/terminal_tables/position/positions_table.tsx:175
msgid "Close All"
msgstr "Close All"

#. Market picker close button
#: packages/ui-kit/src/feature/market_info/market_menu/market_menu_sheet.tsx:137
msgid "Close market picker"
msgstr "Close market picker"

#. Mobile drawer close button
#: apps/web/src/components/header/mobile_drawer.tsx:129
msgid "Close menu"
msgstr "Close menu"

#. Mobile order drawer close button
#: apps/web/src/features/terminal/mobile/mobile_order_drawer.tsx:66
msgid "Close order form"
msgstr "Close order form"

#. Table header: Close PNL
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:99
msgid "Close PNL"
msgstr "Close PNL"

#. Picture-in-picture button that closes the pop-out window
#: apps/web/src/features/picture_in_picture/components/PipCloseButton.tsx:31
msgid "Close pop-out"
msgstr "Close pop-out"

#. Mobile position card: close position button
#: packages/ui-kit/src/feature/terminal_tables/position/positions_cards.tsx:72
#~ msgid "Close position"
#~ msgstr "Close position"

#. Close dialog: confirm button label for a full close
#: apps/web/src/features/account/close_position_dialog/SinglePositionContent.tsx:22
msgid "Close Position"
msgstr "Close Position"

#. Keyboard shortcut action: open the close dialog for the selected market's position
#: apps/web/src/features/shortcuts/shortcuts.ts:56
msgctxt "keyboard shortcut"
msgid "Close Position"
msgstr "Close Position"

#. Preferences drawer close button
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:208
msgid "close settings"
msgstr "close settings"

#. Table header tooltip: PnL
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:133
msgid "Closed PNL includes fees and funding payments"
msgstr "Closed PNL includes fees and funding payments"

#: apps/web/src/features/tournament/components/standing-shared.tsx:126
msgid "Closest shot"
msgstr "Closest shot"

#. Label of Coin
#. Table header: Coin
#. Table header: Coin
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:70
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:72
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/tp_sl_modal.tsx:143
msgid "Coin"
msgstr "Coin"

#. placeholder {0}: token.symbol
#: apps/web/src/features/account/components/account_panel.tsx:184
msgid "Collateral ({0})"
msgstr "Collateral ({0})"

#. Tooltip for total volume referred referral stat
#: apps/web/src/features/referral/referral.tsx:81
msgid "Combined trading volume of everyone you referred."
msgstr "Combined trading volume of everyone you referred."

#: apps/web/src/features/tournament/components/competition-card.tsx:101
msgid "Competition {number}"
msgstr "Competition {number}"

#. Configure amount checkbox
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/fields/amount.tsx:64
msgid "Configure Amount"
msgstr "Configure Amount"

#. Add referral code confirm button
#. Confirm button in tp/sl modal
#. Confirm leverage update
#: apps/web/src/features/account/oneclick_dialog.tsx:36
#: apps/web/src/features/auth/components/access_request_dialog.tsx:93
#: apps/web/src/features/referral/components/referred-by.tsx:145
#: packages/ui-kit/src/components/dialogs/confirmation_dialog.tsx:25
#: packages/ui-kit/src/components/dialogs/slippage_dialog.tsx:59
#: packages/ui-kit/src/feature/order_entry/form/account_leverage.tsx:218
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/tp_sl_modal.tsx:248
msgid "Confirm"
msgstr "Confirm"

#. Close-all dialog title
#: apps/web/src/features/account/close_position_dialog/CloseAllContent.tsx:52
msgid "Confirm Close All"
msgstr "Confirm Close All"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:176
msgid "Confirm in wallet…"
msgstr "Confirm in wallet…"

#. Preferences: confirm position close toggle
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:170
msgid "Confirm Position Close"
msgstr "Confirm Position Close"

#. Preferences: confirm position flip (reverse) toggle
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:171
msgid "Confirm Position Flip"
msgstr "Confirm Position Flip"

#. Connect wallet button
#. Connect wallet button
#: apps/web/src/components/rainbow/CustomConnectButton.tsx:114
#: apps/web/src/features/account/hooks/useDepositButtonText.ts:29
msgid "Connect"
msgstr "Connect"

#. Builder dashboard disconnected state
#: apps/web/src/features/builders/builderDashboard.tsx:203
msgid "Connect the wallet your builder code is registered to."
msgstr "Connect the wallet your builder code is registered to."

#. Points history connect CTA
#: apps/web/src/features/points/components/points-history-grid/cells/disconnected.tsx:12
msgid "Connect to see Points"
msgstr "Connect to see Points"

#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:50
#: apps/web/src/features/tournament/components/standing-card.tsx:128
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:86
msgid "Connect wallet"
msgstr "Connect wallet"

#. API keys page disconnected state
#: apps/web/src/features/api-keys/api-keys.tsx:64
msgid "Connect your wallet to manage API keys."
msgstr "Connect your wallet to manage API keys."

#. Account history table, no wallet connected
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:118
msgid "Connect your wallet to see your account history"
msgstr "Connect your wallet to see your account history"

#. Funding history table, no wallet connected
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:128
msgid "Connect your wallet to see your funding payments"
msgstr "Connect your wallet to see your funding payments"

#. Open orders table, no wallet connected
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:96
msgid "Connect your wallet to see your open orders"
msgstr "Connect your wallet to see your open orders"

#. Order history table, no wallet connected
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:107
msgid "Connect your wallet to see your order history"
msgstr "Connect your wallet to see your order history"

#. P&L history table, no wallet connected
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:114
msgid "Connect your wallet to see your P&L history"
msgstr "Connect your wallet to see your P&L history"

#. Points history disconnected overlay
#: apps/web/src/features/points/components/points-history-grid/cells/disconnected.tsx:10
msgid "Connect your wallet to see your Points history"
msgstr "Connect your wallet to see your Points history"

#. Portfolio chart empty state body: no wallet connected
#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:46
msgid "Connect your wallet to see your portfolio"
msgstr "Connect your wallet to see your portfolio"

#. Positions table, no wallet connected
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:92
msgid "Connect your wallet to see your positions"
msgstr "Connect your wallet to see your positions"

#. Rewards menu panel when wallet is disconnected
#: apps/web/src/components/header/rewards_menu/panels.tsx:139
msgid "Connect your wallet to see your rewards"
msgstr "Connect your wallet to see your rewards"

#: apps/web/src/features/tournament/hooks/useStandings.ts:82
msgid "Connect your wallet to see your standing"
msgstr "Connect your wallet to see your standing"

#. Trade history table, no wallet connected
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:100
msgid "Connect your wallet to see your trade history"
msgstr "Connect your wallet to see your trade history"

#. Account panel prompt when no wallet connected
#: apps/web/src/features/account/account_status.tsx:170
msgid "Connect your wallet to start trading"
msgstr "Connect your wallet to start trading"

#: apps/web/src/features/account/components/account_panel.tsx:99
msgid "Connected Wallet"
msgstr "Connected Wallet"

#. Footer connection status
#: packages/ui-kit/src/common/heartbeatStore.ts:19
msgid "Connection Issues"
msgstr "Connection Issues"

#. Renew referral code confirm button
#: apps/web/src/features/referral/hooks/useRefCodeRenewal.ts:111
msgid "Continue"
msgstr "Continue"

#. Address copied confirmation
#. Referral code copied confirmation
#: apps/web/src/components/header/user_account_menu/account_menu_header.tsx:39
#: apps/web/src/components/header/user_account_menu/account_menu_referral.tsx:104
msgid "Copied"
msgstr "Copied"

#. Clipboard copy success
#: apps/web/src/features/api-keys/utils.ts:50
msgid "Copied to clipboard"
msgstr "Copied to clipboard"

#. Referrals card CTA
#. Referrals card CTA
#: apps/web/src/features/referral/components/referrals-card/referrals-card.tsx:64
#: apps/web/src/features/referral/components/referrals-card/share-referral-dialog.tsx:45
msgid "Copied!"
msgstr "Copied!"

#. Share dialog copy image
#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:283
#: packages/ui-kit/src/components/dialogs/share_pnl/ShareActionButtons.tsx:40
msgid "Copy"
msgstr "Copy"

#. Copy wallet address
#: apps/web/src/components/header/user_account_menu/account_menu_header.tsx:37
msgid "Copy address"
msgstr "Copy address"

#: apps/web/src/features/account/components/account_panel.tsx:116
msgid "Copy Address"
msgstr "Copy Address"

#: apps/web/src/features/account/components/account_panel.tsx:76
msgid "Copy Delegated Address"
msgstr "Copy Delegated Address"

#. API key table copy tooltip
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:27
msgid "Copy key"
msgstr "Copy key"

#. Copy referral code
#: apps/web/src/components/header/user_account_menu/account_menu_referral.tsx:78
msgid "Copy referral code"
msgstr "Copy referral code"

#. Referrals card CTA
#. Referrals card CTA
#: apps/web/src/features/referral/components/referrals-card/referrals-card.tsx:65
#: apps/web/src/features/referral/components/referrals-card/share-referral-dialog.tsx:46
msgid "Copy referral link"
msgstr "Copy referral link"

#. Preferences drawer copy support info
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:406
msgid "Copy support info"
msgstr "Copy support info"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:216
msgid "Copy your secret now. For security it is never stored and will not be shown again."
msgstr "Copy your secret now. For security it is never stored and will not be shown again."

#. Funding map load error
#: apps/web/src/features/funding-map/FundingHeatmapCard.tsx:152
msgid "Could not load funding history."
msgstr "Could not load funding history."

#. Dashboard load error
#: apps/web/src/features/dashboard/dashboard.tsx:119
msgid "Could not load protocol stats."
msgstr "Could not load protocol stats."

#. Flip dialog: typed slippage limit covers the whole order
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:179
#~ msgid "Covers the whole flip at the current order book"
#~ msgstr "Covers the whole flip at the current order book"

#. API keys page create button
#: apps/web/src/features/api-keys/api-keys.tsx:55
#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:108
msgid "Create API key"
msgstr "Create API key"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:176
msgid "Create key"
msgstr "Create key"

#: apps/web/src/features/api-keys/api-keys.tsx:39
msgid "Create keys to access the trading API programmatically. Each key carries read-only or trade permissions; withdrawals are never permitted via an API key. <0>View the API docs.</0>"
msgstr "Create keys to access the trading API programmatically. Each key carries read-only or trade permissions; withdrawals are never permitted via an API key. <0>View the API docs.</0>"

#. API key table column
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:156
msgid "Created"
msgstr "Created"

#. Cross margin label. One of two labels in a narrow two-button toggle, beside "Isolated" — keep both the same part of speech and roughly the same length.
#. Cross margin label. One of two labels in a narrow two-button toggle, beside "Isolated" — keep both the same part of speech and roughly the same length.
#: packages/ui-kit/src/feature/order_entry/margin_switch/margin_switch.tsx:86
#: packages/ui-kit/src/feature/order_entry/margin_switch/margin_switch.tsx:93
msgid "Cross"
msgstr "Cross"

#. Dashboard chart overlay: running total
#: apps/web/src/features/dashboard/dashboardLabels.ts:12
msgid "Cumulative"
msgstr "Cumulative"

#: packages/ui-kit/src/feature/terminal_tables/position/positions_columns.tsx:45
msgid "Current leverage"
msgstr "Current leverage"

#. Adjust margin dialog: label for current margin row
#: apps/web/src/features/trading/adjust_margin_dialog/MarginInfoRows.tsx:28
msgid "Current margin"
msgstr "Current margin"

#. Filter option: current market
#: packages/ui-kit/src/feature/terminal_tables/shared/useMarketQuickFilter.tsx:72
msgid "Current market{market}"
msgstr "Current market{market}"

#. Current position label
#: packages/ui-kit/src/feature/order_entry/form/position_display.tsx:85
msgid "Current position"
msgstr "Current position"

#: apps/web/src/features/mpoints/components/stat-cards/projected-rewards-card.tsx:16
msgid "Current value"
msgstr "Current value"

#. Share card stat label
#: apps/web/src/features/mpoints/components/share-points-dialog/points-share-card.tsx:248
msgid "Current Value"
msgstr "Current Value"

#. Custom slippage input placeholder
#: packages/ui-kit/src/components/dialogs/slippage_selector.tsx:179
msgid "Custom"
msgstr "Custom"

#. Renew disabled reason (custom alias code)
#: apps/web/src/features/referral/hooks/useRefCodeRenewal.ts:74
msgid "Custom referral codes can't be renewed."
msgstr "Custom referral codes can't be renewed."

#. Countdown days unit (single letter)
#: apps/web/src/features/mpoints/components/hero-banner/hero-banner.tsx:124
#~ msgid "D"
#~ msgstr "D"

#. Countdown days unit (single letter)
#: apps/web/src/features/mpoints/components/hero-banner/hero-banner.tsx:124
msgctxt "countdown unit"
msgid "D"
msgstr "D"

#. Dashboard chart legend: daily series
#: apps/web/src/features/dashboard/dashboardLabels.ts:11
msgid "Daily"
msgstr "Daily"

#. Dashboard KPI: latest daily deposits
#: apps/web/src/features/dashboard/dashboard.tsx:173
msgid "Daily Inflows"
msgstr "Daily Inflows"

#. Dashboard KPI: latest daily net deposit flow
#: apps/web/src/features/dashboard/dashboard.tsx:169
msgid "Daily Net Flow"
msgstr "Daily Net Flow"

#. Dashboard KPI: latest daily withdrawals
#: apps/web/src/features/dashboard/dashboard.tsx:177
msgid "Daily Outflows"
msgstr "Daily Outflows"

#. Dashboard chart: daily Perpl transactions
#: apps/web/src/features/dashboard/dashboardLabels.ts:33
msgid "Daily Transactions"
msgstr "Daily Transactions"

#. Dashboard chart: daily notional volume
#: apps/web/src/features/dashboard/dashboardLabels.ts:24
msgid "Daily Volume"
msgstr "Daily Volume"

#. Header nav item
#: apps/web/src/components/header/constants.ts:106
msgid "Dashboard"
msgstr "Dashboard"

#. Funding history popover header: Date
#: packages/ui-kit/src/feature/market_info/funding_history_popover.tsx:148
msgid "Date"
msgstr "Date"

#. Referral history column header
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:99
msgid "Date Joined"
msgstr "Date Joined"

#: apps/web/src/features/points/components/countdown-card.tsx:46
#: apps/web/src/features/tournament/components/countdown-card.tsx:134
msgid "Days"
msgstr "Days"

#. Adjust margin dialog: description paragraph
#: apps/web/src/features/trading/adjust_margin_dialog/index.tsx:126
msgid "Decrease the chance of liquidation by adding more margin."
msgstr "Decrease the chance of liquidation by adding more margin."

#. Funding heatmap legend: colour intensity
#: apps/web/src/features/funding-map/FundingHeatmapCard.tsx:131
msgid "deeper colour = larger rate"
msgstr "deeper colour = larger rate"

#. Preferences: select for the order type the order form opens on (Market or Limit)
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:175
msgid "Default Order Type"
msgstr "Default Order Type"

#: apps/web/src/features/tournament/components/standing-shared.tsx:125
msgid "Defend"
msgstr "Defend"

#. Delegated wallet address label in account menu
#. Header chip: delegated account session
#: apps/web/src/components/header/constants.ts:190
#: apps/web/src/components/header/user_account_menu/account_menu_header.tsx:40
msgid "Delegated"
msgstr "Delegated"

#: apps/web/src/features/account/components/account_panel.tsx:70
#: apps/web/src/features/account/components/account_panel.tsx:169
msgid "Delegated Account"
msgstr "Delegated Account"

#. P&L history event fallback label: deleveraged
#. P&L history event label: position deleveraged
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:44
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:76
msgid "Deleverage"
msgstr "Deleverage"

#. Account history operation
#: packages/ui-kit/src/feature/terminal_tables/account_history/constants.ts:37
msgid "Deleveraging"
msgstr "Deleveraging"

#. Account history operation
#. Custom filter: Deposit
#. Deposit action in account menu
#. Deposit dialog title
#. Deposit view title in account menu
#. Keyboard shortcut action
#. Portfolio chart empty state button: open the deposit dialog
#: apps/web/src/components/header/user_account_menu/account_balance_summary.tsx:110
#: apps/web/src/components/header/user_account_menu/index.tsx:202
#: apps/web/src/features/account/deposit_dialog.tsx:20
#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:77
#: apps/web/src/features/shortcuts/shortcuts.ts:63
#: packages/ui-kit/src/feature/terminal_tables/account_history/constants.ts:21
#: packages/ui-kit/src/feature/terminal_tables/account_history/useFilterOptions.tsx:21
msgid "Deposit"
msgstr "Deposit"

#. Button opening the deposit dialog. An action ("add funds"), not the noun for a deposit transaction — the uncontexted "Deposit" is the noun used by the account-history row and the table filter.
#. Deposit button fallback label. An action ("add funds"), not the noun for a deposit transaction — the uncontexted "Deposit" is the noun used by the account-history row and the table filter.
#. Deposit collateral button. An action ("add funds"), not the noun for a deposit transaction — the uncontexted "Deposit" is the noun used by the account-history row and the table filter.
#. Deposit panel submit button. An action ("add funds"), not the noun for a deposit transaction — the uncontexted "Deposit" is the noun used by the account-history row and the table filter. Sits beside a "Withdraw" button, so keep the two the same part of speech.
#: apps/web/src/components/header/mobile_drawer.tsx:215
#: apps/web/src/features/account/components/deposit_panel.tsx:128
#: apps/web/src/features/account/hooks/useDepositButtonText.ts:40
#: packages/ui-kit/src/feature/order_entry/form/forms_action_buttons.tsx:96
msgctxt "action"
msgid "Deposit"
msgstr "Deposit"

#: apps/web/src/features/account/components/deposit_panel.tsx:139
msgid "Deposit {tokenSymbol} to use as collateral. Minimum: {formattedMinDeposit}."
msgstr "Deposit {tokenSymbol} to use as collateral. Minimum: {formattedMinDeposit}."

#. Enable trading button
#: apps/web/src/features/account/hooks/useDepositButtonText.ts:37
msgid "Deposit to Enable trading"
msgstr "Deposit to Enable trading"

#. Account panel prompt when connected but unfunded
#. Portfolio chart empty state body: signed in, no deposit yet
#: apps/web/src/features/account/account_status.tsx:169
#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:71
msgid "Deposit to start trading"
msgstr "Deposit to start trading"

#. Terminal chart view: market depth
#: apps/web/src/features/tv_charts/candle_sticks.tsx:172
msgid "Depth"
msgstr "Depth"

#. Link to referral stats
#: apps/web/src/components/header/user_account_menu/account_menu_referral.tsx:54
msgid "Details"
msgstr "Details"

#: apps/web/src/features/tournament/components/tournament-dev-controls.tsx:25
msgid "Dev: remove Monad Card"
msgstr "Dev: remove Monad Card"

#: apps/web/src/features/tournament/components/tournament-dev-controls.tsx:25
msgid "Dev: simulate Monad Card"
msgstr "Dev: simulate Monad Card"

#. Table header: Direction
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:100
msgid "Direction"
msgstr "Direction"

#. Disable one-click trading confirmation title
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:152
msgid "Disable One-Click Trading?"
msgstr "Disable One-Click Trading?"

#: apps/web/src/features/account/components/account_panel.tsx:197
msgid "Disconnect"
msgstr "Disconnect"

#. Footer connection status
#: packages/ui-kit/src/common/heartbeatStore.ts:18
msgid "Disconnected"
msgstr "Disconnected"

#: apps/web/src/components/summer-banner/million-banner.tsx:36
#: apps/web/src/components/summer-banner/summer-banner.tsx:44
msgid "Dismiss banner"
msgstr "Dismiss banner"

#. Alias saved notification
#: apps/web/src/features/referral/components/partner/edit-alias-dialog.tsx:40
msgid "Display name updated"
msgstr "Display name updated"

#. Builders page Traders stat tooltip
#: apps/web/src/features/builders/components/BuilderTotals.tsx:33
msgid "Distinct accounts that traded through any builder over the period, counted once per account."
msgstr "Distinct accounts that traded through any builder over the period, counted once per account."

#. Builder dashboard Traders tooltip
#: apps/web/src/features/builders/builderDashboard.tsx:153
msgid "Distinct accounts that traded through your code."
msgstr "Distinct accounts that traded through your code."

#. Header nav item linking to the documentation site. Sits in the Tools menu beside "API Keys" and "Testnet".
#: apps/web/src/components/header/constants.ts:157
msgid "Docs"
msgstr "Docs"

#: packages/ui-kit/src/components/dialogs/confirmation_dialog.tsx:77
msgid "Don't show again"
msgstr "Don't show again"

#. Close dialog: suppress confirmation checkbox
#. Close dialog: suppress confirmation checkbox
#. Flip dialog: suppress confirmation checkbox
#: apps/web/src/features/account/close_position_dialog/CloseAllContent.tsx:87
#: apps/web/src/features/account/close_position_dialog/SinglePositionContent.tsx:228
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:319
msgid "Don't show me this again (can change in settings)"
msgstr "Don't show me this again (can change in settings)"

#. CSV export dialog: dismiss after a download
#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:244
#: packages/ui-kit/src/feature/terminal_tables/csv_export/ExportCsvDialog.tsx:250
msgid "Done"
msgstr "Done"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:237
msgid "Download all formats"
msgstr "Download all formats"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:114
msgid "e.g. Trading bot"
msgstr "e.g. Trading bot"

#. Referral page subtitle with first- and second-level commissions, points boost, biweekly rewards note, and learn more link
#: apps/web/src/features/referral/referral.tsx:132
msgid "Earn {first} fee rebate from each referral <0>and</0> {second} from each sub-referral. Plus a {boost} Points boost.<1/>Rewards are processed biweekly. <2>Learn more.</2>"
msgstr "Earn {first} fee rebate from each referral <0>and</0> {second} from each sub-referral. Plus a {boost} Points boost.<1/>Rewards are processed biweekly. <2>Learn more.</2>"

#. Referrals card benefit note
#: apps/web/src/features/referral/components/referrals-card/referrals-card.tsx:67
msgid "Earn fee rebates and points from every referral"
msgstr "Earn fee rebates and points from every referral"

#. Referrals card benefit note with docs link
#. Referrals card benefit note with docs link
#: apps/web/src/features/referral/components/referrals-card/referrals-card.tsx:78
#: apps/web/src/features/referral/components/referrals-card/share-referral-dialog.tsx:86
msgid "Earn fee rebates and points from every referral. <0>Learn more.</0>"
msgstr "Earn fee rebates and points from every referral. <0>Learn more.</0>"

#: apps/web/src/components/summer-banner/summer-banner.tsx:49
msgid "Earn mPoints"
msgstr "Earn mPoints"

#: apps/web/src/features/mpoints/components/stat-cards/m-points-card.tsx:69
msgid "Earned last epoch"
msgstr "Earned last epoch"

#. Builder dashboard stat label
#: apps/web/src/features/builders/builderDashboard.tsx:106
msgid "Earned This Epoch"
msgstr "Earned This Epoch"

#. Partner current epoch earnings label
#: apps/web/src/features/referral/components/partner/partner-stats.tsx:141
msgid "Earned this week"
msgstr "Earned this week"

#. Edit partner display name button
#. Market order fill prognosis: edit slippage link
#. Mobile open order card: edit order button
#: apps/web/src/features/referral/components/partner/partner-hero-card.tsx:188
#: packages/ui-kit/src/feature/order_entry/form/market_fill_prognosis.tsx:146
#: packages/ui-kit/src/feature/terminal_tables/open_orders/open_orders.tsx:82
msgid "Edit"
msgstr "Edit"

#. Edit referral code button
#: apps/web/src/features/referral/components/partner/partner-hero-card.tsx:206
msgid "Edit code"
msgstr "Edit code"

#. Mobile open order card: edit order button
#: packages/ui-kit/src/feature/terminal_tables/open_orders/open_orders.tsx:85
#~ msgid "Edit order"
#~ msgstr "Edit order"

#. Edit open order dialog title
#: apps/web/src/features/trading/edit_order_dialog/index.tsx:123
msgid "Edit Order"
msgstr "Edit Order"

#. Picture-in-picture edit order button
#: apps/web/src/features/picture_in_picture/components/OrderRow.tsx:186
msgid "Edit price"
msgstr "Edit price"

#. Picture-in-picture edit TP/SL button
#: apps/web/src/features/picture_in_picture/components/PositionRow.tsx:184
msgid "Edit TP / SL"
msgstr "Edit TP / SL"

#. Portfolio Account Leverage tooltip
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:233
msgid "Effective leverage across all open positions.\n"
"Total notional value divided by total margin."
msgstr "Effective leverage across all open positions.\n"
"Total notional value divided by total margin."

#. Enable one-click trading in settings link
#: packages/ui-kit/src/components/one_click_tooltip_content.tsx:30
msgid "Enable in Settings"
msgstr "Enable in Settings"

#. Preferences: one-click trading toggle
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:169
msgid "Enable One Click Trading"
msgstr "Enable One Click Trading"

#: apps/web/src/features/account/oneclick_dialog.tsx:61
msgid "Enable One-Click Trading"
msgstr "Enable One-Click Trading"

#. One-click trading required tooltip message
#: packages/ui-kit/src/components/one_click_tooltip_content.tsx:17
msgid "Enable One-Click Trading to allow automated order execution (TP/SL, Stop orders)"
msgstr "Enable One-Click Trading to allow automated order execution (TP/SL, Stop orders)"

#. Filter: End date
#: packages/ui-kit/src/components/table/filter/date_range.tsx:158
msgid "End date"
msgstr "End date"

#: apps/web/src/features/tournament/components/competition-card.tsx:98
msgid "Ended"
msgstr "Ended"

#: apps/web/src/features/tournament/components/countdown-card.tsx:199
msgid "Ended on {date}"
msgstr "Ended on {date}"

#: apps/web/src/features/tournament/components/countdown-card.tsx:202
msgid "Ends on {date}"
msgstr "Ends on {date}"

#. Custom slippage validation
#: packages/ui-kit/src/components/dialogs/slippage_selector.tsx:82
msgid "Enter a valid number"
msgstr "Enter a valid number"

#. Flip dialog: per-order slippage field out of range
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:157
#~ msgid "Enter a value between {CUSTOM_SLIPPAGE_MIN_PERCENT}% and {CUSTOM_SLIPPAGE_MAX_PERCENT}%"
#~ msgstr "Enter a value between {CUSTOM_SLIPPAGE_MIN_PERCENT}% and {CUSTOM_SLIPPAGE_MAX_PERCENT}%"

#. Flip dialog: per-order slippage field out of range; both placeholders are percentages
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:169
#~ msgid "Enter a value between {minPct}% and {maxPct}%"
#~ msgstr "Enter a value between {minPct}% and {maxPct}%"

#. Enter access code button
#: apps/web/src/features/account/hooks/useDepositButtonText.ts:21
msgid "Enter access code"
msgstr "Enter access code"

#: apps/web/src/features/auth/components/access_request_dialog.tsx:77
msgid "Enter Perpl"
msgstr "Enter Perpl"

#. PiP metric entry
#: apps/web/src/features/picture_in_picture/components/PositionRow.tsx:137
msgid "Entry price"
msgstr "Entry price"

#. Label of Entry Price
#. Table header: Entry Price
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:76
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/tp_sl_modal.tsx:164
msgid "Entry Price"
msgstr "Entry Price"

#. Builder payout history column header
#. Rewards history column header
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:125
#: apps/web/src/features/mpoints/components/rewards-history-grid/useRewardsHistoryColumns.tsx:18
#: apps/web/src/features/mpoints/components/stat-cards/points-distribution-card.tsx:94
#: apps/web/src/features/referral/components/referrals-history/rewards-columns.tsx:78
msgid "Epoch"
msgstr "Epoch"

#: apps/web/src/features/mpoints/components/hero-banner/hero-banner.tsx:119
msgid "Epoch #{current} / {total}"
msgstr "Epoch #{current} / {total}"

#: apps/web/src/features/points/components/points-history-grid/columns.tsx:62
msgid "Epoch Name"
msgstr "Epoch Name"

#: apps/web/src/features/points/components/countdown-card.tsx:43
msgid "Epoch Snapshot in"
msgstr "Epoch Snapshot in"

#. Rewards history footer
#: apps/web/src/features/referral/components/referrals-history/rewards-grid.tsx:89
msgid "Epoch snapshots are taken {snapshot}. Transfers are processed biweekly. Circumstances permitting."
msgstr "Epoch snapshots are taken {snapshot}. Transfers are processed biweekly. Circumstances permitting."

#: apps/web/src/features/points/components/points-history-grid/points-history-grid.tsx:78
msgid "Epoch snapshots are taken each Wednesday at 16:00 UTC. Points are usually distributed within 48 hours. <0>See Docs</0>"
msgstr "Epoch snapshots are taken each Wednesday at 16:00 UTC. Points are usually distributed within 48 hours. <0>See Docs</0>"

#: apps/web/src/features/account/components/deposit_panel.tsx:170
msgid "Equity is your balance plus open positions, and is capped at {formattedMaxEquity} {tokenSymbol}."
msgstr "Equity is your balance plus open positions, and is capped at {formattedMaxEquity} {tokenSymbol}."

#. Flip dialog: estimated slippage for the whole flip order
#. placeholder {0}: formatPct(estImpactPct)
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:230
#~ msgid "Est: {0}"
#~ msgstr "Est: {0}"

#. Close dialog: estimated slippage
#. Flip dialog: estimated slippage for the whole flip order
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:138
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:181
msgid "Est: {est}"
msgstr "Est: {est}"

#. Estimate marker after the live epoch payout amount
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:184
msgid "est."
msgstr "est."

#. Close dialog: estimated closing fee row label
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:107
msgid "Est. Closing Fee"
msgstr "Est. Closing Fee"

#. Close dialog: combined opening + estimated closing fees row label
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:108
#~ msgid "Est. Fees"
#~ msgstr "Est. Fees"

#. Flip dialog: estimated average fill price row label
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:171
msgid "Est. Fill Price"
msgstr "Est. Fill Price"

#. Close dialog: estimated realized PnL row label
#. Flip dialog: estimated realized PnL row label
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:183
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:212
msgid "Est. Realized PnL"
msgstr "Est. Realized PnL"

#. Market order fill prognosis: caveat about book changes between blocks
#: packages/ui-kit/src/feature/order_entry/form/market_fill_prognosis.tsx:185
msgid "Estimate based on current book; actual fill may shift before the order lands."
msgstr "Estimate based on current book; actual fill may shift before the order lands."

#. Builder dashboard live payout note
#: apps/web/src/features/builders/builderDashboard.tsx:117
msgid "Estimate. Final when the epoch closes."
msgstr "Estimate. Final when the epoch closes."

#. Close dialog: closing fee tooltip for a limit close
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:91
msgid "Estimated fee for closing at the current mark price, shown as maker / taker. A limit order that rests on the book pays the maker fee; one that fills immediately pays the taker fee."
msgstr "Estimated fee for closing at the current mark price, shown as maker / taker. A limit order that rests on the book pays the maker fee; one that fills immediately pays the taker fee."

#. Close dialog: closing fee tooltip for a market close
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:96
msgid "Estimated fee for closing at the current mark price. A market close pays the taker fee."
msgstr "Estimated fee for closing at the current mark price. A market close pays the taker fee."

#. Tooltip on estimated rewards for current epoch
#: apps/web/src/features/referral/components/referrals-history/rewards-columns.tsx:120
msgid "Estimated rewards for current epoch."
msgstr "Estimated rewards for current epoch."

#. Table header: Event
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:103
msgid "Event"
msgstr "Event"

#. Liquidation split: exchange share
#: apps/web/src/features/account/components/account_panel.tsx:141
#: packages/ui-kit/src/feature/terminal_tables/LiquidationDistributionTooltip.tsx:35
msgid "Exchange"
msgstr "Exchange"

#. Dashboard section: exchange activity
#: apps/web/src/features/dashboard/dashboard.tsx:205
msgctxt "dashboard section"
msgid "Exchange"
msgstr "Exchange"

#. Dashboard chart: USD execution cost per million transactions
#: apps/web/src/features/dashboard/dashboardLabels.ts:34
msgid "Execution Cost / 1M tx"
msgstr "Execution Cost / 1M tx"

#. Table header: Exit Price
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:77
msgid "Exit Price"
msgstr "Exit Price"

#. Expected loss summary label
#: packages/ui-kit/src/feature/order_entry/form/tp_sl.tsx:204
msgid "Exp Loss"
msgstr "Exp Loss"

#. Expected PnL zero summary label
#: packages/ui-kit/src/feature/order_entry/form/tp_sl.tsx:206
msgid "Exp PnL"
msgstr "Exp PnL"

#. Expected profit summary label
#: packages/ui-kit/src/feature/order_entry/form/tp_sl.tsx:202
msgid "Exp Profit"
msgstr "Exp Profit"

#. Expected Loss label
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/fields/tp_sl_input_section.tsx:134
msgid "Expected Loss"
msgstr "Expected Loss"

#. Expected Profit label
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/fields/tp_sl_input_section.tsx:133
msgid "Expected Profit"
msgstr "Expected Profit"

#. Referees filter option
#. Referral history volume badge — reward window expired
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:174
#: apps/web/src/features/referral/components/referrals-history/referrals-history.tsx:63
msgid "Expired"
msgstr "Expired"

#. API key table column
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:170
#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:143
msgid "Expires"
msgstr "Expires"

#. CSV export dialog: start the export and download the file
#: packages/ui-kit/src/feature/terminal_tables/csv_export/ExportCsvDialog.tsx:263
msgid "Export"
msgstr "Export"

#. CSV export dialog title; tableName is a history tab title such as "Trade History"
#: packages/ui-kit/src/feature/terminal_tables/csv_export/ExportCsvDialog.tsx:154
msgid "Export {tableName}"
msgstr "Export {tableName}"

#. Table footer button: downloads the table as a CSV file
#: packages/ui-kit/src/feature/terminal_tables/csv_export/ExportCsvDialog.tsx:69
msgid "Export as CSV"
msgstr "Export as CSV"

#. CSV export failed to load the history
#: packages/ui-kit/src/feature/terminal_tables/csv_export/ExportCsvDialog.tsx:206
msgid "Export failed. Check your connection and try again."
msgstr "Export failed. Check your connection and try again."

#. P&L history event fallback label: failed
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:84
msgid "Failed"
msgstr "Failed"

#. Clipboard copy failure
#: apps/web/src/features/api-keys/utils.ts:52
msgid "Failed to copy"
msgstr "Failed to copy"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:94
msgid "Failed to create API key. Please try again."
msgstr "Failed to create API key. Please try again."

#. Portfolio chart error
#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:173
msgid "Failed to load chart data"
msgstr "Failed to load chart data"

#. Market making table: stats request failed
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:172
msgid "Failed to load market making stats."
msgstr "Failed to load market making stats."

#. API keys page load error
#: apps/web/src/features/api-keys/api-keys.tsx:99
msgid "Failed to load your API keys."
msgstr "Failed to load your API keys."

#. API key revoke failed toast
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:43
msgid "Failed to revoke API key"
msgstr "Failed to revoke API key"

#. Memo save error toast
#: apps/web/src/features/referral/components/referrals-history/memo-cell.tsx:46
msgid "Failed to save memo. Please try again."
msgstr "Failed to save memo. Please try again."

#. Preferences: toast duration
#: apps/web/src/components/header/user_settings/preferences-drawer/notification_preference_section.tsx:43
msgid "Fast ({seconds}s)"
msgstr "Fast ({seconds}s)"

#. Market menu keyboard hint: F toggles the highlighted market as a favorite
#: packages/ui-kit/src/feature/market_info/market_menu/market_menu_hints.tsx:54
msgctxt "keyboard shortcut"
msgid "Favorite"
msgstr "Favorite"

#. Keyboard shortcut action: toggle the highlighted market as a favorite while the Markets menu is open
#: apps/web/src/features/shortcuts/keyboard_shortcuts_dialog.tsx:23
msgid "Favorite (in Markets)"
msgstr "Favorite (in Markets)"

#. Market picker tab: favorite markets
#. Preferences: trading panel toggle
#: apps/web/src/components/header/user_settings/preferences-drawer/terminal_panels_section.tsx:9
#: packages/ui-kit/src/feature/market_info/market_menu/market_menu_sheet.tsx:99
msgid "Favorites"
msgstr "Favorites"

#. Favorites bar toggle group aria label
#: apps/web/src/features/markets/favorites_bar.tsx:148
msgid "Favorites display mode"
msgstr "Favorites display mode"

#. Builders page section heading
#: apps/web/src/features/builders/components/FeaturedBuilders.tsx:36
msgid "Featured Builders"
msgstr "Featured Builders"

#. Table header: Fee
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:107
msgid "Fee"
msgstr "Fee"

#. Empty state when fee tiers are unavailable in account menu
#: apps/web/src/components/header/user_account_menu/fees_panel.tsx:131
msgid "Fee schedule unavailable"
msgstr "Fee schedule unavailable"

#. Referrals fee share row
#: apps/web/src/components/header/rewards_menu/panels.tsx:273
msgid "Fee share"
msgstr "Fee share"

#. Rewards structure column header
#: apps/web/src/features/referral/components/partner/rewards-structure-dialog.tsx:73
msgid "Fee Share"
msgstr "Fee Share"

#. Partner stat label
#: apps/web/src/features/referral/components/partner/partner-stats.tsx:173
msgid "Fee Share Referred"
msgstr "Fee Share Referred"

#: packages/ui-kit/src/components/dialogs/fee_tiers_dialog.tsx:141
msgid "Fee Tiers"
msgstr "Fee Tiers"

#. Mobile drawer item that opens the feedback survey
#: apps/web/src/components/header/mobile_drawer.tsx:195
msgid "Feedback"
msgstr "Feedback"

#. Close dialog: fees row label
#. Dashboard chart: daily trading fees by type
#. Fees view title in account menu
#. Open fee tiers panel in account menu
#. Order form fees row label
#: apps/web/src/components/header/user_account_menu/account_balance_summary.tsx:114
#: apps/web/src/components/header/user_account_menu/index.tsx:201
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:109
#: apps/web/src/features/dashboard/dashboardLabels.ts:28
#: packages/ui-kit/src/feature/order_entry/constants.ts:49
msgid "Fees"
msgstr "Fees"

#. Fee schedule note in account menu: the rates shown are per trade, charged on open and again on close
#: apps/web/src/components/header/user_account_menu/fees_panel.tsx:166
msgid "Fees apply on open and again on close. <0>Docs</0>"
msgstr "Fees apply on open and again on close. <0>Docs</0>"

#. Fee schedule note in account menu
#: apps/web/src/components/header/user_account_menu/fees_panel.tsx:173
msgid "Fees apply on open only, not on close. <0>Docs</0>"
msgstr "Fees apply on open only, not on close. <0>Docs</0>"

#. Close dialog: explains that fees were charged at open, not on close
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:87
msgid "Fees are charged on open but settled against your realized PnL when you close. There is no closing fee."
msgstr "Fees are charged on open but settled against your realized PnL when you close. There is no closing fee."

#. Order form fees tooltip: closing fees
#: packages/ui-kit/src/feature/order_entry/constants.ts:66
#~ msgid "Fees charged when closing this position (maker / taker)."
#~ msgstr "Fees charged when closing this position (maker / taker)."

#. Order form fees tooltip: opening fees
#: packages/ui-kit/src/feature/order_entry/constants.ts:59
#~ msgid "Fees charged when opening this position (maker / taker)."
#~ msgstr "Fees charged when opening this position (maker / taker)."

#. Referral history column header
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:231
msgid "Fees Paid"
msgstr "Fees Paid"

#. Order form fees tooltip: the rate shown is for one trade; it is charged on open and again on close
#: packages/ui-kit/src/feature/order_entry/constants.ts:50
msgid "Fees per trade, shown as maker / taker. You pay them when you open a position and again when you close it. Maker fees apply when your order adds liquidity; taker fees apply when it removes liquidity."
msgstr "Fees per trade, shown as maker / taker. You pay them when you open a position and again when you close it. Maker fees apply when your order adds liquidity; taker fees apply when it removes liquidity."

#. Builders leaderboard Builder Fees column header tooltip
#: apps/web/src/features/builders/components/useBuilderColumns.tsx:95
msgid "Fees this builder earned over the period."
msgstr "Fees this builder earned over the period."

#. Fees view title in account menu with user tier
#. Open fee tiers panel in account menu with user tier
#: apps/web/src/components/header/user_account_menu/account_balance_summary.tsx:113
#: apps/web/src/components/header/user_account_menu/index.tsx:200
msgid "Fees Tier {feeTierLabel}"
msgstr "Fees Tier {feeTierLabel}"

#. Fill Or Kill
#: packages/ui-kit/src/feature/order_entry/form/tif.tsx:40
msgid "Fill Or Kill"
msgstr "Fill Or Kill"

#. Table header: Fill Price
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:75
msgid "Fill Price"
msgstr "Fill Price"

#. Table header: Filled Size
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:113
msgid "Filled Size"
msgstr "Filled Size"

#. Preferences: custom slippage help text
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:187
msgid "Fills up to this limit, then cancels any remainder."
msgstr "Fills up to this limit, then cancels any remainder."

#. Table filter menu button
#: packages/ui-kit/src/components/table/filter/custom_menu_filter.tsx:45
msgid "Filter"
msgstr "Filter"

#. Table header button: opens the coin filter checklist
#: packages/ui-kit/src/feature/terminal_tables/shared/MarketColumnFilter.tsx:100
msgid "Filter by coin"
msgstr "Filter by coin"

#: apps/web/src/features/tournament/components/standing-shared.tsx:99
msgid "Final"
msgstr "Final"

#: apps/web/src/features/tournament/components/leaderboard.tsx:114
msgid "Final order may change"
msgstr "Final order may change"

#: apps/web/src/features/tournament/components/leaderboard.tsx:109
msgid "Final standings"
msgstr "Final standings"

#: apps/web/src/features/tournament/components/countdown-card.tsx:194
msgid "Final standings will be posted within 1 week."
msgstr "Final standings will be posted within 1 week."

#: apps/web/src/features/tournament/components/competition-card.tsx:97
msgid "Finalising"
msgstr "Finalising"

#. P&L history event label: position flipped to the opposite side
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:38
msgid "Flip"
msgstr "Flip"

#. Mobile position card: reverse (flip) position button
#: packages/ui-kit/src/feature/terminal_tables/position/positions_table.tsx:110
msgctxt "action"
msgid "Flip"
msgstr "Flip"

#. Flip dialog title, e.g. "Flip BTC Position"
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:21
msgid "Flip {ticker} Position"
msgstr "Flip {ticker} Position"

#. Flip dialog: acknowledge a possible partial fill
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:195
#~ msgid "Flip anyway — the order may fill only partially"
#~ msgstr "Flip anyway — the order may fill only partially"

#. Positions row action tooltip: reverse to the opposite side
#: packages/ui-kit/src/feature/terminal_tables/position/positions_columns.tsx:185
msgid "Flip position"
msgstr "Flip position"

#. Flip dialog: confirm button
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:150
msgid "Flip Position"
msgstr "Flip Position"

#. Partner dashboard stats section title
#: apps/web/src/features/referral/components/partner/partner-stats.tsx:134
msgid "From Your Referrals"
msgstr "From Your Referrals"

#. Fund account menu title
#: apps/web/src/components/header/fund_account_menu/index.tsx:61
#~ msgid "Fund Account"
#~ msgstr "Fund Account"

#. Account history operation
#. Market info table funding rate column
#: packages/ui-kit/src/feature/market_info/market_menu/market_menu_table.tsx:281
#: packages/ui-kit/src/feature/terminal_tables/account_history/constants.ts:35
msgid "Funding"
msgstr "Funding"

#. Table header: Funding (accrued)
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:105
msgid "Funding (accrued)"
msgstr "Funding (accrued)"

#. Table header: Funding (realized)
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:106
msgid "Funding (realized)"
msgstr "Funding (realized)"

#. Coin info funding countdown
#: packages/ui-kit/src/feature/market_info/coin_info/market_metrics.tsx:139
msgid "Funding / Countdown"
msgstr "Funding / Countdown"

#. Table header tooltip: Funding (accrued)
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:119
msgid "Funding accrued on this position so far. It settles to your balance or position deposit when you modify the position."
msgstr "Funding accrued on this position so far. It settles to your balance or position deposit when you modify the position."

#. Funding rates page: heatmap card title
#: apps/web/src/features/funding-map/FundingHeatmapCard.tsx:119
msgid "Funding across markets"
msgstr "Funding across markets"

#. Funding rates table column header: max positive / max negative rate per funding event
#: apps/web/src/features/funding_rates/funding_rates.tsx:166
msgid "Funding Cap / Floor"
msgstr "Funding Cap / Floor"

#. Funding rates table column header: max positive / max negative rate per event
#. Table header tooltip: Funding
#: apps/web/src/features/funding_rates/funding_rates.tsx:124
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:90
#~ msgid "Funding distributions are made when the position is settled or its size changes. This affects final PNL"
#~ msgstr "Funding distributions are made when the position is settled or its size changes. This affects final PNL"

#. Funding rates page: heatmap card subtitle
#: apps/web/src/features/funding-map/FundingHeatmapCard.tsx:122
msgid "Funding for every Perpl market, one cell per funding event. Persistent colour is carry worth having; noise that flips every few hours is not."
msgstr "Funding for every Perpl market, one cell per funding event. Persistent colour is carry worth having; noise that flips every few hours is not."

#. Tab title: Funding History
#. Tab title: Funding History
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:268
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/pnl_history.tsx:143
msgid "Funding History"
msgstr "Funding History"

#. Account tab render error
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:326
msgid "Funding History failed to render."
msgstr "Funding History failed to render."

#. Funding history popover interval note with block count
#: packages/ui-kit/src/feature/market_info/funding_history_popover.tsx:127
#~ msgid "Funding is applied every {blocks} blocks (≈ {minutes} min)"
#~ msgstr "Funding is applied every {blocks} blocks (≈ {minutes} min)"

#. Funding history popover interval note; the block count drives the plural form
#: packages/ui-kit/src/feature/market_info/funding_history_popover.tsx:127
msgid "Funding is applied every {fundingIntervalBlocks, plural, one {# block} other {# blocks}} (≈ {minutes} min)"
msgstr "Funding is applied every {fundingIntervalBlocks, plural, one {# block} other {# blocks}} (≈ {minutes} min)"

#. Funding history popover interval note without block count
#: packages/ui-kit/src/feature/market_info/funding_history_popover.tsx:132
msgid "Funding is applied in block intervals"
msgstr "Funding is applied in block intervals"

#. Funding rates page subtitle: plain-language explanation of what funding is
#: apps/web/src/features/funding_rates/funding_rates.tsx:193
msgid "Funding keeps perp prices anchored to the oracle price, based on how far the order book sits above or below it. Positive rates mean longs pay shorts; negative rates mean shorts pay longs. <0>Read more</0>"
msgstr "Funding keeps perp prices anchored to the oracle price, based on how far the order book sits above or below it. Positive rates mean longs pay shorts; negative rates mean shorts pay longs. <0>Read more</0>"

#. Table header tooltip: Funding (realized)
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:126
msgid "Funding posts when you reduce, close, or increase a position. Check accrued funding on your open position in the meantime."
msgstr "Funding posts when you reduce, close, or increase a position. Check accrued funding on your open position in the meantime."

#. Funding rates table column header
#: apps/web/src/features/funding_rates/funding_rates.tsx:158
msgid "Funding Rate"
msgstr "Funding Rate"

#. Funding rates page: the funding formula. Keep the math notation; translate only the words ("Average Premium Index", "Cap").
#: apps/web/src/features/funding_rates/funding_rates.tsx:191
#~ msgid "Funding Rate = clamp(Average Premium Index, -Cap, +Cap)"
#~ msgstr "Funding Rate = clamp(Average Premium Index, -Cap, +Cap)"

#. Funding history popover title
#: packages/ui-kit/src/feature/market_info/funding_history_popover.tsx:117
msgid "Funding Rate History"
msgstr "Funding Rate History"

#. Empty state message for funding rate history table
#: packages/ui-kit/src/feature/terminal_tables/funding_history/funding_history.tsx:42
#~ msgid "Funding rate history will appear here"
#~ msgstr "Funding rate history will appear here"

#. Header nav item
#: apps/web/src/components/header/constants.ts:122
msgid "Funding Rates"
msgstr "Funding Rates"

#. Funding history table note: when funding settles
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/funding_events.tsx:9
msgid "Funding settles when you reduce, close or increase a position, not at each funding interval."
msgstr "Funding settles when you reduce, close or increase a position, not at each funding interval."

#. Portfolio account overview label
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:204
msgid "Funds Available"
msgstr "Funds Available"

#. Portfolio Funds Available tooltip
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:206
msgid "Funds not locked in open orders.\n"
"Account balance minus locked balance."
msgstr "Funds not locked in open orders.\n"
"Account balance minus locked balance."

#: apps/web/src/features/account/components/withdraw_panel.tsx:115
msgid "Funds will be withdrawn from the exchange and sent to the delegated account owner."
msgstr "Funds will be withdrawn from the exchange and sent to the delegated account owner."

#. Label gain percent input
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/fields/tp_sl_input_section.tsx:138
msgid "Gain"
msgstr "Gain"

#. Native gas balance row
#: apps/web/src/components/header/user_account_menu/account_balance_summary.tsx:189
msgid "Gas"
msgstr "Gas"

#. Dashboard chart: Mgas per second, Perpl vs Monad
#: apps/web/src/features/dashboard/dashboardLabels.ts:38
msgid "Gas (Mgas/s)"
msgstr "Gas (Mgas/s)"

#. Renew referral code confirmation body
#: apps/web/src/features/referral/hooks/useRefCodeRenewal.ts:106
msgid "Generating a new code will invalidate your current code. Anyone who hasn't used it yet will no longer be able to join with it. Continue?"
msgstr "Generating a new code will invalidate your current code. Anyone who hasn't used it yet will no longer be able to join with it. Continue?"

#. Good unTil Cancel
#: packages/ui-kit/src/feature/order_entry/form/tif.tsx:30
msgid "Good ’Til Cancel"
msgstr "Good ’Til Cancel"

#. Market making table: tooltip on the maker, taker and total fee column headers
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:72
msgid "Gross fees paid, including builder fees. Maker rebates are not deducted."
msgstr "Gross fees paid, including builder fees. Maker rebates are not deducted."

#. Tools menu docs description
#: apps/web/src/components/header/tools_menu/config.tsx:48
msgid "Guides and API reference"
msgstr "Guides and API reference"

#. Countdown hours unit (single letter)
#: apps/web/src/features/mpoints/components/hero-banner/hero-banner.tsx:128
#~ msgid "H"
#~ msgstr "H"

#. Countdown hours unit (single letter)
#: apps/web/src/features/mpoints/components/hero-banner/hero-banner.tsx:132
msgctxt "countdown unit"
msgid "H"
msgstr "H"

#. Preferences drawer help link
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:433
msgid "Help"
msgstr "Help"

#. Partner dashboard greeting with the partner's display name
#: apps/web/src/features/referral/components/partner/partner-hero-card.tsx:181
msgid "Hi, {name}"
msgstr "Hi, {name}"

#: apps/web/src/features/tournament/components/standing-card.tsx:135
msgid "Hold your spot"
msgstr "Hold your spot"

#: apps/web/src/features/leaderboard/components/dialog/badges_dialog.tsx:97
msgid "Holders carry their badge permanently – a record of being here first."
msgstr "Holders carry their badge permanently – a record of being here first."

#. Dashboard chart: hourly Perpl transactions
#: apps/web/src/features/dashboard/dashboardLabels.ts:32
msgid "Hourly Transactions"
msgstr "Hourly Transactions"

#. Table header tooltip: Liquidation Buffer
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:82
msgid "How far the mark price can move before this position is liquidated. Add collateral to increase your buffer."
msgstr "How far the mark price can move before this position is liquidated. Add collateral to increase your buffer."

#. Alert link: leverage docs
#: packages/ui-kit/src/feature/order_entry/form/account_leverage.tsx:209
msgid "How leverage and liquidation work on Perpl →"
msgstr "How leverage and liquidation work on Perpl →"

#. Preferences: liquidation alerts info icon
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:394
msgid "How liquidation alerts work"
msgstr "How liquidation alerts work"

#. Portfolio Margin Usage tooltip
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:219
msgid "How much of your equity is tied up in open positions and resting orders.\n"
"100% means nothing is free to open a new position with."
msgstr "How much of your equity is tied up in open positions and resting orders.\n"
"100% means nothing is free to open a new position with."

#. Portfolio Margin Usage tooltip
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:195
#~ msgid "How much of your position margin is consumed by maintenance requirements.\n"
#~ "Weighted average across positions: (maintenance margin requirement − unrealized PnL) / margin.\n"
#~ "MMR is based on entry price, size, and the market's maintenance margin fraction."
#~ msgstr "How much of your position margin is consumed by maintenance requirements.\n"
#~ "Weighted average across positions: (maintenance margin requirement − unrealized PnL) / margin.\n"
#~ "MMR is based on entry price, size, and the market's maintenance margin fraction."

#: apps/web/src/features/points/components/countdown-card.tsx:50
#: apps/web/src/features/tournament/components/countdown-card.tsx:135
msgid "Hrs"
msgstr "Hrs"

#. Share tweet body for a weekly mPoints card. The trader posts this about themselves and we do not know their gender, so if a first-person verb carries gender in your language, rewrite it as a nominal phrase (e.g. "My mPoints this week: {points}, place #{rank}").
#: apps/web/src/features/mpoints/components/share-points-dialog/hooks/usePointsShareActions.ts:120
msgid "I earned {points} mPoints this week, ranked #{rank} 🔥"
msgstr "I earned {points} mPoints this week, ranked #{rank} 🔥"

#. Share tweet body for a season-total mPoints card. The trader posts this about themselves and we do not know their gender, so if a first-person verb carries gender in your language, rewrite it as a nominal phrase (e.g. "My mPoints: {points}, place #{rank}").
#: apps/web/src/features/mpoints/components/share-points-dialog/hooks/usePointsShareActions.ts:125
msgid "I earned {points} mPoints, ranked #{rank} 🔥"
msgstr "I earned {points} mPoints, ranked #{rank} 🔥"

#. Share tweet body for a weekly Perpl Points card. The trader posts this about themselves and we do not know their gender, so if a first-person verb carries gender in your language, rewrite it as a nominal phrase (e.g. "My Perpl Points this week: {points}, place #{rank}").
#: apps/web/src/features/mpoints/components/share-points-dialog/hooks/usePointsShareActions.ts:131
msgid "I earned {points} Perpl Points this week, ranked #{rank} 🔥"
msgstr "I earned {points} Perpl Points this week, ranked #{rank} 🔥"

#. Share tweet body for a total Perpl Points card. The trader posts this about themselves and we do not know their gender, so if a first-person verb carries gender in your language, rewrite it as a nominal phrase (e.g. "My Perpl Points: {points}, place #{rank}").
#: apps/web/src/features/mpoints/components/share-points-dialog/hooks/usePointsShareActions.ts:136
msgid "I earned {points} Perpl Points, ranked #{rank} 🔥"
msgstr "I earned {points} Perpl Points, ranked #{rank} 🔥"

#. Indexing-delay alert: link to the standalone rescue tool
#: apps/web/src/features/terminal/pro_layout.tsx:66
msgid "If the delay persists and you need to manage positions, you can use <0>Perpl Rescue</0>. Follow our Discord and X for updates."
msgstr "If the delay persists and you need to manage positions, you can use <0>Perpl Rescue</0>. Follow our Discord and X for updates."

#. Add referral code dialog body
#: apps/web/src/features/referral/components/referred-by.tsx:150
msgid "If you have a referral code, enter it below.<0/>You will earn a boost on Perpl Points and mPoints."
msgstr "If you have a referral code, enter it below.<0/>You will earn a boost on Perpl Points and mPoints."

#. Immediate Or Cancel
#: packages/ui-kit/src/feature/order_entry/form/tif.tsx:35
msgid "Immediate Or Cancel"
msgstr "Immediate Or Cancel"

#. Market order fill prognosis: cost driven mainly by order size vs book depth
#: packages/ui-kit/src/feature/order_entry/form/market_fill_prognosis.tsx:160
msgid "Impact driven by order size."
msgstr "Impact driven by order size."

#. Market order fill prognosis: cost driven mainly by the bid-ask spread
#: packages/ui-kit/src/feature/order_entry/form/market_fill_prognosis.tsx:155
msgid "Impact driven by the spread."
msgstr "Impact driven by the spread."

#: apps/web/src/hooks/useOntarioBanAnnouncement.ts:39
#~ msgid "Important notice for Ontario users"
#~ msgstr "Important notice for Ontario users"

#: apps/web/src/hooks/useGeoBlockAnnouncement.ts:43
msgid "Important notice for users in {country}"
msgstr "Important notice for users in {country}"

#: apps/web/src/components/summer-banner/summer-banner.tsx:61
#: apps/web/src/features/mpoints/components/hero-banner/hero-banner.tsx:169
msgid "in MON"
msgstr "in MON"

#. Second half of the banner headline, set smaller and baseline-aligned after a currency amount: "$1,000,000 · in MON rewards unlocked!". Word it so it reads correctly directly after the amount; drop or reorder words if your language needs it.
#: apps/web/src/components/summer-banner/million-banner.tsx:48
msgid "in MON rewards unlocked!"
msgstr "in MON rewards unlocked!"

#: apps/web/src/features/tournament/components/standing-shared.tsx:124
msgid "In the money"
msgstr "In the money"

#. Referees filter option
#. Referral history volume badge — slot returned
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:157
#: apps/web/src/features/referral/components/referrals-history/referrals-history.tsx:58
msgid "Inactive"
msgstr "Inactive"

#. CSV export dialog: scope of the file
#: packages/ui-kit/src/feature/terminal_tables/csv_export/ExportCsvDialog.tsx:272
msgid "Includes all markets. Times in the file are UTC."
msgstr "Includes all markets. Times in the file are UTC."

#. Tooltip on Your Rewards column header
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:278
msgid "Includes fee rebates from each referee's sub-referrals."
msgstr "Includes fee rebates from each referee's sub-referrals."

#. Close dialog: realized PnL is shown net of fees
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:167
msgid "Includes fees"
msgstr "Includes fees"

#. Close dialog: realized PnL is net of fees; a limit close assumes the maker fee
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:168
#~ msgid "Includes fees, assuming the maker fee for the limit close."
#~ msgstr "Includes fees, assuming the maker fee for the limit close."

#. Close dialog: realized PnL is net of both legs' fees; a limit close assumes the maker fee
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:169
msgid "Includes the opening fee and the estimated closing fee, assuming the maker fee for the limit close."
msgstr "Includes the opening fee and the estimated closing fee, assuming the maker fee for the limit close."

#. Close dialog: realized PnL is net of both legs' fees (the fee row shows only the closing one)
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:173
msgid "Includes the opening fee and the estimated closing fee."
msgstr "Includes the opening fee and the estimated closing fee."

#. P&L history event label: position size increased
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:28
msgid "Increase"
msgstr "Increase"

#. Funding history popover header: Index Price
#: packages/ui-kit/src/feature/market_info/funding_history_popover.tsx:157
msgid "Index Price"
msgstr "Index Price"

#. Footer connection status; {lag} is a block count
#: packages/ui-kit/src/common/heartbeatStore.ts:21
#~ msgid "Indexing ({lag} blocks behind)"
#~ msgstr "Indexing ({lag} blocks behind)"

#. Dashboard chart legend: deposits
#: apps/web/src/features/dashboard/dashboard.tsx:79
#~ msgid "Inflows"
#~ msgstr "Inflows"

#: packages/ui-kit/src/feature/terminal_tables/position/positions_columns.tsx:39
msgid "Initial leverage"
msgstr "Initial leverage"

#: apps/web/src/features/auth/components/access_steps.tsx:72
msgid "Input access code"
msgstr "Input access code"

#. Referral code field placeholder
#: apps/web/src/features/referral/components/referred-by.tsx:164
msgid "Input referral code"
msgstr "Input referral code"

#. Dashboard chart legend: insurance fund fees
#: apps/web/src/features/dashboard/dashboardLabels.ts:17
msgid "Insurance"
msgstr "Insurance"

#. Liquidation split: insurance fund share
#: packages/ui-kit/src/feature/terminal_tables/LiquidationDistributionTooltip.tsx:30
msgid "Insurance fund"
msgstr "Insurance fund"

#. P&L history event label: settlement shortfall covered by the insurance fund
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:57
msgid "Insurance Settlement"
msgstr "Insurance Settlement"

#. Preferences: interface section title
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:198
msgid "Interface"
msgstr "Interface"

#. Preferences: interface font select
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:199
msgid "Interface Font"
msgstr "Interface Font"

#. Funding rates table column header: funding interval, e.g. 1h
#: apps/web/src/features/funding_rates/funding_rates.tsx:137
msgid "Interval"
msgstr "Interval"

#: apps/web/src/features/auth/components/access_request_dialog.tsx:93
msgid "Invalid Access Code"
msgstr "Invalid Access Code"

#. Rewards menu Referrals item description
#: apps/web/src/components/header/rewards_menu/config.tsx:70
msgid "Invite traders, earn fees"
msgstr "Invite traders, earn fees"

#. API key table column
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:135
msgid "IP restrictions"
msgstr "IP restrictions"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:156
msgid "IP restrictions (optional)"
msgstr "IP restrictions (optional)"

#. Rule-flanked line rendered directly under the "{name} Tournament" title, completing it: "<Name> Tournament / — is over —". Translate as the predicate that agrees with however you rendered that title.
#: apps/web/src/features/tournament/components/finalising-dialog.tsx:138
msgid "is over"
msgstr "is over"

#. Isolated margin label. One of two labels in a narrow two-button toggle, beside "Cross" — keep both the same part of speech and roughly the same length; abbreviate if the word is long in your language (the positions table already uses a short form).
#. Isolated margin label. One of two labels in a narrow two-button toggle, beside "Cross" — keep both the same part of speech and roughly the same length; abbreviate if the word is long in your language (the positions table already uses a short form).
#: packages/ui-kit/src/feature/order_entry/margin_switch/margin_switch.tsx:69
#: packages/ui-kit/src/feature/order_entry/margin_switch/margin_switch.tsx:77
msgid "Isolated"
msgstr "Isolated"

#: apps/web/src/features/auth/components/access_request_dialog.tsx:151
msgid "Join Perpl"
msgstr "Join Perpl"

#. Tooltip on a referee address showing how long ago that person joined. Their gender is unknown, so if the past tense carries gender in your language, rewrite as a nominal phrase (e.g. "Joined: today").
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:63
msgid "Joined today"
msgstr "Joined today"

#: apps/web/src/features/tournament/hooks/useStandings.ts:112
#: apps/web/src/features/tournament/hooks/useStandings.ts:159
msgid "Keep climbing — {days} left"
msgstr "Keep climbing — {days} left"

#. API key table column
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:61
msgid "Key"
msgstr "Key"

#. Dialog title
#: apps/web/src/features/shortcuts/keyboard_shortcuts_dialog.tsx:37
msgid "Keyboard Shortcuts"
msgstr "Keyboard Shortcuts"

#. API key name field
#. API key table column
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:54
#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:113
msgid "Label"
msgstr "Label"

#. Accessible name of the header language picker
#. Label of the language picker in the preferences drawer
#. Mobile drawer row opening the language list
#: apps/web/src/components/header/language_menu.tsx:77
#: apps/web/src/components/header/language_menu.tsx:136
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:105
msgid "Language"
msgstr "Language"

#. Funding heatmap tooltip: the 24h summary column
#: apps/web/src/features/funding-map/HeatmapTooltip.tsx:70
msgid "Last 24h"
msgstr "Last 24h"

#. Filter: Last 30 Days
#: packages/ui-kit/src/components/table/filter/date_range.tsx:102
msgid "Last 30 Days"
msgstr "Last 30 Days"

#. Filter: Last 7 Days
#: packages/ui-kit/src/components/table/filter/date_range.tsx:101
msgid "Last 7 Days"
msgstr "Last 7 Days"

#. Points last epoch emission row
#. mPoints last epoch earned row
#: apps/web/src/components/header/rewards_menu/panels.tsx:171
#: apps/web/src/components/header/rewards_menu/panels.tsx:220
msgid "Last epoch"
msgstr "Last epoch"

#. Market info table last price
#: packages/ui-kit/src/feature/market_info/market_menu/market_menu_table.tsx:268
msgid "Last Price"
msgstr "Last Price"

#. API key table column
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:163
msgid "Last used"
msgstr "Last used"

#. Filter: Last Year
#: packages/ui-kit/src/components/table/filter/date_range.tsx:104
msgid "Last Year"
msgstr "Last Year"

#. Tools menu changelog description
#: apps/web/src/components/header/tools_menu/config.tsx:44
msgid "Latest releases and fixes"
msgstr "Latest releases and fixes"

#. Builders page section heading
#. Header nav item
#: apps/web/src/components/header/constants.ts:114
#: apps/web/src/features/builders/builders.tsx:79
#: apps/web/src/features/leaderboard/leaderboard.tsx:19
msgid "Leaderboard"
msgstr "Leaderboard"

#: apps/web/src/features/points/components/total-emitted.tsx:28
msgid "Learn more"
msgstr "Learn more"

#: apps/web/src/features/builders/builderDashboard.tsx:308
#: apps/web/src/features/builders/builders.tsx:54
msgid "Learn more."
msgstr "Learn more."

#. Preferences: chart layout left
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:200
msgctxt "chart layout side"
msgid "Left"
msgstr "Left"

#. Adjust margin dialog: label for leverage row
#: apps/web/src/features/trading/adjust_margin_dialog/MarginInfoRows.tsx:36
msgid "Leverage"
msgstr "Leverage"

#. Limit order type
#. Limit order type
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:181
#: packages/ui-kit/src/feature/order_entry/form/order_type_bar.tsx:182
msgid "Limit"
msgstr "Limit"

#. Picture-in-picture orders empty subtitle
#: apps/web/src/features/picture_in_picture/components/OrdersList.tsx:29
msgid "Limit and stop orders waiting to fill will appear here."
msgstr "Limit and stop orders waiting to fill will appear here."

#. Close-all dialog: limit close option
#: apps/web/src/features/account/close_position_dialog/CloseAllContent.tsx:78
msgid "Limit Close at Mid Price"
msgstr "Limit Close at Mid Price"

#. Chart overlay preference
#: apps/web/src/components/header/user_settings/preferences-drawer/chart_overlay_preference_section.tsx:16
msgid "Limit orders"
msgstr "Limit orders"

#. Close dialog: limit price field label
#. Close dialog: limit price toggle
#: apps/web/src/features/account/close_position_dialog/SinglePositionContent.tsx:200
#: apps/web/src/features/account/close_position_dialog/SinglePositionContent.tsx:206
msgid "Limit Price"
msgstr "Limit Price"

#. Configure Limit stop loss checkbox
#. Label SL limit price input
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/fields/tp_sl_input_section.tsx:149
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/fields/tp_sl_input_section.tsx:150
msgid "Limit SL Price"
msgstr "Limit SL Price"

#. Configure Limit take profit checkbox
#. Label limit price input
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/fields/tp_sl_input_section.tsx:139
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/fields/tp_sl_input_section.tsx:140
msgid "Limit TP Price"
msgstr "Limit TP Price"

#. Table header: Liquidation Buffer
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:80
msgid "Liq. Buffer"
msgstr "Liq. Buffer"

#. PiP metric liq price
#: apps/web/src/features/picture_in_picture/components/PositionRow.tsx:146
msgid "Liq. price"
msgstr "Liq. price"

#. Table header: Liquidation Price
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:79
msgid "Liq. Price"
msgstr "Liq. Price"

#. Chip label on a liquidated P&L history row
#. P&L history filter option: liquidated only
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/LiquidatedChip.tsx:22
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/pnl_history.tsx:91
msgid "Liquidated"
msgstr "Liquidated"

#. Account history operation
#. Custom filter: Liquidation
#. P&L history event fallback label: liquidated
#. P&L history event label: position liquidated
#: packages/ui-kit/src/feature/terminal_tables/account_history/constants.ts:29
#: packages/ui-kit/src/feature/terminal_tables/account_history/useFilterOptions.tsx:36
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:40
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:74
msgid "Liquidation"
msgstr "Liquidation"

#. Preferences: liquidation alerts section title
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:191
msgid "Liquidation Alerts"
msgstr "Liquidation Alerts"

#. P&L history event label: remaining equity credited after liquidation
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:42
msgid "Liquidation Credit"
msgstr "Liquidation Credit"

#. Adjust margin dialog: label for liquidation level row
#: apps/web/src/features/trading/adjust_margin_dialog/MarginInfoRows.tsx:44
msgid "Liquidation level"
msgstr "Liquidation level"

#. Order form summary row label
#: packages/ui-kit/src/feature/order_entry/constants.ts:23
msgid "Liquidation Price"
msgstr "Liquidation Price"

#. Portfolio account overview label
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:39
msgid "Liquidation Risk"
msgstr "Liquidation Risk"

#. Dashboard chart: daily count of liquidated positions
#: apps/web/src/features/dashboard/dashboardLabels.ts:29
msgid "Liquidations"
msgstr "Liquidations"

#. Builder payout status: epoch still running
#. Live status pill
#. Reward status: live
#. Rewards filter option
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:41
#: apps/web/src/features/referral/components/live-chip.tsx:25
#: apps/web/src/features/referral/components/referrals-history/referrals-history.tsx:79
#: apps/web/src/features/referral/components/referrals-history/rewards-columns.tsx:19
#: apps/web/src/features/tournament/components/competition-card.tsx:95
#: apps/web/src/features/tournament/components/countdown-card.tsx:154
msgid "Live"
msgstr "Live"

#. Tools menu funding rates description
#: apps/web/src/components/header/tools_menu/config.tsx:32
msgid "Live funding rates across markets"
msgstr "Live funding rates across markets"

#: apps/web/src/features/mpoints/components/hero-banner/reward-steps.tsx:77
msgid "Locked"
msgstr "Locked"

#. placeholder {0}: token.symbol
#: apps/web/src/features/account/components/account_panel.tsx:155
msgid "Locked ({0})"
msgstr "Locked ({0})"

#. Disconnect wallet button in account menu
#: apps/web/src/components/header/user_account_menu/account_menu_overview.tsx:53
msgid "Log out"
msgstr "Log out"

#. Custom filter: Long
#. Keyboard shortcut action: switch the order form to Long
#. Trade side Long label
#. Trade side Long label
#: apps/web/src/features/shortcuts/shortcuts.ts:35
#: packages/ui-kit/src/feature/order_entry/side_switch/side_switch.tsx:37
#: packages/ui-kit/src/feature/order_entry/side_switch/side_switch.tsx:39
#: packages/ui-kit/src/feature/terminal_tables/shared/getSideFilterOptions.tsx:17
msgid "Long"
msgstr "Long"

#. Funding heatmap tooltip: funding paid at one event or over 24h, per reference position size. e.g. "$0.40 per $10K"
#: apps/web/src/features/funding-map/HeatmapTooltip.tsx:49
msgid "Longs paid shorts {amount} per {notional}"
msgstr "Longs paid shorts {amount} per {notional}"

#. Funding heatmap legend: positive rate
#: apps/web/src/features/funding-map/FundingHeatmapCard.tsx:111
msgid "Longs pay shorts"
msgstr "Longs pay shorts"

#. Label loss percent input
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/fields/tp_sl_input_section.tsx:148
msgid "Loss"
msgstr "Loss"

#. Countdown minutes unit (single letter)
#: apps/web/src/features/mpoints/components/hero-banner/hero-banner.tsx:132
#~ msgid "M"
#~ msgstr "M"

#. Countdown minutes unit (single letter)
#: apps/web/src/features/mpoints/components/hero-banner/hero-banner.tsx:140
msgctxt "countdown unit"
msgid "M"
msgstr "M"

#. Dashboard chart legend: maker fees
#. Fee table column: maker fee in bps (compact)
#: apps/web/src/components/header/user_account_menu/fees_panel.tsx:143
#: apps/web/src/features/dashboard/dashboardLabels.ts:15
msgid "Maker"
msgstr "Maker"

#: packages/ui-kit/src/components/dialogs/fee_tiers_dialog.tsx:144
msgid "Maker (bps)"
msgstr "Maker (bps)"

#. Market making table header
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:111
msgid "Maker Fees"
msgstr "Maker Fees"

#. Market making table header: number of maker fills
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:114
msgid "Maker Fills"
msgstr "Maker Fills"

#: apps/web/src/components/header/user_account_menu/fees_panel.tsx:26
#: packages/ui-kit/src/components/dialogs/fee_tiers_dialog.tsx:22
msgid "Maker rebate: you are paid this amount instead of paying a fee. Rebates are applied off-chain and paid out separately, so they arrive with a delay rather than on each fill."
msgstr "Maker rebate: you are paid this amount instead of paying a fee. Rebates are applied off-chain and paid out separately, so they arrive with a delay rather than on each fill."

#. Market making table header
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:108
msgid "Maker Volume"
msgstr "Maker Volume"

#. Limit order form: maker-volume mPoints boost campaign notice
#: packages/ui-kit/src/feature/order_entry/form/maker_boost_alert.tsx:47
msgid "Maker volume earns extra mPoints."
msgstr "Maker volume earns extra mPoints."

#. Tools menu API keys description
#: apps/web/src/components/header/tools_menu/config.tsx:40
msgid "Manage exchange API keys"
msgstr "Manage exchange API keys"

#. Mobile position card: adjust margin button
#. Table header: Margin
#: packages/ui-kit/src/feature/terminal_tables/position/positions_table.tsx:109
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:104
msgid "Margin"
msgstr "Margin"

#. Adjust margin dialog: label for available margin row
#: apps/web/src/features/trading/adjust_margin_dialog/MarginInfoRows.tsx:22
msgid "Margin available to add"
msgstr "Margin available to add"

#. Portfolio 10% stress test tooltip
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:257
msgid "Margin held in positions that a 10% adverse price move would liquidate.\n"
"This includes everything counted in the 5% row. It is collateral at risk, not a loss estimate, so it can exceed your equity when positions are down."
msgstr "Margin held in positions that a 10% adverse price move would liquidate.\n"
"This includes everything counted in the 5% row. It is collateral at risk, not a loss estimate, so it can exceed your equity when positions are down."

#. Portfolio 5% stress test tooltip
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:248
msgid "Margin held in positions that a 5% adverse price move would liquidate.\n"
"Anything inside 5% is also inside 10%, so both rows show the same total when every position is already this close."
msgstr "Margin held in positions that a 5% adverse price move would liquidate.\n"
"Anything inside 5% is also inside 10%, so both rows show the same total when every position is already this close."

#. Order form summary row label
#: packages/ui-kit/src/feature/order_entry/constants.ts:38
msgid "Margin Required"
msgstr "Margin Required"

#. Margin type switch toggle
#: packages/ui-kit/src/feature/order_entry/margin_switch/margin_switch.tsx:63
msgid "Margin type switch"
msgstr "Margin type switch"

#. Portfolio account overview label
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:212
msgid "Margin Usage"
msgstr "Margin Usage"

#. Coin info mark price
#: packages/ui-kit/src/feature/market_info/coin_info/market_metrics.tsx:112
msgid "Mark"
msgstr "Mark"

#. Label of Mark Price
#. Table header: Mark Price
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:78
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/tp_sl_modal.tsx:168
msgid "Mark Price"
msgstr "Mark Price"

#. Funding rates table column header: market name, e.g. BTC-USD
#. Market order type
#. Market order type
#. Picture-in-picture market order price label
#. Table cell: Market
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:180
#: apps/web/src/features/funding_rates/funding_rates.tsx:131
#: apps/web/src/features/picture_in_picture/components/OrderRow.tsx:107
#: packages/ui-kit/src/feature/order_entry/form/order_type_bar.tsx:176
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:237
msgid "Market"
msgstr "Market"

#. Preferences: trading panel toggle. Names the market-info panel (ticker, 24h change, funding, open interest) — the market itself, not the market order type that the uncontexted 'Market' translates.
#: apps/web/src/components/header/user_settings/preferences-drawer/terminal_panels_section.tsx:11
msgctxt "terminal panel"
msgid "Market"
msgstr "Market"

#. Keyboard shortcut action: toggle the order type between Market and Limit
#: apps/web/src/features/shortcuts/shortcuts.ts:47
msgid "Market / Limit"
msgstr "Market / Limit"

#. Close-all dialog: market close option
#: apps/web/src/features/account/close_position_dialog/CloseAllContent.tsx:74
msgid "Market Close"
msgstr "Market Close"

#. Connection status tooltip line; {lag} is a block count
#: packages/ui-kit/src/common/heartbeatStore.ts:31
#~ msgid "Market data {lag} blocks behind"
#~ msgstr "Market data {lag} blocks behind"

#. Connection status tooltip line
#: packages/ui-kit/src/common/heartbeatStore.ts:35
msgid "Market data connection error"
msgstr "Market data connection error"

#. Connection status tooltip line
#: packages/ui-kit/src/common/heartbeatStore.ts:37
msgid "Market data connection slow"
msgstr "Market data connection slow"

#. Connection status tooltip line
#: packages/ui-kit/src/common/heartbeatStore.ts:33
msgid "Market data disconnected"
msgstr "Market data disconnected"

#. Accessible name for the market depth chart
#: apps/web/src/features/order_book/market_depth/MarketDepthPanel.tsx:22
msgid "Market depth chart"
msgstr "Market depth chart"

#. Mobile market header: show or hide market stats
#: apps/web/src/features/markets/market_panel.tsx:57
msgid "Market details"
msgstr "Market details"

#. Market picker: market filter tabs
#: packages/ui-kit/src/feature/market_info/market_menu/market_menu_sheet.tsx:144
msgid "Market filters"
msgstr "Market filters"

#. Tab title: Market Making
#. Tab title: Market Making
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:276
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:197
msgid "Market Making"
msgstr "Market Making"

#. Account tab render error
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:335
msgid "Market Making failed to render."
msgstr "Market Making failed to render."

#. Market making table: stats request failed
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:163
#~ msgid "Market making stats failed to load"
#~ msgstr "Market making stats failed to load"

#. Flip dialog: the order that gets sent
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:163
msgid "Market Order"
msgstr "Market Order"

#. Market search input
#: packages/ui-kit/src/feature/market_info/market_menu/market_search_input.tsx:30
msgid "Market search"
msgstr "Market search"

#. Builders leaderboard column header: number of markets traded
#: apps/web/src/features/builders/components/useBuilderColumns.tsx:132
msgid "Markets"
msgstr "Markets"

#. Button that fills in the maximum available amount. Keep the Latin `MAX` — it is the conventional label on exchange amount inputs and the button is sized for three characters.
#: packages/ui-kit/src/components/input_field/token_input_field.tsx:81
msgid "MAX"
msgstr "MAX"

#. Custom slippage validation, shown under the input. Keep the Latin `Max` — it pairs with the `Min` variant and with the MAX / Mid buttons elsewhere in the order form.
#: packages/ui-kit/src/components/dialogs/slippage_selector.tsx:90
msgid "Max {percent}%"
msgstr "Max {percent}%"

#: apps/web/src/features/account/components/deposit_panel.tsx:145
msgid "Max balance to use is checked on delegated account smart contract, not connected wallet."
msgstr "Max balance to use is checked on delegated account smart contract, not connected wallet."

#. API key table column
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:114
msgid "Max builder fee"
msgstr "Max builder fee"

#. Flip dialog: max slippage cap. Keep the Latin `Max` — it pairs with the MAX / Mid / Min labels used across the order form.
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:149
#~ msgid "Max: {capText}"
#~ msgstr "Max: {capText}"

#. Close dialog: max slippage cap. Keep the Latin `Max` — it pairs with the MAX / Mid / Min labels used across the order form.
#. Flip dialog: max slippage cap. Keep the Latin `Max` — it pairs with the MAX / Mid / Min labels used across the order form.
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:54
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:127
msgid "Max: {max}"
msgstr "Max: {max}"

#. Adjust leverage modal: notice that this market's max leverage was raised above the previous baseline
#: packages/ui-kit/src/feature/order_entry/form/account_leverage.tsx:151
msgid "Maximum leverage increased from <0>{from}x → {to}x</0>."
msgstr "Maximum leverage increased from <0>{from}x → {to}x</0>."

#. Preferences: custom slippage heading
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:183
msgid "Maximum slippage for market orders"
msgstr "Maximum slippage for market orders"

#. Preferences: toast duration
#: apps/web/src/components/header/user_settings/preferences-drawer/notification_preference_section.tsx:52
msgid "Medium"
msgstr "Medium"

#. Referral history column header for memo
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:88
msgid "Memo"
msgstr "Memo"

#. Dashboard table column: metric name
#: apps/web/src/features/dashboard/dashboard.tsx:233
msgctxt "dashboard table"
msgid "Metric"
msgstr "Metric"

#. Button that fills in the order book mid price. Keep the Latin `Mid` — it is the conventional label on trading terminals and the button is sized for three characters.
#. Button that fills in the order book mid price. Keep the Latin `Mid` — it is the conventional label on trading terminals and the button is sized for three characters.
#: apps/web/src/features/trading/edit_order_dialog/index.tsx:99
#: packages/ui-kit/src/feature/order_entry/fields/price.tsx:60
msgid "Mid"
msgstr "Mid"

#. Custom slippage validation, shown under the input. Keep the Latin `Min` — it pairs with the `Max` variant and with the MAX / Mid buttons elsewhere in the order form.
#: packages/ui-kit/src/components/dialogs/slippage_selector.tsx:84
msgid "Min {percent}%"
msgstr "Min {percent}%"

#: apps/web/src/features/points/components/countdown-card.tsx:54
#: apps/web/src/features/tournament/components/countdown-card.tsx:136
msgid "Mins"
msgstr "Mins"

#. Dashboard chart: share of MON burned by Perpl vs rest of chain
#: apps/web/src/features/dashboard/dashboard.tsx:217
msgid "MON Burn Share"
msgstr "MON Burn Share"

#. Dashboard chart: daily MON burned
#: apps/web/src/features/dashboard/dashboardLabels.ts:39
msgid "MON Burned"
msgstr "MON Burned"

#. Dashboard chart legend: rest of Monad gas
#. Dashboard table column: whole Monad chain
#: apps/web/src/features/dashboard/dashboard.tsx:235
#: apps/web/src/features/dashboard/dashboardLabels.ts:20
msgid "Monad"
msgstr "Monad"

#. Fund account menu bridge description
#: apps/web/src/components/header/fund_account_menu/index.tsx:186
msgid "Move assets across chains"
msgstr "Move assets across chains"

#. Header nav item
#. Rewards menu mPoints item label
#. Rewards menu mPoints item label
#: apps/web/src/components/header/constants.ts:77
#: apps/web/src/components/header/rewards_menu/config.tsx:60
#: apps/web/src/components/header/rewards_menu/panels.tsx:374
#: apps/web/src/features/mpoints/components/hero-banner/hero-banner.tsx:114
#: apps/web/src/features/mpoints/components/rewards-history-grid/useRewardsHistoryColumns.tsx:46
msgid "mPoints"
msgstr "mPoints"

#: apps/web/src/features/mpoints/components/stat-cards/points-distribution-card.tsx:89
msgid "mPoints Distribution"
msgstr "mPoints Distribution"

#: apps/web/src/features/mpoints/components/rewards-history-grid/rewards-history-grid.tsx:32
msgid "mPoints History"
msgstr "mPoints History"

#. mPoints distribution card: epoch pool topped up by the maker-volume boost campaign
#: apps/web/src/features/mpoints/components/stat-cards/points-distribution-card.tsx:60
msgid "mPoints increased from {from} <0><1/> {to}</0>."
msgstr "mPoints increased from {from} <0><1/> {to}</0>."

#: apps/web/src/features/mpoints/components/stat-cards/points-distribution-card.tsx:95
msgid "mPoints this epoch"
msgstr "mPoints this epoch"

#: apps/web/src/features/mpoints/components/stat-cards/points-distribution-card.tsx:96
msgid "mPoints this season"
msgstr "mPoints this season"

#. Order form validation
#: packages/ui-kit/src/feature/order_entry/order_schema.ts:15
msgid "Must be a positive number"
msgstr "Must be a positive number"

#. TP/SL form validation
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/schema.tsx:7
msgid "Must be greater than 0"
msgstr "Must be greater than 0"

#. Share card headline
#: apps/web/src/features/mpoints/components/share-points-dialog/points-share-card.tsx:200
msgid "My Total Points"
msgstr "My Total Points"

#. Order form summary value: not applicable
#: packages/ui-kit/src/feature/order_entry/hooks/useBottomLabels.ts:115
msgid "N/A"
msgstr "N/A"

#. Display name field placeholder
#. Partner headline fallback name
#: apps/web/src/features/referral/components/partner/edit-alias-dialog.tsx:62
#: apps/web/src/features/referral/components/partner/partner-hero-card.tsx:120
msgid "Name"
msgstr "Name"

#. placeholder {0}: nativeBalance?.symbol
#: apps/web/src/features/account/components/account_panel.tsx:174
msgid "Native ({0})"
msgstr "Native ({0})"

#. Market menu keyboard hint: the up and down arrow keys move through the market list
#: packages/ui-kit/src/feature/market_info/market_menu/market_menu_hints.tsx:36
msgctxt "keyboard shortcut"
msgid "Navigate"
msgstr "Navigate"

#: apps/web/src/features/auth/components/access_request_dialog.tsx:99
msgid "Need a code? Request one in our <0>Discord</0>."
msgstr "Need a code? Request one in our <0>Discord</0>."

#. Dashboard chart: net MON emissions
#: apps/web/src/features/dashboard/dashboardLabels.ts:40
msgid "Net Emissions"
msgstr "Net Emissions"

#. Dashboard chart legend: daily net deposits minus withdrawals
#: apps/web/src/features/dashboard/dashboardLabels.ts:13
msgid "Net flow"
msgstr "Net flow"

#. Dashboard section: Monad chain impact
#: apps/web/src/features/dashboard/dashboard.tsx:212
msgctxt "dashboard section"
msgid "Network"
msgstr "Network"

#. API key timestamp empty
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:26
msgid "Never"
msgstr "Never"

#. API key expiry option
#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:36
msgctxt "expiry"
msgid "Never"
msgstr "Never"

#. Dashboard chart legend: accounts opened that day
#: apps/web/src/features/dashboard/dashboardLabels.ts:18
msgid "New"
msgstr "New"

#. Builder dashboard state for a wallet without a builder code
#: apps/web/src/features/builders/builderDashboard.tsx:257
msgid "No builder code is registered to this wallet."
msgstr "No builder code is registered to this wallet."

#. Default empty message for tables
#: packages/ui-kit/src/components/table/table_builder/table_builder.tsx:61
msgid "No data"
msgstr "No data"

#. Points history empty state
#. Table empty state
#: apps/web/src/features/points/components/points-history-grid/cells/no-rows.tsx:9
#: packages/ui-kit/src/components/datagrid/DefaultNoRowsOverlay.tsx:9
msgid "No data available"
msgstr "No data available"

#. CSV export: no dates picked means the whole history is exported
#: packages/ui-kit/src/feature/terminal_tables/csv_export/ExportCsvDialog.tsx:227
msgid "No dates selected: the file will cover your entire history."
msgstr "No dates selected: the file will cover your entire history."

#. Portfolio chart empty state title: signed in, no deposit yet
#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:70
msgid "No deposits yet"
msgstr "No deposits yet"

#. Market picker: empty favorites list
#: packages/ui-kit/src/feature/market_info/market_menu/market_menu_sheet.tsx:166
msgid "No favorites yet. Tap the star on a market."
msgstr "No favorites yet. Tap the star on a market."

#. Funding history popover empty state
#: packages/ui-kit/src/feature/market_info/funding_history_popover.tsx:167
msgid "No funding events yet"
msgstr "No funding events yet"

#. Funding heatmap tooltip: the funding rate was zero
#: apps/web/src/features/funding-map/HeatmapTooltip.tsx:62
msgid "No funding paid"
msgstr "No funding paid"

#. Market picker: no search results
#: packages/ui-kit/src/feature/market_info/market_menu/market_menu_sheet.tsx:167
msgid "No markets found"
msgstr "No markets found"

#. Funding map empty markets
#: apps/web/src/features/funding-map/FundingHeatmapCard.tsx:157
msgid "No open markets to show."
msgstr "No open markets to show."

#. Picture-in-picture orders empty title
#: apps/web/src/features/picture_in_picture/components/OrdersList.tsx:27
msgid "No open orders"
msgstr "No open orders"

#. Portfolio liquidation risk value: the account has no open positions
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:48
msgid "No open positions"
msgstr "No open positions"

#: apps/web/src/features/auth/hooks/useAccessRequestState.ts:56
msgid "No pending authentication request found"
msgstr "No pending authentication request found"

#. Picture-in-picture positions empty title
#: apps/web/src/features/picture_in_picture/components/PositionsList.tsx:28
msgid "No positions"
msgstr "No positions"

#: apps/web/src/features/tournament/components/standing-shared.tsx:157
msgid "No prize this round"
msgstr "No prize this round"

#. History table empty state when filters match no rows
#: packages/ui-kit/src/feature/terminal_tables/shared/filtered_empty_message.tsx:4
msgid "No results for the selected filters"
msgstr "No results for the selected filters"

#. Empty state message for table filters
#: packages/ui-kit/src/components/table/filter/empty_filter_view.tsx:36
msgid "No results found for this period."
msgstr "No results found for this period."

#. Preferences drawer no support info
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:437
msgid "No support info"
msgstr "No support info"

#. Portfolio chart empty state title: no wallet connected
#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:45
msgid "Not connected"
msgstr "Not connected"

#: apps/web/src/features/tournament/components/standing-shared.tsx:128
#: apps/web/src/features/tournament/components/standing-shared.tsx:162
msgid "Not eligible"
msgstr "Not eligible"

#: apps/web/src/features/tournament/components/standing-shared.tsx:127
msgid "Not qualified"
msgstr "Not qualified"

#: apps/web/src/features/tournament/components/standing-shared.tsx:171
msgid "Not ranked"
msgstr "Not ranked"

#. Portfolio chart empty state title: wallet connected, not signed in
#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:55
msgid "Not signed in"
msgstr "Not signed in"

#. Builder payout status: epoch earned nothing
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:44
msgid "Nothing owed"
msgstr "Nothing owed"

#. CSV export: the chosen date range holds no rows, so no file was downloaded
#: packages/ui-kit/src/feature/terminal_tables/csv_export/ExportCsvDialog.tsx:189
msgid "Nothing to export in this date range."
msgstr "Nothing to export in this date range."

#. Preferences: toast duration select
#: apps/web/src/components/header/user_settings/preferences-drawer/notification_preference_section.tsx:27
msgid "Notification duration"
msgstr "Notification duration"

#. Header notifications button
#. Header notifications button
#. Mobile drawer notifications item
#. Preferences: notifications section title and toggle
#: apps/web/src/components/header/desktop_actions.tsx:96
#: apps/web/src/components/header/dex_header.tsx:158
#: apps/web/src/components/header/mobile_drawer.tsx:174
#: apps/web/src/components/header/user_settings/preferences-drawer/notification_preference_section.tsx:25
msgid "Notifications"
msgstr "Notifications"

#. Mobile drawer notifications item with unread count
#: apps/web/src/components/header/mobile_drawer.tsx:170
msgid "Notifications ({unreadCount})"
msgstr "Notifications ({unreadCount})"

#. Table header: Value
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:87
msgid "Notional Value"
msgstr "Notional Value"

#. Builders leaderboard Traders column header tooltip
#: apps/web/src/features/builders/components/useBuilderColumns.tsx:119
msgid "Number of distinct accounts that traded through this builder over the period."
msgstr "Number of distinct accounts that traded through this builder over the period."

#: apps/web/src/features/points/components/points-history-grid/points-history-grid.tsx:54
msgid "OG"
msgstr "OG"

#. Disable one-click trading confirm button
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:158
msgid "OK"
msgstr "OK"

#. Alert body: liquidation explanation with leverage
#: packages/ui-kit/src/feature/order_entry/form/account_leverage.tsx:184
msgid "On Perpl, only the collateral on this position is at risk, never your whole account."
msgstr "On Perpl, only the collateral on this position is at risk, never your whole account."

#. Partner stable CTA: locked tier is safe until the next snapshot
#: apps/web/src/features/referral/components/partner/partner-hero-card.tsx:169
msgid "On track to hold Tier {tier} · next snapshot {snapshot}"
msgstr "On track to hold Tier {tier} · next snapshot {snapshot}"

#. On-chain collateral row
#: apps/web/src/components/header/user_account_menu/account_balance_summary.tsx:185
msgid "On-chain"
msgstr "On-chain"

#. Dashboard page subtitle: onchain Perpl stats
#: apps/web/src/features/dashboard/dashboard.tsx:314
#~ msgid "Onchain view of Perpl on Monad — volume, open interest, TVL, flows and network load."
#~ msgstr "Onchain view of Perpl on Monad — volume, open interest, TVL, flows and network load."

#. Dashboard page subtitle: onchain Perpl stats
#: apps/web/src/features/dashboard/dashboard.tsx:89
#~ msgid "Onchain view of Perpl on Monad — volume, TVL, fees, users, flows and network load."
#~ msgstr "Onchain view of Perpl on Monad — volume, TVL, fees, users, flows and network load."

#. Dashboard page subtitle, one line under the title. <0/> is the Dune logo badge (the data provider), so the sentence should read naturally with the logo in that slot.
#: apps/web/src/features/dashboard/dashboard.tsx:98
msgid "Onchain view of Perpl on Monad, powered by <0/>"
msgstr "Onchain view of Perpl on Monad, powered by <0/>"

#: apps/web/src/features/account/oneclick_dialog.tsx:30
msgid "One-Click Trading"
msgstr "One-Click Trading"

#. Flip dialog: visible order book too thin for the whole order
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:287
msgid "Only about {fillPctText} of this flip can fill from the visible order book. The rest would be cancelled, leaving you <0/>."
msgstr "Only about {fillPctText} of this flip can fill from the visible order book. The rest would be cancelled, leaving you <0/>."

#. P&L history event label: position opened
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:26
msgid "Open"
msgstr "Open"

#. Market menu keyboard hint: the shortcut opens and closes this menu
#: packages/ui-kit/src/feature/market_info/market_menu/market_menu_hints.tsx:27
msgctxt "keyboard shortcut"
msgid "Open"
msgstr "Open"

#. Order form fees row label: opening fees
#: packages/ui-kit/src/feature/order_entry/constants.ts:58
#~ msgctxt "position fees"
#~ msgid "Open"
#~ msgstr "Open"

#. Coin info open interest
#. Dashboard KPI: current open interest
#. Dashboard chart: daily open interest
#. Market info table open interest
#: apps/web/src/features/dashboard/dashboard.tsx:140
#: apps/web/src/features/dashboard/dashboardLabels.ts:25
#: packages/ui-kit/src/feature/market_info/coin_info/market_metrics.tsx:132
#: packages/ui-kit/src/feature/market_info/market_menu/market_menu_table.tsx:302
msgid "Open Interest"
msgstr "Open Interest"

#. Keyboard shortcut action
#: apps/web/src/features/shortcuts/shortcuts.ts:29
msgid "Open Markets"
msgstr "Open Markets"

#. Header button opening the mobile menu
#: apps/web/src/components/header/dex_header.tsx:170
msgid "Open mobile menu"
msgstr "Open mobile menu"

#. Picture-in-picture notifications button
#: apps/web/src/features/picture_in_picture/components/PipNotificationsButton.tsx:26
msgid "Open notifications"
msgstr "Open notifications"

#. Close dialog: resting orders row label
#. Flip dialog: resting orders row label
#. Tab title: Open Orders
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:228
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:251
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:253
msgid "Open Orders"
msgstr "Open Orders"

#. Account tab render error
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:290
msgid "Open Orders failed to render."
msgstr "Open Orders failed to render."

#. Picture-in-picture positions empty subtitle
#: apps/web/src/features/picture_in_picture/components/PositionsList.tsx:30
msgid "Open positions will show up here with live PnL."
msgstr "Open positions will show up here with live PnL."

#. Keyboard shortcut action
#: apps/web/src/features/shortcuts/shortcuts.ts:62
msgid "Open Settings"
msgstr "Open Settings"

#. Close dialog: opening fees row label
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:91
#~ msgid "Opening Fees"
#~ msgstr "Opening Fees"

#. Table header: Operation
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:111
msgid "Operation"
msgstr "Operation"

#. Footer connection status
#: packages/ui-kit/src/common/heartbeatStore.ts:17
msgid "Operational"
msgstr "Operational"

#. Coin info oracle
#: packages/ui-kit/src/feature/market_info/coin_info/market_metrics.tsx:119
msgid "Oracle"
msgstr "Oracle"

#. Mobile order drawer: toggle that shows the order book next to the form
#. Preferences: trading panel toggle
#. Terminal tab: order book
#. Terminal tab: order book
#: apps/web/src/components/header/user_settings/preferences-drawer/terminal_panels_section.tsx:18
#: apps/web/src/features/order_book/orders_panel.tsx:132
#: apps/web/src/features/terminal/mobile/mobile_order_drawer.tsx:57
#: apps/web/src/features/terminal/mobile/mobile_trading_layout.tsx:44
msgid "Order Book"
msgstr "Order Book"

#. Tab title: Order History
#. Tab title: Order History
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:260
#: packages/ui-kit/src/feature/terminal_tables/order_history/order_history.tsx:83
msgid "Order History"
msgstr "Order History"

#. Account tab render error
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:304
msgid "Order History failed to render."
msgstr "Order History failed to render."

#. Table header: Order ID
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:116
msgid "Order ID"
msgstr "Order ID"

#. PiP order price
#: apps/web/src/features/picture_in_picture/components/OrderRow.tsx:102
msgid "Order price"
msgstr "Order price"

#. Order form validation
#: packages/ui-kit/src/feature/order_entry/order_schema.ts:19
msgid "Order price must be greater than zero"
msgstr "Order price must be greater than zero"

#. Order form validation
#: packages/ui-kit/src/feature/order_entry/order_schema.ts:17
msgid "Order size must be greater than zero"
msgstr "Order size must be greater than zero"

#. Keyboard shortcut action
#: apps/web/src/features/shortcuts/shortcuts.ts:20
#~ msgid "Order Type"
#~ msgstr "Order Type"

#. Order form summary row label
#. Table header: Order Value
#: packages/ui-kit/src/feature/order_entry/constants.ts:31
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:95
msgid "Order Value"
msgstr "Order Value"

#. Picture-in-picture open orders tab
#: apps/web/src/features/picture_in_picture/OrdersPip.tsx:73
msgid "Orders"
msgstr "Orders"

#. API key table column
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:127
msgid "Origin"
msgstr "Origin"

#: apps/web/src/features/leaderboard/components/dialog/badges_dialog.tsx:78
msgid "Origin Badges"
msgstr "Origin Badges"

#: apps/web/src/features/leaderboard/components/dialog/badges_dialog.tsx:88
msgid "Origin Badges mark the first cohort of traders on Perpl. They were awarded to wallets that crossed a notional volume threshold before 1 June, 2026."
msgstr "Origin Badges mark the first cohort of traders on Perpl. They were awarded to wallets that crossed a notional volume threshold before 1 June, 2026."

#: apps/web/src/features/leaderboard/components/dialog/badges_dialog.tsx:103
#: apps/web/src/features/leaderboard/components/dialog/badges_dialog.tsx:114
msgid "Origin Badges volume thresholds"
msgstr "Origin Badges volume thresholds"

#. Table header: Original Size
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:112
msgid "Original Size"
msgstr "Original Size"

#. Leaderboard Origins tier row
#. Points Origins badge tier row
#: apps/web/src/components/header/rewards_menu/panels.tsx:225
#: apps/web/src/components/header/rewards_menu/panels.tsx:324
msgid "Origins tier"
msgstr "Origins tier"

#: apps/web/src/hooks/useGeoBlockAnnouncement.ts:44
msgid "Our services are no longer offered to users in {country} for regulatory reasons effective {blockAt}. If you are located in {country}, please close your positions and withdraw funds before that date. If you missed that opportunity, please contact our Discord {discordUrl}"
msgstr "Our services are no longer offered to users in {country} for regulatory reasons effective {blockAt}. If you are located in {country}, please close your positions and withdraw funds before that date. If you missed that opportunity, please contact our Discord {discordUrl}"

#: apps/web/src/hooks/useOntarioBanAnnouncement.ts:40
#~ msgid "Our services are no longer offered to users in Ontario for regulatory reasons effective {blockAt}. If you are located in the province of Ontario, please close your positions and withdraw funds before that date. If you missed that opportunity, please contact our Discord {discordUrl}"
#~ msgstr "Our services are no longer offered to users in Ontario for regulatory reasons effective {blockAt}. If you are located in the province of Ontario, please close your positions and withdraw funds before that date. If you missed that opportunity, please contact our Discord {discordUrl}"

#. Dashboard chart legend: withdrawals
#: apps/web/src/features/dashboard/dashboard.tsx:86
#~ msgid "Outflows"
#~ msgstr "Outflows"

#. Delegated account owner chip
#. Header chip: delegated account owner
#: apps/web/src/components/header/constants.ts:191
#: apps/web/src/features/account/components/account_panel.tsx:103
msgid "Owner"
msgstr "Owner"

#. Tab title: P&L History
#. Tab title: P&L History
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:261
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/pnl_history.tsx:144
msgid "P&L History"
msgstr "P&L History"

#. Account tab render error
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:311
msgid "P&L History failed to render."
msgstr "P&L History failed to render."

#: apps/web/src/features/mpoints/components/stat-cards/projected-rewards-card.tsx:26
#~ msgid "Paid in MON at season end • May go up, but never down."
#~ msgstr "Paid in MON at season end • May go up, but never down."

#: apps/web/src/features/mpoints/components/stat-cards/projected-rewards-card.tsx:26
msgid "Paid in MON at season end."
msgstr "Paid in MON at season end."

#. P&L history event label: position partially closed
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:30
msgid "Partial Close"
msgstr "Partial Close"

#. Market order fill prognosis: partial fill due to slippage cap
#: packages/ui-kit/src/feature/order_entry/form/market_fill_prognosis.tsx:209
msgid "Partial fill (~{pct}%) — exceeds slippage"
msgstr "Partial fill (~{pct}%) — exceeds slippage"

#. Market order fill prognosis: partial fill due to insufficient liquidity
#: packages/ui-kit/src/feature/order_entry/form/market_fill_prognosis.tsx:214
msgid "Partial fill (~{pct}%) — not enough liquidity"
msgstr "Partial fill (~{pct}%) — not enough liquidity"

#: apps/web/src/features/tournament/tournament-detail-page.tsx:79
msgid "Participation in this tournament is exclusively for Monad Card and Perpl Points holders."
msgstr "Participation in this tournament is exclusively for Monad Card and Perpl Points holders."

#. Rewards menu description for the partner (VIP Rewards) entry replacing Referrals
#: apps/web/src/components/header/rewards_menu/use_filtered_rewards_menu_items.ts:8
msgid "Partner rewards dashboard"
msgstr "Partner rewards dashboard"

#. Footer ticker control
#: apps/web/src/components/footer/dex_footer.tsx:97
msgid "Pause ticker"
msgstr "Pause ticker"

#. Builder payout history column header
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:173
msgid "Payout"
msgstr "Payout"

#. Builder dashboard payout history card title
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:260
msgid "Payout History"
msgstr "Payout History"

#. Builder payout history load error
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:266
msgid "Payout history is temporarily unavailable. Retrying shortly."
msgstr "Payout history is temporarily unavailable. Retrying shortly."

#. Builder payout history footer
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:290
msgid "Payouts are made after each epoch closes. Transfers are matched to epochs by amount and time."
msgstr "Payouts are made after each epoch closes. Transfers are matched to epochs by amount and time."

#. Referees filter option
#. Reward status: pending
#. Rewards filter option
#: apps/web/src/features/referral/components/referrals-history/referrals-history.tsx:53
#: apps/web/src/features/referral/components/referrals-history/referrals-history.tsx:84
#: apps/web/src/features/referral/components/referrals-history/rewards-columns.tsx:41
msgid "Pending"
msgstr "Pending"

#: apps/web/src/features/points/components/points-history-grid/cells/pending.tsx:14
msgid "pending..."
msgstr "pending..."

#. Market order fill prognosis: what the impact percentage is measured against
#: packages/ui-kit/src/feature/order_entry/form/market_fill_prognosis.tsx:166
msgid "Percentage is the gap to the book’s mid price."
msgstr "Percentage is the gap to the book’s mid price."

#. Rewards history column header
#: apps/web/src/features/mpoints/components/rewards-history-grid/useRewardsHistoryColumns.tsx:33
#: apps/web/src/features/points/components/points-history-grid/columns.tsx:38
#: apps/web/src/features/referral/components/referrals-history/rewards-columns.tsx:95
msgid "Period"
msgstr "Period"

#. Builder payout history column header
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:137
msgid "Period (UTC)"
msgstr "Period (UTC)"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:125
msgid "Permissions"
msgstr "Permissions"

#. Dashboard burn share: Perpl segment
#. Dashboard chart legend: MON burned by Perpl
#. Dashboard chart legend: Perpl gas
#. Dashboard table column: Perpl value
#: apps/web/src/features/dashboard/dashboard.tsx:221
#: apps/web/src/features/dashboard/dashboard.tsx:234
#: apps/web/src/features/dashboard/dashboardLabels.ts:19
#: apps/web/src/features/dashboard/dashboardLabels.ts:21
msgid "Perpl"
msgstr "Perpl"

#. Header logo link to the trading page
#: apps/web/src/components/header/dex_header.tsx:111
msgid "Perpl home"
msgstr "Perpl home"

#: apps/web/src/features/auth/components/access_steps.tsx:52
msgid "Perpl is currently in a gated beta phase.<0/>You can request access codes in our <1>Discord</1>."
msgstr "Perpl is currently in a gated beta phase.<0/>You can request access codes in our <1>Discord</1>."

#. Rewards menu Points item description
#: apps/web/src/components/header/rewards_menu/config.tsx:52
msgid "Perpl points"
msgstr "Perpl points"

#: apps/web/src/features/tournament/components/header-banner.tsx:117
msgid "Perpl Trading Tournament{number}"
msgstr "Perpl Trading Tournament{number}"

#. Portfolio account overview label
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:190
msgid "Perps Equity"
msgstr "Perps Equity"

#: apps/web/src/features/tournament/hooks/useStandings.ts:89
msgid "Place a trade to get on the board"
msgstr "Place a trade to get on the board"

#. Reduce only order button text
#: packages/ui-kit/src/feature/order_entry/form/forms_action_buttons.tsx:53
msgid "Place Reduce-Only Order"
msgstr "Place Reduce-Only Order"

#: apps/web/src/hooks/useTokenAmountValidation.ts:63
msgid "Please enter a valid amount."
msgstr "Please enter a valid amount."

#: apps/web/src/features/auth/hooks/useAccessRequestState.ts:50
msgid "Please enter an access code"
msgstr "Please enter an access code"

#. Order form validation
#: packages/ui-kit/src/feature/order_entry/order_schema.ts:18
msgid "Please enter order price"
msgstr "Please enter order price"

#. Order form validation
#: packages/ui-kit/src/feature/order_entry/order_schema.ts:16
msgid "Please enter order size"
msgstr "Please enter order size"

#. Order form validation
#: packages/ui-kit/src/feature/order_entry/order_schema.ts:20
msgid "Please enter trigger price"
msgstr "Please enter trigger price"

#: apps/web/src/features/tournament/components/finalising-dialog.tsx:150
msgid "Please wait while we check for disqualifying behaviour."
msgstr "Please wait while we check for disqualifying behaviour."

#. Mobile positions sort option
#. Portfolio chart: PnL
#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:126
#: apps/web/src/features/tournament/components/leaderboard-columns.tsx:127
#: packages/ui-kit/src/feature/terminal_tables/position/positions_table.tsx:169
msgid "PnL"
msgstr "PnL"

#. Mobile position card: PnL and ROE label
#: packages/ui-kit/src/feature/terminal_tables/position/positions_cards.tsx:96
#~ msgid "PnL (ROE %)"
#~ msgstr "PnL (ROE %)"

#. Table header: PNL(ROE%)
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:98
msgid "PNL (ROE%)"
msgstr "PNL (ROE%)"

#. Leaderboard column header: PnL as a percentage
#: apps/web/src/features/leaderboard/components/ranking/useLeaderboardColumns.tsx:137
msgid "PNL %"
msgstr "PNL %"

#. Leaderboard PNL % column header tooltip
#: apps/web/src/features/leaderboard/components/ranking/useLeaderboardColumns.tsx:138
msgid "PnL % = PnL / max(100, starting equity + sum of Inbound transfers)."
msgstr "PnL % = PnL / max(100, starting equity + sum of Inbound transfers)."

#. Leaderboard column header: PnL in USD
#: apps/web/src/features/leaderboard/components/ranking/useLeaderboardColumns.tsx:112
msgid "PNL USD"
msgstr "PNL USD"

#. Header nav item. "Points" is the name of a reward currency, like the neighbouring "mPoints" — keep it in Latin script and do not translate or transliterate it. The same applies wherever the word names the currency ("Points History", "Weekly Points", …).
#. Rewards menu Points item label
#. Rewards menu Points item label. "Points" is the name of a reward currency — keep it in Latin script and do not translate or transliterate it.
#: apps/web/src/components/header/constants.ts:85
#: apps/web/src/components/header/rewards_menu/config.tsx:47
#: apps/web/src/components/header/rewards_menu/panels.tsx:379
#: apps/web/src/features/points/components/hero-card.tsx:27
#: apps/web/src/features/points/points.tsx:119
msgid "Points"
msgstr "Points"

#: apps/web/src/features/points/components/points-history-grid/cells/pending.tsx:12
msgid "Points are usually distributed within 48 hours."
msgstr "Points are usually distributed within 48 hours."

#: apps/web/src/features/points/components/points-history-grid/cells/weekly-points.tsx:23
msgid "Points earned during the pre-season will be added to your overall total at a later date."
msgstr "Points earned during the pre-season will be added to your overall total at a later date."

#: apps/web/src/features/points/components/points-history-grid/points-history-grid.tsx:47
msgid "Points History"
msgstr "Points History"

#: apps/web/src/features/points/components/total-emitted.tsx:15
msgid "Points Per Epoch"
msgstr "Points Per Epoch"

#. Partner stat label
#: apps/web/src/features/referral/components/partner/partner-stats.tsx:176
msgid "Points Referred"
msgstr "Points Referred"

#. Rewards structure column header: points boost the referee earns
#: apps/web/src/features/referral/components/partner/rewards-structure-dialog.tsx:59
msgid "Points<0/>(Referee)"
msgstr "Points<0/>(Referee)"

#. Rewards structure column header: points boost the referrer earns
#: apps/web/src/features/referral/components/partner/rewards-structure-dialog.tsx:66
msgid "Points<0/>(Referrer)"
msgstr "Points<0/>(Referrer)"

#. Header tooltip for the picture-in-picture button
#: apps/web/src/features/picture_in_picture/PipButton.tsx:27
msgid "Pop out"
msgstr "Pop out"

#. Header nav item
#. Portfolio page title
#: apps/web/src/components/header/constants.ts:36
#: apps/web/src/features/portfolio/portfolio.tsx:41
msgid "Portfolio"
msgstr "Portfolio"

#. Chart overlay preference
#. Close dialog: position value row label
#. Current position label, short form for mobile
#. Flip dialog: position row label
#. Preferences: toast position select
#: apps/web/src/components/header/user_settings/preferences-drawer/chart_overlay_preference_section.tsx:15
#: apps/web/src/components/header/user_settings/preferences-drawer/notification_preference_section.tsx:26
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:61
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:157
#: packages/ui-kit/src/feature/order_entry/form/position_display.tsx:88
msgid "Position"
msgstr "Position"

#. Account history operation
#: packages/ui-kit/src/feature/terminal_tables/account_history/constants.ts:45
msgid "Position Collateral Decreased"
msgstr "Position Collateral Decreased"

#. Close dialog: position margin row label
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:71
msgid "Position Margin"
msgstr "Position Margin"

#. Picture-in-picture positions tab
#. Tab title: Positions
#: apps/web/src/features/picture_in_picture/OrdersPip.tsx:64
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:244
msgid "Positions"
msgstr "Positions"

#. Picture-in-picture tab switch
#: apps/web/src/features/picture_in_picture/OrdersPip.tsx:54
msgid "Positions and orders"
msgstr "Positions and orders"

#. Account tab render error
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:283
msgid "Positions failed to render."
msgstr "Positions failed to render."

#. Funding tooltip with interval blocks
#: packages/ui-kit/src/feature/market_info/coin_info/market_metrics.tsx:148
msgid "Positive funding: longs pay shorts. Negative: shorts pay longs. Funding is computed in blocks ({blocks} per period). Times are estimates."
msgstr "Positive funding: longs pay shorts. Negative: shorts pay longs. Funding is computed in blocks ({blocks} per period). Times are estimates."

#. Funding tooltip without interval
#: packages/ui-kit/src/feature/market_info/coin_info/market_metrics.tsx:152
msgid "Positive funding: longs pay shorts. Negative: shorts pay longs. Funding is computed in blocks. Times are estimates."
msgstr "Positive funding: longs pay shorts. Negative: shorts pay longs. Funding is computed in blocks. Times are estimates."

#. Funding history popover: who pays whom by rate sign
#: packages/ui-kit/src/feature/market_info/funding_history_popover.tsx:138
msgid "Positive: longs pay shorts. Negative: shorts pay longs."
msgstr "Positive: longs pay shorts. Negative: shorts pay longs."

#. Post Only
#: packages/ui-kit/src/feature/order_entry/form/tif.tsx:45
msgid "Post Only"
msgstr "Post Only"

#. Points history epoch name for the pre-season row
#: apps/web/src/features/points/components/points-history-grid/columns.tsx:18
msgid "Pre-Season"
msgstr "Pre-Season"

#. Funding rates page: how the premium index is measured and bounded. Keep the math notation; translate only the words.
#: apps/web/src/features/funding_rates/funding_rates.tsx:198
#~ msgid "Premium Index = [max(Impact Bid - Oracle, 0) - max(Oracle - Impact Ask, 0)] / Oracle, sampled throughout the funding interval and averaged. The cap applies per event and per hour over a trailing window. Positive rates: longs pay shorts. Negative rates: shorts pay longs."
#~ msgstr "Premium Index = [max(Impact Bid - Oracle, 0) - max(Oracle - Impact Ask, 0)] / Oracle, sampled throughout the funding interval and averaged. The cap applies per event and per hour over a trailing window. Positive rates: longs pay shorts. Negative rates: shorts pay longs."

#. Dashboard table: previous calendar month summary
#: apps/web/src/features/dashboard/dashboard.tsx:232
msgid "Previous Full Month"
msgstr "Previous Full Month"

#. Edit order dialog limit price label
#. Order book price
#. Table header: Price
#. Trade console form price label
#. Trade table Price
#: apps/web/src/features/trading/edit_order_dialog/index.tsx:148
#: packages/ui-kit/src/feature/order_book/side/side.tsx:112
#: packages/ui-kit/src/feature/order_book/trades/trades.tsx:118
#: packages/ui-kit/src/feature/order_entry/fields/price.tsx:33
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:74
msgid "Price"
msgstr "Price"

#. Portfolio private-mode overlay
#. Portfolio private-mode overlay
#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:203
#: apps/web/src/features/portfolio/portfolio.tsx:98
msgid "Private mode on"
msgstr "Private mode on"

#: apps/web/src/features/tournament/components/leaderboard-columns.tsx:151
msgid "Prize"
msgstr "Prize"

#: apps/web/src/features/tournament/components/standing-shared.tsx:99
msgid "Prize!"
msgstr "Prize!"

#. Reward status: processing
#: apps/web/src/features/referral/components/referrals-history/rewards-columns.tsx:32
msgid "Processing"
msgstr "Processing"

#: apps/web/src/features/account/components/deposit_panel.tsx:123
#: apps/web/src/features/account/components/withdraw_panel.tsx:99
#: apps/web/src/features/auth/components/terms_dialog.tsx:66
msgid "Processing..."
msgstr "Processing..."

#. mPoints projected USD row
#: apps/web/src/components/header/rewards_menu/panels.tsx:179
msgid "Projected"
msgstr "Projected"

#. Partner projected tier when the tier ladder is unavailable
#: apps/web/src/features/referral/components/partner/partner-stats.tsx:128
msgid "Projected next epoch: —"
msgstr "Projected next epoch: —"

#. Partner projected tier in the next epoch
#: apps/web/src/features/referral/components/partner/partner-stats.tsx:124
msgid "Projected next epoch: Tier {tier}"
msgstr "Projected next epoch: Tier {tier}"

#. Dashboard chart legend: protocol fees
#: apps/web/src/features/dashboard/dashboardLabels.ts:16
msgid "Protocol"
msgstr "Protocol"

#. Tooltip on Fees Paid column header
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:238
msgid "Protocol fees only. Builder fees paid by the referral go to the builder and earn no rewards."
msgstr "Protocol fees only. Builder fees paid by the referral go to the builder and earn no rewards."

#. Tools menu dashboard description
#: apps/web/src/components/header/tools_menu/config.tsx:24
msgid "Protocol volume, TVL and onchain stats"
msgstr "Protocol volume, TVL and onchain stats"

#: apps/web/src/features/tournament/components/standing-shared.tsx:113
msgid "Provisional"
msgstr "Provisional"

#. Points unit suffix in the header pill
#. Points unit suffix in the rewards summary
#: apps/web/src/components/header/points_button.tsx:59
#: apps/web/src/components/header/rewards_menu/panels.tsx:365
msgid "pts"
msgstr "pts"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:223
msgid "Public identifier — sent as the X-API-Key header."
msgstr "Public identifier — sent as the X-API-Key header."

#. Points history disconnected overlay
#: apps/web/src/features/points/components/points-history-grid/cells/disconnected.tsx:20
#~ msgid "Purple Summer has begun..."
#~ msgstr "Purple Summer has begun..."

#. Flip dialog: per-order slippage override toggle
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:312
#~ msgid "Raise the slippage limit for this flip only"
#~ msgstr "Raise the slippage limit for this flip only"

#. Builders leaderboard column header
#. Leaderboard column header
#. Share card stat label: the trader's standing on the leaderboard. Use the everyday word for a finishing position ("place"), the same one used in the share tweet body — not a military or academic "rank".
#. Shared rewards panel rank row
#. Shared rewards panel rank row
#: apps/web/src/components/header/rewards_menu/panels.tsx:187
#: apps/web/src/components/header/rewards_menu/panels.tsx:230
#: apps/web/src/features/builders/components/useBuilderColumns.tsx:23
#: apps/web/src/features/leaderboard/components/ranking/useLeaderboardColumns.tsx:41
#: apps/web/src/features/mpoints/components/share-points-dialog/points-share-card.tsx:255
#: apps/web/src/features/points/components/points-history-grid/columns.tsx:76
#: apps/web/src/features/tournament/components/leaderboard-columns.tsx:22
msgid "Rank"
msgstr "Rank"

#. Tournament standing headline. Use the everyday word for a finishing position ("place"), the same one used in the share tweet body — not a military or academic "rank".
#: apps/web/src/features/tournament/components/standing-shared.tsx:165
msgid "Rank {rank}"
msgstr "Rank {rank}"

#. Funding history popover header: Rate
#: packages/ui-kit/src/feature/market_info/funding_history_popover.tsx:154
msgid "Rate"
msgstr "Rate"

#. API key permission chip
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:93
msgctxt "api key scope"
msgid "Read"
msgstr "Read"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:131
msgid "Read only — view account, orders and positions"
msgstr "Read only — view account, orders and positions"

#. Funding rates page title
#: apps/web/src/features/funding_rates/funding_rates.tsx:189
msgid "Real-Time Funding Rates"
msgstr "Real-Time Funding Rates"

#. Flip dialog: realized PnL tooltip
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:206
msgid "Realized on the closing leg, including fees. The new position opens at the fill price."
msgstr "Realized on the closing leg, including fees. The new position opens at the fill price."

#. Liquidation tooltip header
#: packages/ui-kit/src/feature/terminal_tables/LiquidationDistributionTooltip.tsx:43
msgid "Redistributed {total}"
msgstr "Redistributed {total}"

#. Close dialog title for a partial close
#: apps/web/src/features/account/close_position_dialog/SinglePositionContent.tsx:27
msgid "Reduce {ticker} Position"
msgstr "Reduce {ticker} Position"

#. Reduce only checkbox label
#. Table header: Reduce Only
#: packages/ui-kit/src/feature/order_entry/fields/reduce_only.tsx:35
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:114
msgid "Reduce Only"
msgstr "Reduce Only"

#. Reduce only disabled button text
#: packages/ui-kit/src/feature/order_entry/form/forms_action_buttons.tsx:52
msgid "Reduce Only Enabled"
msgstr "Reduce Only Enabled"

#. Reduce only tooltip
#: packages/ui-kit/src/feature/order_entry/fields/reduce_only.tsx:17
msgid "Reduce Only will only reduce your position. Any order that might increase your position size will be canceled or adjusted."
msgstr "Reduce Only will only reduce your position. Any order that might increase your position size will be canceled or adjusted."

#. Close dialog: confirm button label for a partial close
#: apps/web/src/features/account/close_position_dialog/SinglePositionContent.tsx:21
msgid "Reduce Position"
msgstr "Reduce Position"

#. Navbar button opening the referral popover
#: apps/web/src/components/header/desktop_actions.tsx:100
#~ msgid "Refer"
#~ msgstr "Refer"

#. Partner at-risk CTA: volume needed to hold the locked tier by the next snapshot
#. placeholder {0}: formatCompactUsd(view.volumeToKeepTier, { maxFractionDigits: 1 })
#: apps/web/src/features/referral/components/partner/partner-hero-card.tsx:147
msgid "Refer <0>{0} more</0> by {snapshot} to hold Tier {tier}"
msgstr "Refer <0>{0} more</0> by {snapshot} to hold Tier {tier}"

#. Partner promotion CTA: volume needed to reach the next tier by the next snapshot
#. placeholder {0}: formatCompactUsd(view.volumeToNextTier, { maxFractionDigits: 1 })
#: apps/web/src/features/referral/components/partner/partner-hero-card.tsx:158
msgid "Refer <0>{0} more</0> by {snapshot} to reach Tier {tier}"
msgstr "Refer <0>{0} more</0> by {snapshot} to reach Tier {tier}"

#. Refer Others card title
#. Referrals card title (modal)
#: apps/web/src/features/referral/components/referrals-card/referrals-card.tsx:37
#: apps/web/src/features/referral/components/referrals-card/share-referral-dialog.tsx:44
msgid "Refer Others"
msgstr "Refer Others"

#. Referral history column header
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:53
msgid "Referee's Address"
msgstr "Referee's Address"

#. Referral section title in account menu
#: apps/web/src/components/header/user_account_menu/account_menu_referral.tsx:37
msgid "Referral code"
msgstr "Referral code"

#. Referral code field label
#: apps/web/src/features/referral/components/referred-by.tsx:158
msgid "Referral Code"
msgstr "Referral Code"

#. Referral code linked notification
#: apps/web/src/features/referral/components/referred-by.tsx:100
msgid "Referral code added"
msgstr "Referral code added"

#. Referral page title (desktop)
#: apps/web/src/features/referral/referral.tsx:68
msgid "Referral Dashboard"
msgstr "Referral Dashboard"

#. Referrals panel headline
#. Referrals panel headline
#: apps/web/src/components/header/rewards_menu/panels.tsx:263
#: apps/web/src/components/header/rewards_menu/panels.tsx:384
msgid "Referral earnings"
msgstr "Referral earnings"

#. Referral history tabs aria-label
#: apps/web/src/features/referral/components/referrals-history/referrals-history.tsx:106
msgid "Referral history tabs"
msgstr "Referral history tabs"

#. Referral link input placeholder
#. Referral link input placeholder
#: apps/web/src/features/referral/components/partner/partner-hero-card.tsx:195
#: apps/web/src/features/referral/components/renewable-code-field.tsx:16
msgid "Referral link unavailable"
msgstr "Referral link unavailable"

#. Chip showing who referred this profile. The value is EITHER a referral code OR a shortened wallet address, so the label must cover both — do not word it as "referral code".
#: apps/web/src/features/referral/components/referred-by.tsx:43
msgid "Referral: {code}"
msgstr "Referral: {code}"

#. Header nav item
#. Referral page title (mobile)
#. Rewards menu Referrals item label
#: apps/web/src/components/header/constants.ts:97
#: apps/web/src/components/header/rewards_menu/config.tsx:69
#: apps/web/src/features/referral/referral.tsx:69
msgid "Referrals"
msgstr "Referrals"

#: apps/web/src/features/auth/components/terms_dialog.tsx:63
msgid "Reject"
msgstr "Reject"

#. P&L history event label: collateral removed
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:54
msgid "Remove Collateral"
msgstr "Remove Collateral"

#. Renew referral code button
#: apps/web/src/features/referral/components/renewable-code-field.tsx:17
msgid "Renew code"
msgstr "Renew code"

#. Renew referral code confirmation title
#: apps/web/src/features/referral/hooks/useRefCodeRenewal.ts:105
msgid "Renew referral code?"
msgstr "Renew referral code?"

#. Renew referral code button (in-flight)
#: apps/web/src/features/referral/components/renewable-code-field.tsx:18
msgid "Renewing…"
msgstr "Renewing…"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:117
msgid "Required. A name to help you recognize this key later."
msgstr "Required. A name to help you recognize this key later."

#. Filter: Reset
#: packages/ui-kit/src/components/table/filter/date_range.tsx:106
msgid "Reset"
msgstr "Reset"

#. Preferences drawer reset button
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:211
msgid "Reset Layout"
msgstr "Reset Layout"

#. Partner current epoch earnings cadence
#: apps/web/src/features/referral/components/partner/partner-stats.tsx:148
msgid "Resets Mon 00:00 UTC. Rewards transferred biweekly."
msgstr "Resets Mon 00:00 UTC. Rewards transferred biweekly."

#. Dashboard burn share: rest of Monad
#. Dashboard chart legend: MON burned by the rest of Monad
#: apps/web/src/features/dashboard/dashboard.tsx:222
#: apps/web/src/features/dashboard/dashboardLabels.ts:22
msgid "Rest of Monad"
msgstr "Rest of Monad"

#: apps/web/src/features/tournament/components/finalising-dialog.tsx:153
msgid "Results will be finalised within 1 week."
msgstr "Results will be finalised within 1 week."

#. Footer ticker control
#: apps/web/src/components/footer/dex_footer.tsx:96
msgid "Resume ticker"
msgstr "Resume ticker"

#. Builder code status: no longer live
#: apps/web/src/features/builders/builderDashboard.tsx:47
msgctxt "builder code status"
msgid "Retired"
msgstr "Retired"

#. API keys page retry button
#. Dashboard retry action
#. Funding map retry action
#: apps/web/src/features/api-keys/api-keys.tsx:95
#: apps/web/src/features/dashboard/dashboard.tsx:115
#: apps/web/src/features/funding-map/FundingHeatmapCard.tsx:148
msgid "Retry"
msgstr "Retry"

#. Portfolio ROE tooltip
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:151
msgid "Return on equity: current equity minus net deposits. May differ from total PnL if positions were liquidated."
msgstr "Return on equity: current equity minus net deposits. May differ from total PnL if positions were liquidated."

#. Revoke API key confirm button
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:38
msgid "Revoke"
msgstr "Revoke"

#. Revoke API key confirmation title
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:33
msgid "Revoke API key?"
msgstr "Revoke API key?"

#. API key table revoke tooltip
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:28
msgid "Revoke key"
msgstr "Revoke key"

#. Header Rewards dropdown trigger
#. Rewards history column header
#: apps/web/src/components/header/nav_hover_group/nav_hover_group.tsx:223
#: apps/web/src/features/referral/components/referrals-history/rewards-columns.tsx:107
msgid "Rewards"
msgstr "Rewards"

#. Rewards structure dialog title
#: apps/web/src/features/referral/components/partner/rewards-structure-dialog.tsx:44
msgid "Rewards Structure"
msgstr "Rewards Structure"

#. Preferences: chart layout right
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:201
msgctxt "chart layout side"
msgid "Right"
msgstr "Right"

#. Tournament leaderboard toggle
#: apps/web/src/features/tournament/components/leaderboard-columns.tsx:73
#: apps/web/src/features/tournament/components/leaderboard.tsx:95
#: apps/web/src/features/tournament/tournament-detail-page.tsx:180
msgid "ROI"
msgstr "ROI"

#. Tournament ROI column header tooltip
#: apps/web/src/features/tournament/components/leaderboard-columns.tsx:74
msgid "ROI = PnL / max(100, starting equity + sum of Inbound transfers)."
msgstr "ROI = PnL / max(100, starting equity + sum of Inbound transfers)."

#: apps/web/src/features/tournament/components/leaderboard.tsx:89
msgid "ROI Leaderboard"
msgstr "ROI Leaderboard"

#. CSV export hit its row cap; the downloaded file holds only the newest rows, back to the given date
#: packages/ui-kit/src/feature/terminal_tables/csv_export/ExportCsvDialog.tsx:198
msgid "Row limit reached: the file holds only the newest rows, back to {oldest}. Export earlier dates separately."
msgstr "Row limit reached: the file holds only the newest rows, back to {oldest}. Export earlier dates separately."

#. Countdown seconds unit (single letter)
#: apps/web/src/features/mpoints/components/hero-banner/hero-banner.tsx:136
#~ msgid "S"
#~ msgstr "S"

#. Countdown seconds unit (single letter)
#: apps/web/src/features/mpoints/components/hero-banner/hero-banner.tsx:148
msgctxt "countdown unit"
msgid "S"
msgstr "S"

#. Edit display name dialog save button
#. Share dialog download image
#: apps/web/src/features/referral/components/partner/edit-alias-dialog.tsx:54
#: packages/ui-kit/src/components/dialogs/share_pnl/ShareActionButtons.tsx:30
msgid "Save"
msgstr "Save"

#. Edit display name dialog save button (in-flight)
#: apps/web/src/features/referral/components/partner/edit-alias-dialog.tsx:53
msgid "Saving..."
msgstr "Saving..."

#. Memo cell saving label
#: apps/web/src/features/referral/components/referrals-history/memo-cell.tsx:65
msgid "Saving…"
msgstr "Saving…"

#. API key table column
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:85
msgid "Scope"
msgstr "Scope"

#. Tournament leaderboard toggle
#: apps/web/src/features/tournament/components/leaderboard.tsx:96
#: apps/web/src/features/tournament/tournament-detail-page.tsx:180
msgid "Score"
msgstr "Score"

#. Tournament score column header tooltip
#: apps/web/src/features/tournament/components/leaderboard-columns.tsx:98
msgid "Score = PnL × √volume — a composite ranking that rewards profit and trading volume together. Higher is better."
msgstr "Score = PnL × √volume — a composite ranking that rewards profit and trading volume together. Higher is better."

#: apps/web/src/features/tournament/components/leaderboard.tsx:88
msgid "Score Leaderboard"
msgstr "Score Leaderboard"

#. Market info search label
#: packages/ui-kit/src/feature/market_info/market_menu/market_search_input.tsx:27
msgid "Search"
msgstr "Search"

#. Builders leaderboard search input placeholder
#: apps/web/src/features/builders/components/BuildersCard.tsx:133
msgid "Search by builder"
msgstr "Search by builder"

#. Funding rates search input placeholder
#: apps/web/src/features/funding_rates/funding_rates.tsx:205
msgid "Search by name"
msgstr "Search by name"

#. Leaderboard search input placeholder
#: apps/web/src/features/leaderboard/components/LeaderboardCard.tsx:148
msgid "Search by wallet"
msgstr "Search by wallet"

#. Rewards menu mPoints item description
#: apps/web/src/components/header/rewards_menu/config.tsx:61
msgid "Seasonal Monad trading rewards"
msgstr "Seasonal Monad trading rewards"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:228
msgid "Secret — Ed25519 private key (32-byte seed). Save it in whichever encoding your client needs."
msgstr "Secret — Ed25519 private key (32-byte seed). Save it in whichever encoding your client needs."

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:231
msgid "Secret (base64url) copied"
msgstr "Secret (base64url) copied"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:230
msgid "Secret (hex) copied"
msgstr "Secret (hex) copied"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:232
msgid "Secret (PEM) copied"
msgstr "Secret (PEM) copied"

#: apps/web/src/features/points/components/countdown-card.tsx:58
#: apps/web/src/features/tournament/components/countdown-card.tsx:137
msgid "Secs"
msgstr "Secs"

#. Fee tiers dialog docs link
#: packages/ui-kit/src/components/dialogs/fee_tiers_dialog.tsx:196
msgid "See the docs for more →"
msgstr "See the docs for more →"

#. Market menu keyboard hint: Enter switches to the highlighted market
#: packages/ui-kit/src/feature/market_info/market_menu/market_menu_hints.tsx:45
msgctxt "keyboard shortcut"
msgid "Select"
msgstr "Select"

#. Flip dialog: no order book for this market
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:279
msgid "Select the {ticker} market to preview how this flip would fill."
msgstr "Select the {ticker} market to preview how this flip would fill."

#. Custom filter: Sell
#: packages/ui-kit/src/feature/terminal_tables/shared/getSideFilterOptions.tsx:12
msgid "Sell"
msgstr "Sell"

#. Mobile trade bar: open the order form on the short side
#: apps/web/src/features/terminal/mobile/mobile_trade_bar.tsx:44
msgid "Sell / Short"
msgstr "Sell / Short"

#: packages/ui-kit/src/components/dialogs/slippage_dialog.tsx:74
msgid "Set max slippage for market orders placed from this form. Fills up to this limit, then cancels any remainder."
msgstr "Set max slippage for market orders placed from this form. Fills up to this limit, then cancels any remainder."

#. Header settings button
#. Header settings button
#. Mobile drawer settings item
#. Preferences drawer title
#: apps/web/src/components/header/desktop_actions.tsx:103
#: apps/web/src/components/header/dex_header.tsx:162
#: apps/web/src/components/header/mobile_drawer.tsx:185
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:167
msgid "Settings"
msgstr "Settings"

#. Account history operation
#. Custom filter: Settlement
#: packages/ui-kit/src/feature/terminal_tables/account_history/constants.ts:27
#: packages/ui-kit/src/feature/terminal_tables/account_history/useFilterOptions.tsx:31
msgid "Settlement"
msgstr "Settlement"

#. Mobile P&L history card: share button
#. Mobile position card: share PnL button
#. Portfolio share PnL button
#. Referrals card CTA
#. Table header: Share
#. Table header: Share
#. TableCell : action Share
#: apps/web/src/features/mpoints/components/stat-cards/m-points-card.tsx:63
#: apps/web/src/features/points/components/total-points-card.tsx:40
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:180
#: apps/web/src/features/referral/components/referrals-card/referrals-card.tsx:63
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/pnl_history_columns.tsx:84
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/pnl_history_columns.tsx:95
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/pnl_history.tsx:104
#: packages/ui-kit/src/feature/terminal_tables/position/positions_table.tsx:108
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:117
msgid "Share"
msgstr "Share"

#. Dashboard table column: Perpl share of the chain
#: apps/web/src/features/dashboard/dashboard.tsx:236
msgctxt "dashboard table"
msgid "Share"
msgstr "Share"

#. Builders leaderboard column header: share of total builder volume, a percentage — not the "share" action
#: apps/web/src/features/builders/components/useBuilderColumns.tsx:76
msgctxt "market share"
msgid "Share"
msgstr "Share"

#. Share referral code button
#: apps/web/src/features/referral/components/partner/partner-hero-card.tsx:217
msgid "Share code"
msgstr "Share code"

#. Builders leaderboard Share column header tooltip
#: apps/web/src/features/builders/components/useBuilderColumns.tsx:81
msgid "Share of the total builder volume over the period."
msgstr "Share of the total builder volume over the period."

#. Share referral link on Telegram
#: apps/web/src/components/header/user_account_menu/account_menu_referral.tsx:87
msgid "Share on Telegram"
msgstr "Share on Telegram"

#. Share referral link on X (Twitter)
#: apps/web/src/components/header/user_account_menu/account_menu_referral.tsx:96
msgid "Share on X"
msgstr "Share on X"

#: apps/web/src/features/mpoints/components/share-points-dialog/share-points-dialog.tsx:44
msgid "Share Total mPoints"
msgstr "Share Total mPoints"

#: apps/web/src/features/mpoints/components/share-points-dialog/share-points-dialog.tsx:45
msgid "Share Total Points"
msgstr "Share Total Points"

#: apps/web/src/features/mpoints/components/share-points-dialog/share-points-dialog.tsx:44
msgid "Share Weekly mPoints"
msgstr "Share Weekly mPoints"

#: apps/web/src/features/mpoints/components/share-points-dialog/share-points-dialog.tsx:46
msgid "Share Weekly Points"
msgstr "Share Weekly Points"

#. Custom filter: Short
#. Keyboard shortcut action: switch the order form to Short
#. Trade side Short label
#. Trade side Short label
#: apps/web/src/features/shortcuts/shortcuts.ts:41
#: packages/ui-kit/src/feature/order_entry/side_switch/side_switch.tsx:46
#: packages/ui-kit/src/feature/order_entry/side_switch/side_switch.tsx:48
#: packages/ui-kit/src/feature/terminal_tables/shared/getSideFilterOptions.tsx:20
msgid "Short"
msgstr "Short"

#. Footer button that opens the keyboard shortcuts guide
#: apps/web/src/components/footer/dex_footer.tsx:110
msgid "Shortcuts"
msgstr "Shortcuts"

#. P&L history tooltip: insurance settlement amount
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:97
msgid "Shortfall covered by the insurance fund: {amount}"
msgstr "Shortfall covered by the insurance fund: {amount}"

#. Funding heatmap tooltip: funding paid at one event or over 24h, per reference position size. e.g. "$0.40 per $10K"
#: apps/web/src/features/funding-map/HeatmapTooltip.tsx:56
msgid "Shorts paid longs {amount} per {notional}"
msgstr "Shorts paid longs {amount} per {notional}"

#. Funding heatmap legend: negative rate
#: apps/web/src/features/funding-map/FundingHeatmapCard.tsx:112
msgid "Shorts pay longs"
msgstr "Shorts pay longs"

#. Favorites bar toggle aria label
#: apps/web/src/features/markets/favorites_bar.tsx:35
msgid "Show 24h change"
msgstr "Show 24h change"

#. Order book ticker: tooltip on the spread value
#: packages/ui-kit/src/feature/order_book/ticker/ticker.tsx:102
msgid "Show as percentage"
msgstr "Show as percentage"

#. Order book ticker: tooltip on the spread value
#: packages/ui-kit/src/feature/order_book/ticker/ticker.tsx:101
msgid "Show in basis points"
msgstr "Show in basis points"

#. Favorites bar toggle aria label
#: apps/web/src/features/markets/favorites_bar.tsx:37
msgid "Show price"
msgstr "Show price"

#. Builder dashboard live payout note while the previous epoch is still being processed
#: apps/web/src/features/builders/builderDashboard.tsx:113
msgid "Shown once the previous epoch is processed."
msgstr "Shown once the previous epoch is processed."

#. Portfolio liquidation risk bar tooltip
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:31
msgid "Shows the relative size of each position and how close it is to liquidation."
msgstr "Shows the relative size of each position and how close it is to liquidation."

#. Portfolio chart empty state button: start the sign-in signature
#. Table empty state button: start the sign-in signature
#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:62
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:85
msgid "Sign in"
msgstr "Sign in"

#. Sign in pending button
#: apps/web/src/features/account/hooks/useDepositButtonText.ts:34
msgid "Sign in pending"
msgstr "Sign in pending"

#. Account history table, wallet not signed in
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:122
msgid "Sign in with your wallet to see your account history"
msgstr "Sign in with your wallet to see your account history"

#. Funding history table, wallet not signed in
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:132
msgid "Sign in with your wallet to see your funding payments"
msgstr "Sign in with your wallet to see your funding payments"

#. Open orders table, wallet not signed in
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:97
msgid "Sign in with your wallet to see your open orders"
msgstr "Sign in with your wallet to see your open orders"

#. Order history table, wallet not signed in
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:108
msgid "Sign in with your wallet to see your order history"
msgstr "Sign in with your wallet to see your order history"

#. P&L history table, wallet not signed in
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:115
msgid "Sign in with your wallet to see your P&L history"
msgstr "Sign in with your wallet to see your P&L history"

#. Portfolio chart empty state body: wallet connected, not signed in
#: apps/web/src/features/portfolio/components/PortfolioChartCard.tsx:56
msgid "Sign in with your wallet to see your portfolio"
msgstr "Sign in with your wallet to see your portfolio"

#. Positions table, wallet not signed in
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:93
msgid "Sign in with your wallet to see your positions"
msgstr "Sign in with your wallet to see your positions"

#. Trade history table, wallet not signed in
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:101
msgid "Sign in with your wallet to see your trade history"
msgstr "Sign in with your wallet to see your trade history"

#. Close dialog: size field label
#. Edit order dialog size label
#. Label of Size
#. Mobile positions sort option
#. PiP metric size
#. PiP metric size
#. Size field label
#. Table header: Size
#: apps/web/src/features/account/close_position_dialog/SinglePositionContent.tsx:182
#: apps/web/src/features/picture_in_picture/components/OrderRow.tsx:155
#: apps/web/src/features/picture_in_picture/components/PositionRow.tsx:129
#: apps/web/src/features/trading/edit_order_dialog/index.tsx:178
#: packages/ui-kit/src/feature/order_entry/fields/size.tsx:69
#: packages/ui-kit/src/feature/terminal_tables/position/positions_table.tsx:170
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:73
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/tp_sl_modal.tsx:154
msgid "Size"
msgstr "Size"

#. Order book size
#: packages/ui-kit/src/feature/order_book/side/side.tsx:114
msgid "Size ({currency})"
msgstr "Size ({currency})"

#. Trade table size
#: packages/ui-kit/src/feature/order_book/trades/trades.tsx:97
msgid "Size ({shortCurrency})"
msgstr "Size ({shortCurrency})"

#. Stop loss price input label
#: packages/ui-kit/src/feature/order_entry/form/tp_sl.tsx:141
msgid "SL price"
msgstr "SL price"

#. Close dialog: slippage row label
#. Flip dialog: slippage row label
#. Market order fill prognosis: slippage label
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:121
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:177
#: packages/ui-kit/src/feature/order_entry/form/market_fill_prognosis.tsx:200
msgid "Slippage"
msgstr "Slippage"

#. Flip dialog: per-order slippage limit field label
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:322
#~ msgid "Slippage limit for this flip"
#~ msgstr "Slippage limit for this flip"

#. Custom slippage preset toggle
#: packages/ui-kit/src/components/dialogs/slippage_selector.tsx:168
msgid "Slippage preset"
msgstr "Slippage preset"

#. Preferences: toast duration
#: apps/web/src/components/header/user_settings/preferences-drawer/notification_preference_section.tsx:48
msgid "Slow ({seconds}s)"
msgstr "Slow ({seconds}s)"

#. Footer connection status
#: packages/ui-kit/src/common/heartbeatStore.ts:20
msgid "Slow Connection"
msgstr "Slow Connection"

#. Dashboard strip of snapshot totals
#: apps/web/src/features/dashboard/dashboard.tsx:161
msgid "Snapshot"
msgstr "Snapshot"

#. Tooltip for rewards this week referral stat
#: apps/web/src/features/referral/referral.tsx:85
msgid "Snapshots are taken {snapshot}. Transfers are processed biweekly."
msgstr "Snapshots are taken {snapshot}. Transfers are processed biweekly."

#: apps/web/src/features/mpoints/components/rewards-history-grid/rewards-history-grid.tsx:49
msgid "Snapshots are taken each Wednesday at 16:00 UTC. Points are updated by the following Monday."
msgstr "Snapshots are taken each Wednesday at 16:00 UTC. Points are updated by the following Monday."

#. Add referral code error (generic)
#. Edit display name dialog error (generic)
#: apps/web/src/features/referral/components/partner/edit-alias-dialog.tsx:74
#: apps/web/src/features/referral/components/referred-by.tsx:124
msgid "Something went wrong. Please try again."
msgstr "Something went wrong. Please try again."

#: apps/web/src/features/auth/components/geo_block_dialog.tsx:48
msgid "Sorry, the Perpl front end is not available in your current location. Users from <0>Restricted Territories</0> cannot use the platform."
msgstr "Sorry, the Perpl front end is not available in your current location. Users from <0>Restricted Territories</0> cannot use the platform."

#. Mobile card list: sort menu button; the visible label is the active sort field, e.g. "Sort by Value"
#: packages/ui-kit/src/components/datagrid/MobileCardList.tsx:176
msgid "Sort by {sortLabel}"
msgstr "Sort by {sortLabel}"

#. Dashboard source footnote
#: apps/web/src/features/dashboard/dashboard.tsx:246
msgid "Source: Dune onchain queries. Figures refresh with the published snapshot."
msgstr "Source: Dune onchain queries. Figures refresh with the published snapshot."

#. Dashboard source footnote with snapshot date
#. placeholder {0}: data.updatedAt
#: apps/web/src/features/dashboard/dashboard.tsx:366
#~ msgid "Source: Dune onchain queries. Snapshot {0}."
#~ msgstr "Source: Dune onchain queries. Snapshot {0}."

#. Order book ticker: bid-ask spread label
#: packages/ui-kit/src/feature/order_book/ticker/ticker.tsx:96
msgid "Spread"
msgstr "Spread"

#: apps/web/src/features/tournament/components/standing-shared.tsx:150
msgid "Standings are being finalised"
msgstr "Standings are being finalised"

#. Filter: Start date
#: packages/ui-kit/src/components/table/filter/date_range.tsx:157
msgid "Start date"
msgstr "Start date"

#: apps/web/src/features/tournament/components/countdown-card.tsx:201
msgid "Starts on {date}"
msgstr "Starts on {date}"

#. Builder payout history column header
#. Rewards history column header
#. Table header: Status
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:192
#: apps/web/src/features/referral/components/referrals-history/rewards-columns.tsx:143
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:101
msgid "Status"
msgstr "Status"

#. Flip dialog: typed slippage limit still stops the fill short
#. placeholder {0}: formatFraction(overridePlan.fillFraction)
#. placeholder {1}: formatPct(overridePlan.requiredCapPct)
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:162
#~ msgid "Still fills only about {0} — at least {1} is needed right now"
#~ msgstr "Still fills only about {0} — at least {1} is needed right now"

#. Flip dialog: typed slippage limit still stops the fill short. {overrideFillPct} = share of the order that fills (e.g. 60%), {overrideRequiredPct} = slippage needed (e.g. 2.35%)
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:174
#~ msgid "Still fills only about {overrideFillPct} — at least {overrideRequiredPct} is needed right now"
#~ msgstr "Still fills only about {overrideFillPct} — at least {overrideRequiredPct} is needed right now"

#. Stop limit order type
#: packages/ui-kit/src/feature/order_entry/form/order_type_bar.tsx:256
msgid "Stop Limit"
msgstr "Stop Limit"

#. PiP SL label
#: apps/web/src/features/picture_in_picture/components/PositionRow.tsx:165
msgid "Stop loss"
msgstr "Stop loss"

#. Label of Stop Loss
#. Label stop loss price input
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/fields/tp_sl_input_section.tsx:147
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/tp_sl_modal.tsx:180
msgid "Stop Loss"
msgstr "Stop Loss"

#. Stop market order type
#: packages/ui-kit/src/feature/order_entry/form/order_type_bar.tsx:264
msgid "Stop Market"
msgstr "Stop Market"

#. Chart overlay preference
#: apps/web/src/components/header/user_settings/preferences-drawer/chart_overlay_preference_section.tsx:17
msgid "Stop orders"
msgstr "Stop orders"

#. Tooltip on the sub-referral count next to Traders Referred
#. Tooltip on the sub-referral count next to users referred
#: apps/web/src/features/referral/components/partner/partner-stats.tsx:96
#: apps/web/src/features/referral/referral.tsx:93
msgid "Sub-referrals your referees have invited."
msgstr "Sub-referrals your referees have invited."

#. Rewards breakdown — sub-referrals portion
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:329
msgid "Sub-referrals:"
msgstr "Sub-referrals:"

#: apps/web/src/features/auth/components/access_request_dialog.tsx:144
msgid "Success!"
msgstr "Success!"

#. Order book hover range asset size sum
#. Order book hover range quote notional sum
#: packages/ui-kit/src/feature/order_book/hover_popover/hover_popover.tsx:142
#: packages/ui-kit/src/feature/order_book/hover_popover/hover_popover.tsx:151
msgid "Sum {currency}"
msgstr "Sum {currency}"

#. Market info table column header. The cells hold a market ticker (BTC-USD), so translate this as "ticker" or "pair" — not as the word for a typographic character or sign.
#: packages/ui-kit/src/feature/market_info/market_menu/market_menu_table.tsx:257
msgid "Symbol"
msgstr "Symbol"

#. Preferences: system default font option
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:359
msgid "System Default"
msgstr "System Default"

#. PiP TP label
#: apps/web/src/features/picture_in_picture/components/PositionRow.tsx:157
msgid "Take profit"
msgstr "Take profit"

#. Label of Take Profit
#. Label take profit price input
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/fields/tp_sl_input_section.tsx:137
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/tp_sl_modal.tsx:172
msgid "Take Profit"
msgstr "Take Profit"

#. Dashboard chart legend: taker fees
#. Fee table column: taker fee in bps (compact)
#: apps/web/src/components/header/user_account_menu/fees_panel.tsx:144
#: apps/web/src/features/dashboard/dashboardLabels.ts:14
msgid "Taker"
msgstr "Taker"

#: packages/ui-kit/src/components/dialogs/fee_tiers_dialog.tsx:144
msgid "Taker (bps)"
msgstr "Taker (bps)"

#. Market making table header
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:112
msgid "Taker Fees"
msgstr "Taker Fees"

#. Market making table header: number of taker fills
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:115
msgid "Taker Fills"
msgstr "Taker Fills"

#. Market making table header
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:109
msgid "Taker Volume"
msgstr "Taker Volume"

#. Points rank placeholder for pre-season
#: apps/web/src/features/points/components/points-history-grid/cells/weekly-points.tsx:29
#: apps/web/src/features/points/components/points-history-grid/columns.tsx:89
msgid "TBA"
msgstr "TBA"

#: apps/web/src/features/auth/components/terms_dialog.tsx:72
msgid "Terms of Use"
msgstr "Terms of Use"

#. Header nav item linking to the test deployment. Keep "Testnet" in Latin script — it is the network's name, and it sits in the same menu as other untranslated names.
#: apps/web/src/components/header/constants.ts:169
msgid "Testnet"
msgstr "Testnet"

#: apps/web/src/features/auth/components/geo_block_dialog.tsx:57
msgid "Thank you for your understanding."
msgstr "Thank you for your understanding."

#. Order form summary tooltip: margin required
#: packages/ui-kit/src/feature/order_entry/constants.ts:39
msgid "The amount of collateral you must provide to open this position."
msgstr "The amount of collateral you must provide to open this position."

#. Header nav item. "The Bag" is the product name of a rewards feature — keep it in Latin script and do not translate or transliterate it.
#: apps/web/src/components/header/constants.ts:64
msgid "The Bag"
msgstr "The Bag"

#. Builder payout awaiting-transfer status tooltip
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:71
msgid "The epoch has closed and this amount is final. No matching transfer has been seen yet."
msgstr "The epoch has closed and this amount is final. No matching transfer has been seen yet."

#. Order form summary tooltip: liquidation price
#: packages/ui-kit/src/feature/order_entry/constants.ts:24
msgid "The estimated price at which your position will be liquidated if your margin balance falls below the maintenance margin."
msgstr "The estimated price at which your position will be liquidated if your margin balance falls below the maintenance margin."

#. Close dialog: combined fees tooltip for a limit close
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:90
#~ msgid "The fee paid when this position was opened, pro-rated to the size you are closing, plus the estimated fee for closing at the current mark price — shown as maker / taker. A limit order that rests on the book pays the maker fee; one that fills immediately pays the taker fee."
#~ msgstr "The fee paid when this position was opened, pro-rated to the size you are closing, plus the estimated fee for closing at the current mark price — shown as maker / taker. A limit order that rests on the book pays the maker fee; one that fills immediately pays the taker fee."

#. Close dialog: combined fees tooltip for a market close
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:96
#~ msgid "The fee paid when this position was opened, pro-rated to the size you are closing, plus the estimated fee for closing at the current mark price. A market close pays the taker fee."
#~ msgstr "The fee paid when this position was opened, pro-rated to the size you are closing, plus the estimated fee for closing at the current mark price. A market close pays the taker fee."

#. Close dialog: opening fees tooltip
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:76
#~ msgid "The fee paid when this position was opened, pro-rated to the size you are closing. It settles against your realized PnL on close."
#~ msgstr "The fee paid when this position was opened, pro-rated to the size you are closing. It settles against your realized PnL on close."

#: apps/web/src/features/mpoints/components/hero-banner/hero-banner.tsx:174
msgid "The full amount is now unlocked! • 1 mPoint = $1 • Paid at season end • <0>Read More.</0>"
msgstr "The full amount is now unlocked! • 1 mPoint = $1 • Paid at season end • <0>Read More.</0>"

#. The maximum leverage for this market display
#: packages/ui-kit/src/feature/order_entry/form/account_leverage.tsx:159
msgid "The maximum leverage for this market is {leverage}x."
msgstr "The maximum leverage for this market is {leverage}x."

#. trigger/execution explanation for tp/sl modal
#. placeholder {0}: tpSlOrderConfig?.triggerOnMarkPrice ? 'mark' : 'last'
#. placeholder {1}: tpSlOrderConfig?.ordersUseIoc ? 'market' : 'limit'
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/tp_sl_modal.tsx:219
msgid "The order is triggered when the {0, select, mark {mark price} other {last price}} reaches the take profit or stop loss price{1, select, market { and is executed as a market order} other {}}."
msgstr "The order is triggered when the {0, select, mark {mark price} other {last price}} reaches the take profit or stop loss price{1, select, market { and is executed as a market order} other {}}."

#. Close dialog: slippage estimate availability caveat
#: apps/web/src/features/account/close_position_dialog/CloseInfoRows.tsx:129
msgid "The slippage estimate is only available while this position's market is the active (selected) one."
msgstr "The slippage estimate is only available while this position's market is the active (selected) one."

#: apps/web/src/hooks/useOntarioBanAnnouncement.ts:31
#~ msgid "The Terms of Service and local law prevent this service from being offered in Ontario. It will be blocked for Ontario users on {BLOCK_AT}. If you are located in the province of Ontario, please close your positions and withdraw your funds before then. If you missed that opportunity, please contact us on Discord: {discordUrl}"
#~ msgstr "The Terms of Service and local law prevent this service from being offered in Ontario. It will be blocked for Ontario users on {BLOCK_AT}. If you are located in the province of Ontario, please close your positions and withdraw your funds before then. If you missed that opportunity, please contact us on Discord: {discordUrl}"

#: apps/web/src/hooks/useOntarioBanAnnouncement.ts:31
#~ msgid "The Terms of Service and local law prevent this service from being offered in Ontario. It will be blocked for Ontario users on {blockAt}. If you are located in the province of Ontario, please close your positions and withdraw your funds before then. If you missed that opportunity, please contact us on Discord: {discordUrl}"
#~ msgstr "The Terms of Service and local law prevent this service from being offered in Ontario. It will be blocked for Ontario users on {blockAt}. If you are located in the province of Ontario, please close your positions and withdraw your funds before then. If you missed that opportunity, please contact us on Discord: {discordUrl}"

#: apps/web/src/hooks/useOntarioBanAnnouncement.ts:21
#~ msgid "The Terms of Service and local law prevent this service from being offered in Ontario. It will be blocked for Ontario users soon. If you are located in the province of Ontario, please close your positions and withdraw your funds before then. If you missed that opportunity, please contact us on Discord: {discordUrl}"
#~ msgstr "The Terms of Service and local law prevent this service from being offered in Ontario. It will be blocked for Ontario users soon. If you are located in the province of Ontario, please close your positions and withdraw your funds before then. If you missed that opportunity, please contact us on Discord: {discordUrl}"

#. Tooltip for total rewards earned referral stat
#: apps/web/src/features/referral/referral.tsx:89
msgid "The total amount of rewards transferred to your account. Does not count rewards accrued in current epoch."
msgstr "The total amount of rewards transferred to your account. Does not count rewards accrued in current epoch."

#. Order form summary tooltip: order value
#: packages/ui-kit/src/feature/order_entry/constants.ts:32
msgid "The total notional value of this order (price × size)."
msgstr "The total notional value of this order (price × size)."

#. Account panel tooltip: account value
#: apps/web/src/features/account/account_status.tsx:50
msgid "The total value of assets in your account, including both unrealized PnL and available balance"
msgstr "The total value of assets in your account, including both unrealized PnL and available balance"

#. Fee tiers dialog callout body: the rates shown are per trade, charged on open and again on close
#: packages/ui-kit/src/components/dialogs/fee_tiers_dialog.tsx:178
msgid "These fees are per trade: you pay them when you open a position and again when you close it."
msgstr "These fees are per trade: you pay them when you open a position and again when you close it."

#: apps/web/src/features/leaderboard/components/dialog/badges_dialog.tsx:94
msgid "They can no longer be earned."
msgstr "They can no longer be earned."

#: apps/web/src/features/auth/hooks/useAccessRequestState.ts:93
msgid "This code is invalid, or there are no more invites currently associated with this code."
msgstr "This code is invalid, or there are no more invites currently associated with this code."

#. Builder dashboard note under a retired code
#: apps/web/src/features/builders/builderDashboard.tsx:52
msgid "This code keeps its history but earns nothing in epochs that close while it is retired."
msgstr "This code keeps its history but earns nothing in epochs that close while it is retired."

#. Partner current epoch stats heading
#: apps/web/src/features/referral/components/partner/partner-stats.tsx:137
msgid "This Epoch"
msgstr "This Epoch"

#. Flip dialog: free balance does not cover the flip's margin and round-trip fee
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:307
msgid "This flip needs about {requiredText} in free balance, {shortfallText} more than you have. Both legs pay a taker fee, so the exchange would reject it."
msgstr "This flip needs about {requiredText} in free balance, {shortfallText} more than you have. Both legs pay a taker fee, so the exchange would reject it."

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:46
msgid "This key is already registered. Please try again."
msgstr "This key is already registered. Please try again."

#. Table tooltip: Isolated margin explainer
#: packages/ui-kit/src/components/table/fields/margin/margin_field.tsx:57
msgid "This position's collateral is isolated – your account balance will not be used to defend it."
msgstr "This position's collateral is isolated – your account balance will not be used to defend it."

#. Add referral code error (invalid code)
#: apps/web/src/features/referral/components/referred-by.tsx:123
msgid "This referral code is invalid or exhausted."
msgstr "This referral code is invalid or exhausted."

#. Rewards breakdown — direct referee portion
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:320
msgid "This referral:"
msgstr "This referral:"

#. Referrals live weekly rewards row
#: apps/web/src/components/header/rewards_menu/panels.tsx:268
msgid "This week"
msgstr "This week"

#. Close-all dialog: explanatory paragraph
#: apps/web/src/features/account/close_position_dialog/CloseAllContent.tsx:64
#~ msgid "This will close all of your positions and cancel all TP/SL orders, along with any resting reduce-only limit orders — even if a close does not fill. If you choose Limit Close, this will set orders for all positions."
#~ msgstr "This will close all of your positions and cancel all TP/SL orders, along with any resting reduce-only limit orders — even if a close does not fill. If you choose Limit Close, this will set orders for all positions."

#. Close-all dialog: explanatory paragraph
#: apps/web/src/features/account/close_position_dialog/CloseAllContent.tsx:82
#~ msgid "This will close all of your positions and cancel all TP/SL orders, along with any resting reduce-only limit orders on the positions that close. If you choose Limit Close, this will set orders for all positions."
#~ msgstr "This will close all of your positions and cancel all TP/SL orders, along with any resting reduce-only limit orders on the positions that close. If you choose Limit Close, this will set orders for all positions."

#. Close-all dialog: explanatory paragraph
#: apps/web/src/features/account/close_position_dialog/CloseAllContent.tsx:64
#~ msgid "This will close all of your positions and cancel all TP/SL orders. If you choose Limit Close, this will set orders for all positions."
#~ msgstr "This will close all of your positions and cancel all TP/SL orders. If you choose Limit Close, this will set orders for all positions."

#. Close-all dialog: explanatory paragraph. Close All covers only the positions the table's filters show; with no filters, that is every position
#: apps/web/src/features/account/close_position_dialog/CloseAllContent.tsx:65
msgid "This will close the positions shown in the table and cancel their TP/SL orders, along with any resting reduce-only limit orders on them. If you choose Limit Close, this will set orders for those positions."
msgstr "This will close the positions shown in the table and cancel their TP/SL orders, along with any resting reduce-only limit orders on them. If you choose Limit Close, this will set orders for those positions."

#. Filter: This Year
#: packages/ui-kit/src/components/table/filter/date_range.tsx:103
msgid "This Year"
msgstr "This Year"

#. Fee table column: tier
#. Rewards structure column header
#: apps/web/src/components/header/user_account_menu/fees_panel.tsx:141
#: apps/web/src/features/referral/components/partner/rewards-structure-dialog.tsx:53
#: packages/ui-kit/src/components/dialogs/fee_tiers_dialog.tsx:144
msgid "Tier"
msgstr "Tier"

#. Partner locked tier headline
#. Partner tier N track label
#: apps/web/src/features/referral/components/partner/partner-hero-card.tsx:227
#: apps/web/src/features/referral/components/partner/partner-tier-tracker.tsx:79
msgid "Tier {tier}"
msgstr "Tier {tier}"

#. Rewards structure empty state when the API ships no tier ladder
#: apps/web/src/features/referral/components/partner/rewards-structure-dialog.tsx:115
msgid "Tier details are unavailable right now."
msgstr "Tier details are unavailable right now."

#. Link opening the partner tier/rewards structure dialog
#: apps/web/src/features/referral/components/partner/partner-hero-card.tsx:247
msgid "Tier structure"
msgstr "Tier structure"

#. Funding history popover header: Time
#. Table header: Time
#. Trade table time
#: packages/ui-kit/src/feature/market_info/funding_history_popover.tsx:151
#: packages/ui-kit/src/feature/order_book/trades/trades.tsx:106
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:71
msgid "Time"
msgstr "Time"

#. Funding rates table column header: countdown to the next funding event
#: apps/web/src/features/funding_rates/funding_rates.tsx:146
msgid "Time to Next Funding"
msgstr "Time to Next Funding"

#. Liquidation split: trader share
#: packages/ui-kit/src/feature/terminal_tables/LiquidationDistributionTooltip.tsx:25
msgid "To you"
msgstr "To you"

#. Filter: Today
#. Filter: Today
#. Filter: Today
#: apps/web/src/features/builders/components/BuildersCard.tsx:120
#: apps/web/src/features/leaderboard/components/LeaderboardCard.tsx:135
#: packages/ui-kit/src/components/table/filter/date_range.tsx:100
msgid "Today"
msgstr "Today"

#. Header Tools dropdown trigger
#: apps/web/src/components/header/nav_hover_group/nav_hover_group.tsx:240
msgid "Tools"
msgstr "Tools"

#. Preferences: toast position
#: apps/web/src/components/header/user_settings/preferences-drawer/notification_preference_section.tsx:36
msgid "Top Center"
msgstr "Top Center"

#. Preferences: toast position
#: apps/web/src/components/header/user_settings/preferences-drawer/notification_preference_section.tsx:33
msgid "Top Right"
msgstr "Top Right"

#. Tools menu leaderboard description
#: apps/web/src/components/header/tools_menu/config.tsx:28
msgid "Top traders on Perpl"
msgstr "Top traders on Perpl"

#. Market making table: label of the pinned row summing every market
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:71
msgid "Total"
msgstr "Total"

#. Order book total
#: packages/ui-kit/src/feature/order_book/side/side.tsx:120
msgid "Total ({currency})"
msgstr "Total ({currency})"

#. Builder dashboard stat label
#: apps/web/src/features/builders/builderDashboard.tsx:129
msgid "Total Earned"
msgstr "Total Earned"

#. Market making table header
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:113
msgid "Total Fees"
msgstr "Total Fees"

#. Builders page Builder Fees stat tooltip
#: apps/web/src/features/builders/components/BuilderTotals.tsx:43
msgid "Total fees earned by builders over the period."
msgstr "Total fees earned by builders over the period."

#. Order form fees tooltip: combined opening + closing fee, maker / taker
#: packages/ui-kit/src/feature/order_entry/constants.ts:50
#~ msgid "Total fees for opening and closing this position, shown as maker / taker. Maker fees apply when your order adds liquidity; taker fees apply when it removes liquidity."
#~ msgstr "Total fees for opening and closing this position, shown as maker / taker. Maker fees apply when your order adds liquidity; taker fees apply when it removes liquidity."

#. Market making table header: number of fills
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:116
msgid "Total Fills"
msgstr "Total Fills"

#. Portfolio 10% stress test tooltip
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:227
#~ msgid "Total margin in positions that would be liquidated by a 10% adverse price move."
#~ msgstr "Total margin in positions that would be liquidated by a 10% adverse price move."

#. Portfolio 5% stress test tooltip
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:219
#~ msgid "Total margin in positions that would be liquidated by a 5% adverse price move."
#~ msgstr "Total margin in positions that would be liquidated by a 5% adverse price move."

#. Share card headline
#: apps/web/src/features/mpoints/components/share-points-dialog/points-share-card.tsx:198
msgid "Total mPoints"
msgstr "Total mPoints"

#. Footer label for open orders table row count
#: packages/ui-kit/src/feature/terminal_tables/open_orders/open_orders.tsx:151
msgid "Total orders:"
msgstr "Total orders:"

#. Footer label for positions table row count
#: packages/ui-kit/src/feature/terminal_tables/position/positions_table.tsx:192
msgid "Total positions:"
msgstr "Total positions:"

#. Share card stat label: the trader's standing on the all-time leaderboard. Use the everyday word for a finishing position ("place"), the same one used in the share tweet body — not a military or academic "rank".
#: apps/web/src/features/mpoints/components/share-points-dialog/points-share-card.tsx:250
msgid "Total Rank"
msgstr "Total Rank"

#: apps/web/src/features/points/components/total-points-card.tsx:45
msgid "Total Rank • <0>{rankText}</0>"
msgstr "Total Rank • <0>{rankText}</0>"

#. Rewards summary panel headline
#: apps/web/src/components/header/rewards_menu/panels.tsx:369
msgid "Total rewards"
msgstr "Total rewards"

#. Referral stat label
#: apps/web/src/features/referral/referral.tsx:75
msgid "Total Rewards Earned"
msgstr "Total Rewards Earned"

#. Portfolio stat label
#: apps/web/src/features/builders/components/BuilderTotals.tsx:28
#: apps/web/src/features/portfolio/components/StatCards.tsx:58
msgid "Total Trades"
msgstr "Total Trades"

#. Dashboard KPI: accounts that have ever traded
#: apps/web/src/features/dashboard/dashboard.tsx:153
msgid "Total Users"
msgstr "Total Users"

#. Referrals card label
#. Referrals card label
#: apps/web/src/features/referral/components/referrals-card/config.ts:70
#: apps/web/src/features/referral/components/referrals-card/share-referral-dialog.tsx:50
msgid "Total Users Referred"
msgstr "Total Users Referred"

#. Portfolio Perps Equity tooltip
#: apps/web/src/features/portfolio/components/AccountOverviewCard.tsx:192
msgid "Total value held in perpetual positions.\n"
"Sum of all position margins plus unrealized PnL."
msgstr "Total value held in perpetual positions.\n"
"Sum of all position margins plus unrealized PnL."

#. Total value of active positions in this market.
#: packages/ui-kit/src/feature/market_info/coin_info/market_metrics.tsx:133
msgid "Total value of active positions in this market."
msgstr "Total value of active positions in this market."

#. Market making table header
#. Referral history column header
#: apps/web/src/features/builders/components/BuilderTotals.tsx:27
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:132
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:110
msgid "Total Volume"
msgstr "Total Volume"

#. Partner stat label
#. Referral stat label
#. Referrals card label
#. Referrals card label
#: apps/web/src/features/referral/components/partner/partner-stats.tsx:179
#: apps/web/src/features/referral/components/referrals-card/config.ts:71
#: apps/web/src/features/referral/components/referrals-card/share-referral-dialog.tsx:56
#: apps/web/src/features/referral/referral.tsx:73
msgid "Total Volume Referred"
msgstr "Total Volume Referred"

#: apps/web/src/features/tournament/components/tournament-breadcrumbs.tsx:14
msgid "Tournament breadcrumb"
msgstr "Tournament breadcrumb"

#: apps/web/src/features/tournament/components/countdown-card.tsx:145
msgid "Tournament Ended"
msgstr "Tournament Ended"

#: apps/web/src/features/tournament/components/countdown-card.tsx:148
msgid "Tournament Ends in"
msgstr "Tournament Ends in"

#: apps/web/src/features/tournament/components/countdown-card.tsx:147
msgid "Tournament Starts in"
msgstr "Tournament Starts in"

#. Header nav item
#: apps/web/src/components/header/constants.ts:44
#: apps/web/src/features/tournament/components/tournament-breadcrumbs.tsx:16
#: apps/web/src/features/tournament/tournaments-list-page.tsx:27
msgid "Tournaments"
msgstr "Tournaments"

#. Chart overlay preference
#: apps/web/src/components/header/user_settings/preferences-drawer/chart_overlay_preference_section.tsx:18
msgid "TP / SL"
msgstr "TP / SL"

#. Take profit price input label
#: packages/ui-kit/src/feature/order_entry/form/tp_sl.tsx:140
msgid "TP price"
msgstr "TP price"

#. Table header: Take Profit/Stop Loss
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:108
msgid "TP/SL"
msgstr "TP/SL"

#. Header nav item
#: apps/web/src/components/header/constants.ts:28
msgid "Trade"
msgstr "Trade"

#. API key permission chip
#: apps/web/src/features/api-keys/components/api-keys-table.tsx:92
msgctxt "api key scope"
msgid "Trade"
msgstr "Trade"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:136
msgid "Trade — place, modify and cancel orders (includes read)"
msgstr "Trade — place, modify and cancel orders (includes read)"

#: apps/web/src/features/tournament/hooks/useStandings.ts:106
msgid "Trade {amount} more volume to qualify for a prize"
msgstr "Trade {amount} more volume to qualify for a prize"

#. Referrals card CTA shown when the referral code is locked behind a trading-volume threshold
#: apps/web/src/features/referral/components/referrals-card/referrals-card.tsx:100
msgid "Trade {amount} to unlock"
msgstr "Trade {amount} to unlock"

#. Tab title: Trade History
#. Tab title: Trade History
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:259
#: packages/ui-kit/src/feature/terminal_tables/trade_history/trade_history.tsx:81
msgid "Trade History"
msgstr "Trade History"

#. Account tab render error
#: packages/ui-kit/src/feature/terminal_tables/account_dashboard.tsx:297
msgid "Trade History failed to render."
msgstr "Trade History failed to render."

#: apps/web/src/features/tournament/components/standing-card.tsx:144
msgid "Trade now"
msgstr "Trade now"

#. Tools menu testnet description
#: apps/web/src/components/header/tools_menu/config.tsx:52
msgid "Trade on Perpl testnet"
msgstr "Trade on Perpl testnet"

#. Share tweet call to action
#: apps/web/src/features/mpoints/components/share-points-dialog/hooks/usePointsShareActions.ts:144
msgid "Trade perps on @perpltrade:"
msgstr "Trade perps on @perpltrade:"

#. Trade side switch aria description
#: packages/ui-kit/src/feature/order_entry/side_switch/side_switch.tsx:30
msgid "Trade side switch"
msgstr "Trade side switch"

#. Table header: Trade Value
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:96
msgid "Trade Value"
msgstr "Trade Value"

#: apps/web/src/features/tournament/components/leaderboard-columns.tsx:42
msgid "Trader"
msgstr "Trader"

#. Builder dashboard stat label: distinct accounts
#. Builders leaderboard column header: distinct traders
#: apps/web/src/features/builders/builderDashboard.tsx:152
#: apps/web/src/features/builders/components/BuilderTotals.tsx:32
#: apps/web/src/features/builders/components/useBuilderColumns.tsx:118
msgid "Traders"
msgstr "Traders"

#. Referral stat label
#: apps/web/src/features/referral/referral.tsx:72
msgid "Traders Referred"
msgstr "Traders Referred"

#. Builders leaderboard column header: number of trades
#. Terminal tab: recent trades
#. Terminal tab: recent trades
#: apps/web/src/features/builders/components/useBuilderColumns.tsx:109
#: apps/web/src/features/order_book/orders_panel.tsx:133
#: apps/web/src/features/terminal/mobile/mobile_trading_layout.tsx:47
msgid "Trades"
msgstr "Trades"

#. Connection status tooltip line
#: packages/ui-kit/src/common/heartbeatStore.ts:34
msgid "Trading connection disconnected"
msgstr "Trading connection disconnected"

#. Connection status tooltip line
#: packages/ui-kit/src/common/heartbeatStore.ts:36
msgid "Trading connection error"
msgstr "Trading connection error"

#. Connection status tooltip line
#: packages/ui-kit/src/common/heartbeatStore.ts:38
msgid "Trading connection slow"
msgstr "Trading connection slow"

#. Order form fees tooltip: maker / taker
#: packages/ui-kit/src/feature/order_entry/constants.ts:55
msgid "Trading fees shown as maker / taker. Maker fees apply when your order adds liquidity; taker fees apply when it removes liquidity."
msgstr "Trading fees shown as maker / taker. Maker fees apply when your order adds liquidity; taker fees apply when it removes liquidity."

#. Preferences: trading panels section title
#: apps/web/src/components/header/user_settings/preferences-drawer/terminal_panels_section.tsx:28
msgid "Trading Panels"
msgstr "Trading Panels"

#: apps/web/src/features/tournament/components/leaderboard-columns.tsx:97
msgid "Trading Score"
msgstr "Trading Score"

#: apps/web/src/features/tournament/components/leaderboard-columns.tsx:53
msgid "Trading Volume"
msgstr "Trading Volume"

#. Preferences: transactions section title
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:168
msgid "Transactions"
msgstr "Transactions"

#. Account history operation
#: packages/ui-kit/src/feature/terminal_tables/account_history/constants.ts:33
msgid "Transfer In"
msgstr "Transfer In"

#. Account history operation
#: packages/ui-kit/src/feature/terminal_tables/account_history/constants.ts:31
msgid "Transfer Out"
msgstr "Transfer Out"

#. Fund account menu withdraw description
#: apps/web/src/components/header/fund_account_menu/index.tsx:166
msgid "Transfer to your wallet"
msgstr "Transfer to your wallet"

#. Builder payout status: paid
#. Reward status: transferred
#. Rewards filter option
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:43
#: apps/web/src/features/referral/components/referrals-history/referrals-history.tsx:89
#: apps/web/src/features/referral/components/referrals-history/rewards-columns.tsx:48
msgid "Transferred"
msgstr "Transferred"

#. Custom filter: Transfers
#: packages/ui-kit/src/feature/terminal_tables/account_history/useFilterOptions.tsx:41
msgid "Transfers"
msgstr "Transfers"

#. Tooltip explaining live epoch status
#. Tooltip explaining processing epoch status
#: apps/web/src/features/referral/components/referrals-history/rewards-columns.tsx:15
#: apps/web/src/features/referral/components/referrals-history/rewards-columns.tsx:29
msgid "Transfers are processed biweekly."
msgstr "Transfers are processed biweekly."

#. Edit order dialog trigger price input label. This is a field label, so use a noun phrase ("trigger price") to match the surrounding labels — not a verb phrase like "it will fire when…".
#. Trade console trigger price input label. This is a field label, so use a noun phrase ("trigger price") to match the surrounding labels — not a verb phrase like "it will fire when…".
#: apps/web/src/features/trading/edit_order_dialog/index.tsx:165
#: packages/ui-kit/src/feature/order_entry/fields/stop_price.tsx:23
msgid "Trigger at"
msgstr "Trigger at"

#. Table header: Trigger Conditions
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:115
msgid "Trigger Conditions"
msgstr "Trigger Conditions"

#. PiP trigger price
#. PiP trigger price
#: apps/web/src/features/picture_in_picture/components/OrderRow.tsx:100
#: apps/web/src/features/picture_in_picture/components/OrderRow.tsx:165
msgid "Trigger price"
msgstr "Trigger price"

#. TP/SL form validation
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/schema.tsx:8
msgid "Trigger price is required"
msgstr "Trigger price is required"

#. Order form validation
#: packages/ui-kit/src/feature/order_entry/order_schema.ts:21
msgid "Trigger price must be greater than zero"
msgstr "Trigger price must be greater than zero"

#. Tooltip explaining the Triggered order status. Shown in live Open Orders AND in the Order History log, where the order already resolved — state the mechanism, not a current 'we are waiting' state.
#: packages/ui-kit/src/components/table/fields/status/status.tsx:56
msgid "Trigger price reached — the order executes once the order book has liquidity at the target price level."
msgstr "Trigger price reached — the order executes once the order book has liquidity at the target price level."

#. Tooltip explaining the Triggered order status
#: packages/ui-kit/src/components/table/fields/status/status.tsx:56
#~ msgid "Trigger price reached — waiting for order book liquidity at the target price level to execute the trade."
#~ msgstr "Trigger price reached — waiting for order book liquidity at the target price level to execute the trade."

#. Preferences: liquidation alerts info tooltip
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:383
msgid "Triggers on how far the mark price has moved from your entry toward your liquidation price. Adding margin lowers it."
msgstr "Triggers on how far the mark price has moved from your entry toward your liquidation price. Adding margin lowers it."

#: apps/web/src/features/account/components/deposit_panel.tsx:126
#: apps/web/src/features/account/components/withdraw_panel.tsx:102
msgid "Try lower amount"
msgstr "Try lower amount"

#. Disable one-click trading confirmation body
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:153
msgid "Turning off one-click trading will cancel all open orders with stop parameters (Stop Loss, Take Profit, etc.). Are you sure you want to proceed?"
msgstr "Turning off one-click trading will cancel all open orders with stop parameters (Stop Loss, Take Profit, etc.). Are you sure you want to proceed?"

#. Dashboard KPI: total value locked
#. Dashboard chart: daily total value locked
#: apps/web/src/features/dashboard/dashboard.tsx:147
#: apps/web/src/features/dashboard/dashboardLabels.ts:27
msgid "TVL"
msgstr "TVL"

#. Share dialog post to X
#: packages/ui-kit/src/components/dialogs/share_pnl/ShareActionButtons.tsx:43
msgid "Tweet"
msgstr "Tweet"

#: apps/web/src/features/tournament/components/header-banner.tsx:135
msgid "Two ways to win • {durationWeeks, plural, one {# week} other {# weeks}} competition • <0>Read more<1/></0>"
msgstr "Two ways to win • {durationWeeks, plural, one {# week} other {# weeks}} competition • <0>Read more<1/></0>"

#. Table header: Type
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:102
msgid "Type"
msgstr "Type"

#. Preferences drawer UI version
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:426
msgid "UI version: {version}"
msgstr "UI version: {version}"

#. Geo-blocked action button
#. Geo-blocked action button
#. Geo-blocked connect button
#: apps/web/src/components/rainbow/CustomConnectButton.tsx:106
#: apps/web/src/features/account/hooks/useDepositButtonText.ts:25
#: apps/web/src/features/auth/components/geo_block_dialog.tsx:45
#: packages/ui-kit/src/feature/order_entry/form/forms_action_buttons.tsx:44
msgid "Unavailable in your location"
msgstr "Unavailable in your location"

#. Account history operation
#: packages/ui-kit/src/feature/terminal_tables/account_history/constants.ts:47
msgid "Unknown"
msgstr "Unknown"

#: apps/web/src/features/mpoints/components/hero-banner/reward-steps.tsx:77
msgid "Unlocked"
msgstr "Unlocked"

#. Origins tier when the user holds no origin badge
#: apps/web/src/utils/badge.ts:18
msgid "Unranked"
msgstr "Unranked"

#. Account panel row label
#: apps/web/src/features/account/account_status.tsx:70
msgid "Unrealized PnL"
msgstr "Unrealized PnL"

#. Table header: Unrealized PNL
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:97
msgid "Unrealized PNL"
msgstr "Unrealized PNL"

#. Table header tooltip: Unrealized PnL
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:139
msgid "Unrealized PNL includes funding payments but excludes fees, which are applied when the position is closed."
msgstr "Unrealized PNL includes funding payments but excludes fees, which are applied when the position is closed."

#. P&L history event fallback label: the protocol wound the position down because the account could not fund it. A forced close, sibling to Liquidation and Deleverage — not the word for disbanding an organisation.
#. P&L history event label: the protocol wound the position down because the account could not fund it. A forced close, sibling to Liquidation and Deleverage — not the word for disbanding an organisation.
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:47
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:79
msgid "Unwind"
msgstr "Unwind"

#. Account history operation: the protocol wound a position down because the account could not fund it. A forced close, sibling to Liquidation and Deleveraging — not the word for disbanding an organisation.
#: packages/ui-kit/src/feature/terminal_tables/account_history/constants.ts:39
msgid "Unwinding"
msgstr "Unwinding"

#: apps/web/src/components/summer-banner/summer-banner.tsx:54
msgid "Up to {amount}"
msgstr "Up to {amount}"

#. mPoints hero: the cap is formatted for the browser locale, so never hardcode digit grouping in a translation
#: apps/web/src/features/mpoints/components/hero-banner/hero-banner.tsx:186
msgid "Up to {max} will be unlocked, based on trading activity on Perpl. <0>Read More.</0>"
msgstr "Up to {max} will be unlocked, based on trading activity on Perpl. <0>Read More.</0>"

#: apps/web/src/features/mpoints/components/hero-banner/hero-banner.tsx:186
#~ msgid "Up to $1,000,000 will be unlocked, based on trading activity on Perpl. <0>Read More.</0>"
#~ msgstr "Up to $1,000,000 will be unlocked, based on trading activity on Perpl. <0>Read More.</0>"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:160
msgid "Up to 4 comma or space separated IP addresses or CIDR ranges. Leave empty to allow any IP."
msgstr "Up to 4 comma or space separated IP addresses or CIDR ranges. Leave empty to allow any IP."

#: apps/web/src/features/tournament/components/competition-card.tsx:96
#: apps/web/src/features/tournament/components/countdown-card.tsx:161
msgid "Upcoming"
msgstr "Upcoming"

#. P&L history event fallback label: generic update
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/PositionEventCell.tsx:86
msgid "Update"
msgstr "Update"

#. Edit open order dialog description
#: apps/web/src/features/trading/edit_order_dialog/index.tsx:139
msgid "Update price fields for this open order. Changes are sent immediately."
msgstr "Update price fields for this open order. Changes are sent immediately."

#. Renew disabled reason (no invites used)
#: apps/web/src/features/referral/hooks/useRefCodeRenewal.ts:80
msgid "Use at least one invite before renewing"
msgstr "Use at least one invite before renewing"

#: apps/web/src/features/auth/components/access_request_dialog.tsx:129
msgid "Use the Bridge to deposit some AUSD and get started."
msgstr "Use the Bridge to deposit some AUSD and get started."

#. Used for margining, computing unrealized PNL, and liquidations.
#: packages/ui-kit/src/feature/market_info/coin_info/market_metrics.tsx:113
msgid "Used for margining, computing unrealized PNL, and liquidations."
msgstr "Used for margining, computing unrealized PNL, and liquidations."

#. Dashboard chart: new and cumulative trading accounts
#: apps/web/src/features/dashboard/dashboardLabels.ts:30
msgid "Users"
msgstr "Users"

#. Partner stat label
#. Referral history column header — number of sub-referrals
#. Referrals card label
#: apps/web/src/features/referral/components/partner/partner-stats.tsx:177
#: apps/web/src/features/referral/components/referrals-card/config.ts:50
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:217
msgid "Users Referred"
msgstr "Users Referred"

#. Order form validation fallback
#: packages/ui-kit/src/feature/order_entry/order_schema.ts:22
msgid "Validation failed"
msgstr "Validation failed"

#. Mobile positions sort option
#: packages/ui-kit/src/feature/terminal_tables/position/positions_table.tsx:168
msgid "Value"
msgstr "Value"

#. TP/SL form validation
#: packages/ui-kit/src/feature/terminal_tables/tp_sl_modal/schema.tsx:6
msgid "Value is required"
msgstr "Value is required"

#. Table header tooltip: Notional Value in the P&L history
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:89
msgid "Value of the size this event traded: at the exit price for closes and reductions, at the position entry price for opens and increases."
msgstr "Value of the size this event traded: at the exit price for closes and reductions, at the position entry price for opens and increases."

#. Header nav item. A DeFi product category (a managed strategy users deposit into), not a strongroom or storage locker — most languages either keep "Vaults" or use their own borrowed form. Do not reach for the word meaning "storage room".
#: apps/web/src/components/header/constants.ts:52
msgid "Vaults"
msgstr "Vaults"

#. Add referral code verifying button
#: apps/web/src/features/auth/components/access_request_dialog.tsx:93
#: apps/web/src/features/referral/components/referred-by.tsx:144
msgid "Verifying..."
msgstr "Verifying..."

#. Button label for TP/SL
#: packages/ui-kit/src/feature/terminal_tables/shared/column-builders.tsx:471
msgid "View"
msgstr "View"

#. Referrals card link
#: apps/web/src/features/referral/components/referrals-card/referrals-card.tsx:66
msgid "View all referrals"
msgstr "View all referrals"

#. View wallet on block explorer
#: apps/web/src/components/header/user_account_menu/account_menu_header.tsx:38
msgid "View on explorer"
msgstr "View on explorer"

#: apps/web/src/features/account/components/account_panel.tsx:81
#: apps/web/src/features/account/components/account_panel.tsx:121
msgid "View on Explorer"
msgstr "View on Explorer"

#. Open builder payout transaction in block explorer
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:102
msgid "View payout transaction"
msgstr "View payout transaction"

#: apps/web/src/features/tournament/tournament-detail-page.tsx:183
msgid "View ROI board"
msgstr "View ROI board"

#: apps/web/src/features/tournament/tournament-detail-page.tsx:183
msgid "View Score board"
msgstr "View Score board"

#. Open transfer transaction in block explorer
#: apps/web/src/features/referral/components/referrals-history/rewards-columns.tsx:61
msgid "View transfer transaction"
msgstr "View transfer transaction"

#: apps/web/src/features/tournament/tournament-detail-page.tsx:276
msgid "View Volume board"
msgstr "View Volume board"

#. Header nav item replacing Referrals for partners
#: apps/web/src/components/header/constants.ts:185
msgid "VIP Rewards"
msgstr "VIP Rewards"

#. Market picker card: 24h volume
#: packages/ui-kit/src/feature/market_info/market_menu/market_menu_sheet.tsx:67
msgid "Vol {volume}"
msgstr "Vol {volume}"

#. Builder dashboard stat label
#. Builder payout history column header
#. Builders leaderboard column header
#. Leaderboard column header
#. Market info table volume
#. Tournament leaderboard toggle
#: apps/web/src/features/builders/builderDashboard.tsx:139
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:147
#: apps/web/src/features/builders/components/useBuilderColumns.tsx:67
#: apps/web/src/features/leaderboard/components/ranking/useLeaderboardColumns.tsx:168
#: apps/web/src/features/tournament/components/leaderboard.tsx:99
#: apps/web/src/features/tournament/tournament-detail-page.tsx:293
#: packages/ui-kit/src/feature/market_info/market_menu/market_menu_table.tsx:295
msgid "Volume"
msgstr "Volume"

#: apps/web/src/features/builders/builders.tsx:49
msgid "Volume and fees from orders routed through builder codes - trading terminals, bots, and apps built on Perpl."
msgstr "Volume and fees from orders routed through builder codes - trading terminals, bots, and apps built on Perpl."

#: apps/web/src/features/tournament/components/finalising-dialog.tsx:166
msgid "Volume Competition:"
msgstr "Volume Competition:"

#: apps/web/src/features/tournament/components/leaderboard.tsx:90
msgid "Volume Leaderboard"
msgstr "Volume Leaderboard"

#. Referrals card label
#: apps/web/src/features/referral/components/referrals-card/config.ts:51
msgid "Volume Referred"
msgstr "Volume Referred"

#. Builder dashboard subtitle when the payout share is unknown
#: apps/web/src/features/builders/builderDashboard.tsx:303
msgid "Volume, fees and payouts for your builder code."
msgstr "Volume, fees and payouts for your builder code."

#. Wallet collateral row
#: apps/web/src/components/header/user_account_menu/account_balance_summary.tsx:184
#: apps/web/src/features/account/components/account_panel.tsx:169
msgid "Wallet"
msgstr "Wallet"

#: apps/web/src/features/builders/builders.tsx:59
msgid "Want your integration listed here?"
msgstr "Want your integration listed here?"

#. Preferences: liquidation alerts toggle
#: apps/web/src/components/header/user_settings/preferences-drawer/preferences_drawer.tsx:192
msgid "Warn me when a position is approaching liquidation"
msgstr "Warn me when a position is approaching liquidation"

#: apps/web/src/features/auth/components/access_steps.tsx:102
msgid "We're currently in private beta and onboarding a limited number of users. Your wallet isn't on the list just yet, but we're opening more spots soon. <0>Join the waitlist to get access.</0>"
msgstr "We're currently in private beta and onboarding a limited number of users. Your wallet isn't on the list just yet, but we're opening more spots soon. <0>Join the waitlist to get access.</0>"

#. Alert shown while blockchain indexing lags
#: packages/ui-kit/src/common/heartbeatStore.ts:8
msgid "We're experiencing a temporary delay as blockchain data syncs. Market and account information may not be current, and order placement is paused."
msgstr "We're experiencing a temporary delay as blockchain data syncs. Market and account information may not be current, and order placement is paused."

#. Featured builder link target, used in an accessible label
#: apps/web/src/features/builders/components/FeaturedBuilders.tsx:54
msgid "Website"
msgstr "Website"

#. Snapshot schedule (weekday + time) interpolated into referral texts
#: apps/web/src/features/referral/utils.ts:4
msgid "Wednesday 16:00 UTC"
msgstr "Wednesday 16:00 UTC"

#. Share card week number label
#: apps/web/src/features/mpoints/components/share-points-dialog/points-share-card.tsx:238
msgid "Week"
msgstr "Week"

#. Points history weekly epoch name
#: apps/web/src/features/points/components/points-history-grid/columns.tsx:22
msgid "Week {week}"
msgstr "Week {week}"

#. Share card headline
#: apps/web/src/features/mpoints/components/share-points-dialog/points-share-card.tsx:197
msgid "Weekly mPoints"
msgstr "Weekly mPoints"

#. Share card headline
#: apps/web/src/features/mpoints/components/share-points-dialog/points-share-card.tsx:201
#: apps/web/src/features/points/components/points-history-grid/columns.tsx:114
msgid "Weekly Points"
msgstr "Weekly Points"

#. Edit display name dialog title
#: apps/web/src/features/referral/components/partner/edit-alias-dialog.tsx:48
msgid "What should we call you?"
msgstr "What should we call you?"

#. Portfolio stat label
#: apps/web/src/features/portfolio/components/StatCards.tsx:49
msgid "Win Rate"
msgstr "Win Rate"

#. Button opening the withdraw dialog
#. Button opening the withdraw dialog
#. Keyboard shortcut action
#. Portfolio withdraw button
#. Withdraw action in account menu
#. Withdraw action in fund account menu
#. Withdraw dialog title
#. Withdraw panel submit button
#. Withdraw view title in account menu
#: apps/web/src/components/header/fund_account_menu/index.tsx:97
#: apps/web/src/components/header/mobile_drawer.tsx:238
#: apps/web/src/components/header/user_account_menu/account_balance_summary.tsx:111
#: apps/web/src/components/header/user_account_menu/index.tsx:197
#: apps/web/src/features/account/account_status.tsx:161
#: apps/web/src/features/account/components/withdraw_panel.tsx:104
#: apps/web/src/features/account/withdraw_dialog.tsx:20
#: apps/web/src/features/portfolio/portfolio.tsx:50
#: apps/web/src/features/shortcuts/shortcuts.ts:64
msgid "Withdraw"
msgstr "Withdraw"

#: apps/web/src/features/account/components/withdraw_panel.tsx:110
msgid "Withdraw {tokenSymbol} to Monad. Minimum: {formattedMinWithdraw}."
msgstr "Withdraw {tokenSymbol} to Monad. Minimum: {formattedMinWithdraw}."

#. Account history operation
#. Custom filter: Withdrawal
#: packages/ui-kit/src/feature/terminal_tables/account_history/constants.ts:23
#: packages/ui-kit/src/feature/terminal_tables/account_history/useFilterOptions.tsx:26
msgid "Withdrawal"
msgstr "Withdrawal"

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:167
msgid "Withdrawals are never permitted via an API key, regardless of permissions."
msgstr "Withdrawals are never permitted via an API key, regardless of permissions."

#. Flip dialog: the slippage cap stops the fill short
#: apps/web/src/features/account/flip_position_dialog/FlipPositionDialog.tsx:297
msgid "Within your {capText} slippage limit only about {fillPctText} of this flip would fill. The rest would be cancelled, leaving you <0/>."
msgstr "Within your {capText} slippage limit only about {fillPctText} of this flip would fill. The rest would be cancelled, leaving you <0/>."

#. Wallet on unsupported chain button
#: apps/web/src/components/rainbow/CustomConnectButton.tsx:122
msgid "Wrong network"
msgstr "Wrong network"

#. Chip marking the user's own fee tier
#. Chip marking the user's own fee tier
#. Leaderboard rank cell: badge alt text on the current user row
#. Rewards structure table chip marking the trader’s own tier
#: apps/web/src/components/header/user_account_menu/fees_panel.tsx:78
#: apps/web/src/features/leaderboard/components/ranking/useLeaderboardColumns.tsx:67
#: apps/web/src/features/referral/components/partner/rewards-structure-dialog.tsx:39
#: packages/ui-kit/src/components/dialogs/fee_tiers_dialog.tsx:72
msgid "You"
msgstr "You"

#. Alert body: add collateral tip
#: packages/ui-kit/src/feature/order_entry/form/account_leverage.tsx:202
msgid "You can add collateral to any open position at any time to increase your buffer."
msgstr "You can add collateral to any open position at any time to increase your buffer."

#: apps/web/src/features/account/oneclick_dialog.tsx:70
msgid "You can change this setting later in the Preferences menu."
msgstr "You can change this setting later in the Preferences menu."

#: apps/web/src/features/account/components/deposit_panel.tsx:168
msgid "You can deposit up to {formattedMaxAmount} {tokenSymbol}"
msgstr "You can deposit up to {formattedMaxAmount} {tokenSymbol}"

#. Adjust margin dialog: tooltip summary on the liquidation buffer percentage, side-neutral wording
#: apps/web/src/features/trading/adjust_margin_dialog/MarginInfoRows.tsx:96
msgid "You can survive a {pct}% move before liquidation."
msgstr "You can survive a {pct}% move before liquidation."

#. Add referral code error (self-referral)
#: apps/web/src/features/referral/components/referred-by.tsx:120
msgid "You can't use your own referral code."
msgstr "You can't use your own referral code."

#. API keys page empty state
#: apps/web/src/features/api-keys/api-keys.tsx:105
msgid "You don't have any API keys yet."
msgstr "You don't have any API keys yet."

#: apps/web/src/features/api-keys/components/create-api-key-dialog.tsx:47
msgid "You have reached the maximum number of API keys for this account."
msgstr "You have reached the maximum number of API keys for this account."

#. Builder dashboard state for a connected wallet without a trading account
#: apps/web/src/features/builders/builderDashboard.tsx:219
msgid "You need a trading account to see your builder dashboard and receive payouts. Deposit funds to create one."
msgstr "You need a trading account to see your builder dashboard and receive payouts. Deposit funds to create one."

#. API keys page unauthorized state
#: apps/web/src/features/api-keys/api-keys.tsx:73
msgid "You need to deposit funds to create a trading account before you can create API keys."
msgstr "You need to deposit funds to create a trading account before you can create API keys."

#. Fee tiers dialog callout body
#: packages/ui-kit/src/components/dialogs/fee_tiers_dialog.tsx:182
msgid "You only pay fees to open a trade, not to close it."
msgstr "You only pay fees to open a trade, not to close it."

#: packages/ui-kit/src/components/dialogs/fee_tiers_dialog.tsx:142
#~ msgid "You only pay fees to open a trade, not to close it. <0>See the docs for more</0>."
#~ msgstr "You only pay fees to open a trade, not to close it. <0>See the docs for more</0>."

#. Builder dashboard subtitle; share is the payout share of builder fees
#: apps/web/src/features/builders/builderDashboard.tsx:299
msgid "You receive {share} of the builder fees charged through your code, paid out after each epoch closes."
msgstr "You receive {share} of the builder fees charged through your code, paid out after each epoch closes."

#. Tooltip on Date Joined for expired referee
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:111
msgid "You stopped earning rewards from this user on {date}."
msgstr "You stopped earning rewards from this user on {date}."

#. Referral dashboard card fee-share note
#: apps/web/src/features/referral/components/referrals-card/referrals-card.tsx:166
msgid "You will earn {share} of referees fees."
msgstr "You will earn {share} of referees fees."

#. Tooltip for traders referred referral stat
#: apps/web/src/features/referral/referral.tsx:77
msgid "You will earn rewards from each referee."
msgstr "You will earn rewards from each referee."

#. Tooltip on pending volume pill — explains when fee rewards begin
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:150
msgid "You will start receiving fee rewards once this user has traded >{amount}."
msgstr "You will start receiving fee rewards once this user has traded >{amount}."

#. Tooltip on Date Joined for active/pending referee — when rewards will stop
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:116
msgid "You will stop earning rewards from this user on {date}."
msgstr "You will stop earning rewards from this user on {date}."

#: apps/web/src/features/tournament/components/standing-shared.tsx:155
msgid "You won a prize!"
msgstr "You won a prize!"

#: apps/web/src/features/auth/components/geo_block_dialog.tsx:35
msgid "You're protected"
msgstr "You're protected"

#: apps/web/src/features/account/components/deposit_panel.tsx:167
msgid "You've reached your {formattedMaxEquity} {tokenSymbol} equity limit"
msgstr "You've reached your {formattedMaxEquity} {tokenSymbol} equity limit"

#. Add referral code error (already referred)
#: apps/web/src/features/referral/components/referred-by.tsx:121
msgid "Your account already has a referrer."
msgstr "Your account already has a referrer."

#. Empty state message for account history table
#: packages/ui-kit/src/feature/terminal_tables/account_history/account_history.tsx:38
msgid "Your account history will appear here"
msgstr "Your account history will appear here"

#. Pnl table empty state message
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/pnl_history.tsx:42
msgid "Your closed P&L will appear here"
msgstr "Your closed P&L will appear here"

#. Account panel tooltip: unrealized PnL
#: apps/web/src/features/account/account_status.tsx:71
msgid "Your current profit or loss. Finalized when position closes."
msgstr "Your current profit or loss. Finalized when position closes."

#. Builders page button to the signed-in builder dashboard
#: apps/web/src/features/builders/builders.tsx:41
msgid "Your Dashboard"
msgstr "Your Dashboard"

#. Funding history table empty state message
#: packages/ui-kit/src/feature/terminal_tables/close_pnl/funding_events.tsx:5
msgid "Your funding payments will appear here"
msgstr "Your funding payments will appear here"

#. Market making table empty state
#: packages/ui-kit/src/feature/terminal_tables/market_making/market_making.tsx:170
msgid "Your market making stats will appear here"
msgstr "Your market making stats will appear here"

#. mPoints panel headline
#: apps/web/src/components/header/rewards_menu/panels.tsx:166
#: apps/web/src/features/mpoints/components/stat-cards/m-points-card.tsx:53
msgid "Your mPoints"
msgstr "Your mPoints"

#. Label when the hovered order-book level has the user limit order
#: packages/ui-kit/src/feature/order_book/hover_popover/hover_popover.tsx:125
msgid "Your order"
msgstr "Your order"

#. Empty message for order history table
#: packages/ui-kit/src/feature/terminal_tables/order_history/order_history.tsx:50
msgid "Your order history will appear here"
msgstr "Your order history will appear here"

#. Offscreen user orders popover header
#: packages/ui-kit/src/feature/order_book/hover_popover/hover_popover.tsx:183
msgid "Your orders"
msgstr "Your orders"

#. Empty message for open order table
#: packages/ui-kit/src/feature/terminal_tables/open_orders/open_orders.tsx:199
msgid "Your orders will appear here"
msgstr "Your orders will appear here"

#: apps/web/src/features/points/components/og-badge-dialog/og-badge-dialog.tsx:130
msgid "Your Origin Badge shows you were one of the first traders on Perpl."
msgstr "Your Origin Badge shows you were one of the first traders on Perpl."

#. Builder payout history empty state
#: apps/web/src/features/builders/components/BuilderPayoutHistory.tsx:239
msgid "Your payout history will appear here."
msgstr "Your payout history will appear here."

#. Points panel headline
#: apps/web/src/components/header/rewards_menu/panels.tsx:215
msgid "Your Points"
msgstr "Your Points"

#. Empty message for position table
#: packages/ui-kit/src/feature/terminal_tables/position/positions_table.tsx:205
msgid "Your positions will appear here"
msgstr "Your positions will appear here"

#: apps/web/src/features/mpoints/components/stat-cards/m-points-card.tsx:71
msgid "Your projected earnings"
msgstr "Your projected earnings"

#: apps/web/src/features/tournament/components/finalising-dialog.tsx:156
msgid "Your provisional ranks are:"
msgstr "Your provisional ranks are:"

#. Leaderboard panel headline
#: apps/web/src/components/header/rewards_menu/panels.tsx:307
msgid "Your rank"
msgstr "Your rank"

#. Referees tab label
#: apps/web/src/features/referral/components/referrals-history/referrals-history.tsx:35
msgid "Your Referees"
msgstr "Your Referees"

#. Empty referees list message
#: apps/web/src/features/referral/components/referrals-history/referees-grid.tsx:78
msgid "Your referees will appear here"
msgstr "Your referees will appear here"

#. Referral history card title
#: apps/web/src/features/referral/components/referrals-history/referrals-history.tsx:34
msgid "Your Referral History"
msgstr "Your Referral History"

#. Referral history column header
#: apps/web/src/features/referral/components/referrals-history/columns.tsx:271
msgid "Your Rewards"
msgstr "Your Rewards"

#. Rewards history tab label
#: apps/web/src/features/referral/components/referrals-history/referrals-history.tsx:36
msgid "Your Rewards History"
msgstr "Your Rewards History"

#. Empty rewards history message
#: apps/web/src/features/referral/components/referrals-history/rewards-grid.tsx:94
msgid "Your rewards history will appear here"
msgstr "Your rewards history will appear here"

#. Referral stat label
#: apps/web/src/features/referral/referral.tsx:74
msgid "Your Rewards this Week"
msgstr "Your Rewards this Week"

#: apps/web/src/features/tournament/tournament-detail-page.tsx:182
msgid "Your ROI Standing"
msgstr "Your ROI Standing"

#: apps/web/src/features/tournament/tournament-detail-page.tsx:182
msgid "Your Score Standing"
msgstr "Your Score Standing"

#. Rewards structure dialog footnote explaining when the tier is snapshotted
#: apps/web/src/features/referral/components/partner/rewards-structure-dialog.tsx:125
msgid "Your tier is calculated at the end of each epoch, then locked for the next epoch."
msgstr "Your tier is calculated at the end of each epoch, then locked for the next epoch."

#: apps/web/src/features/mpoints/components/stat-cards/m-points-card.tsx:70
msgid "Your total mPoints"
msgstr "Your total mPoints"

#: apps/web/src/features/points/components/total-points-card.tsx:30
msgid "Your Total Points"
msgstr "Your Total Points"

#. Empty state message for trade history table
#: packages/ui-kit/src/feature/terminal_tables/trade_history/trade_history.tsx:48
msgid "Your trade history will appear here"
msgstr "Your trade history will appear here"

#: apps/web/src/features/tournament/tournament-detail-page.tsx:274
msgid "Your Volume Standing"
msgstr "Your Volume Standing"
